import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService } from '../app.service';
import { messageService } from '../message.service';
import { PaginationService } from '../PaginationService';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { SuccessSnackbarComponent } from '../support/success-snackbar/success-snackbar.component';
import { MatMenuTrigger } from '@angular/material/menu';
import { DatepickerDateCustomClasses } from 'ngx-bootstrap/datepicker';
import { MatRadioChange } from '@angular/material/radio';
import { DatePipe } from '@angular/common';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';
import { StaticAuditTrailComponent } from '../support/static-audit-trail/static-audit-trail.component';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { HomepagetagComponent } from 'src/app/homepagetag/homepagetag.component';
import { firstValueFrom } from 'rxjs';
import { DynamicGridClauses, DynamicGridConfig, DynamicGridReport, DynamicGridSettings, DynamicGridTrail } from '../support/models/dynamic-grid.model';
import { DocumentViewerComponent } from '../support/document-viewer/document-viewer.component';
import { DocViewerConfig } from '../support/models/doc-viewer-config.model';
import { EditorComponent } from '../editor/editor.component';
@Component({
  selector: 'app-dms-sub-folder',
  templateUrl: './dms-sub-folder.component.html',
  styleUrls: ['./dms-sub-folder.component.scss']
})
export class DmsSubFolderComponent implements OnInit {
  isProcessing = false;
  folderDocListForDataGrid: any = [];
  folderData: any = {};
  searchValue: any;
  searchValue1: any;
  searchValue2: any;
  searchValue3: any;
  title: any = "";
  documentWatermark: any;
  documentNameForDownload: any;
  cascaseToChild: boolean = false;
  latestOnTop: boolean = false;
  parentFolderId: any;
  visibleEditButton: boolean = false;
  visibleAddButton: boolean = false;
  dropDownFordocumentTypeList: any = [];
  documentTypeDropdown: any = [];
  selectedDocumentType: any = [];
  selectedDocumentTypeValue: any = "";
  isShowAddFolderButton = false;
  operationFlag = "";
  folderNameToDisplay: any;
  isShowAddDocumentButton: boolean = false;
  isShowMapFolderButton = false;
  documentBreadcrumbList: any = [];
  parentFolderData: any = {};
  documentAddOption: any = null;
  dateCustomClasses: DatepickerDateCustomClasses[];
  visibleInfoPopup: MatDialogRef<any> | null = null;
  isRightClickAdd: boolean = false;
  visibleWarningPopup: MatDialogRef<any> | null = null;
  buttonText = "";
  isShowBulkCheckInButton: boolean = false;
  isShowBulkPublishButton: boolean = false;

  gridConfig: DynamicGridConfig = {} as any;
  gridClause: DynamicGridClauses = {};
  gridTrail: DynamicGridTrail = {} as any;
  gridReport: DynamicGridReport = {} as any;
  gridSettings: DynamicGridSettings = {} as any;
  selectedVersionValue: any;
  versionValueDropdown1: any = {};
  versionValueDropdown: any = [];
  versionSearchText: string = ''; // In DmsSubFolderComponent.ts
  isPrintDownloadMode: boolean = false;
  bulkDocTypeSearchText: string = '';
  isShowBulkSelfLockButton: boolean = false;
  htmlContent: any;
  @ViewChild(DocumentViewerComponent) documentViewerComponent!: DocumentViewerComponent;
  docViewer!: DocViewerConfig;

  dateFormat: any = this.message.organizationDetails?.dateFormat ? 'DD-MMM-YYYY' : this.message.organizationDetails?.dateFormat;
  datePickerConfiguration = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    todayPosition: 'center'
  }

  effectiveDateConfig = {
    dateInputFormat: this.dateFormat,
    showWeekNumbers: false,
    containerClass: 'theme-dark-blue',
    showTodayButton: false,
    disableClose: true,
    todayPosition: 'center'
  }
  documentIssuanceType: any = [];

  documentIssuanceIncludeType: any;
  typeDmsDocumentsVw: { documentId: any; version: any; };
  issuanceReason: any;
  issuanceTo: any;
  issuanceCopy: any;
  bulkEffectiveDate: any = null;
  bulkExpirationDate: any = null;
  bulkSelectedDocType: any = null;
  isBulkExpApplicable: boolean = true;
  isBulkEffEditable: boolean = true;
  isBulkExpEditable: boolean = true;
  bulkValidDocumentListMaster: any[] = [];
  bulkDocumentTypeDropdown: any[] = [];
  typeDmsDocumentsVwaterMark: { documentId: any; version: any; printParentDetails: string; documentTypeCode: any; issuanceReason: any; issuanceTo: any; noOfCopy: any; };
  incudeCoverPgae: any;
  incudeCoverPgaeTitle: any;
  incudeRevisionhistory: any;
  incudeRevisionhistoryTitle: any;
  incudeFooter: any;
  incudeFooterTitle: any;
  incudeAmendmentTitle: any;
  incudeAmendment: any;
  incudeApproval: any;
  incudeApprovalTitle: any;
  isOnlyPreviewMode: boolean = false;
  bulkActionType: string = '';
  bulkReason: string = '';
  bulkDocumentList: any[] = [];
  bulkParentCheckbox: boolean = false;
  bulkActionResults: any[] = [];
  documentTypeSearchText: string = '';
  groupsSearchText: string = '';
  crGroupsSearchText: string = '';
  placeholderSearchText: string = '';
  issuanceTypeSearchText: string = '';
  docTypeForDocSearchText: string = '';
  designationSearchText: string = '';
  departmentSearchText: string = '';
  documentSearchText: string = '';
  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  selectedIssuanceValue: any;
  onLastPage: boolean;
  incudePageNo: any;
  publisherDetails: any;
  linkedDocuments: any;
  incudeNotes: any;
  incudeNotesTitle: any;
  watermarkColor: any;
  documentIssuanceSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.selectedIssuanceValue = item.valueExp;
        for (let i = 0; i < this.listOfDmsIssuanceTypes.length; i++) {
          if (this.listOfDmsIssuanceTypes[i].codelistName == this.selectedIssuanceValue) {
            this.watermarkColor = this.listOfDmsIssuanceTypes[i].subgroupValues;
          }
        }
        this.callWatermark();
      }
    }
  }

  callWatermark() {
    this.typeDmsDocumentsVwaterMark = {
      documentId: this.rightClickData.documentId,
      version: this.rightClickData.version,
      printParentDetails: "Y",
      documentTypeCode: this.selectedIssuanceValue,
      issuanceReason: this.issuanceReason,
      issuanceTo: this.issuanceTo,
      noOfCopy: this.issuanceCopy

    };
    this.documentIssuanceIncludeType = this.selectedIssuanceValue;
    this.appService.getDocumentWatermark(this.typeDmsDocumentsVwaterMark).subscribe((response: any) => {
      this.isProcessing = false;
      this.documentWatermark = response.result;
    })
    this.appService.getDocumentNameForDownload(this.typeDmsDocumentsVwaterMark).subscribe((response: any) => {
      this.isProcessing = false;
      this.documentNameForDownload = response.documentName;
    })
  }

  // todayDate: Date = new Date();


  onEffectiveDateClick() {
    // Reset the effective date to today when clicked
    this.placeholderData.effectiveDate = new Date();  // Forces picker to show today
  }




  documentIssuanceSelectOld(item: any) {
    this.selectedIssuanceValue = item.valueExp;
    this.typeDmsDocumentsVwaterMark = {
      documentId: this.rightClickData.documentId,
      version: this.rightClickData.version,
      printParentDetails: "Y",
      documentTypeCode: item.valueExp,
      issuanceReason: this.issuanceReason,
      issuanceTo: this.issuanceTo,
      noOfCopy: this.issuanceCopy

    };
    this.documentIssuanceIncludeType = item.valueExp;
    this.appService.getDocumentWatermark(this.typeDmsDocumentsVwaterMark).subscribe((responsedata: any) => {
      this.isProcessing = false;
      this.documentWatermark = responsedata.result;
    })
    this.appService.getDocumentNameForDownload(this.typeDmsDocumentsVwaterMark).subscribe((response: any) => {
      this.isProcessing = false;
      this.documentNameForDownload = response.documentName;
    })


  }
  todayDate = new Date();
  substitueWaterMsg() {
    this.callWatermark();

  }


  isShowOnLatestTopDisabled = false;
  toggleChanged(event: any) {
    if (event.checked == true) {
      this.isShowOnLatestTopDisabled = true;
      this.onLastPage = true;
    } else {
      this.isShowOnLatestTopDisabled = false;
    }

  }

  onApprovalToggleChanged(event: any) {
    if (event.checked == true) {
      this.onLastPage = true;
    }
  }

  dropDownForSearchValue: any = [{
    displayExp: "Document No.",
    valueExp: "documentNo"
  }, {
    displayExp: "Document Name",
    valueExp: "documentName"
  }]
  isShowSearchedGrid: any = false;
  documentTypeDropdownForPlaceholder: any = [];
  documentAddOptions: any = ['Add Manually', 'Add From Template', 'Add PlaceHolder']
  documentIssuanceTypeDropdown: any = [];
  documentIssuanceTypeList: any = [];
  today: Date;
  navigationName: any = '';
  constructor(public dialog: MatDialog, private appService: AppService, public router: Router, public snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, public route: ActivatedRoute, public datePipe: DatePipe) {
    this.route.params.subscribe(
      params => {

        this.navigationName = params['name'];
        if (this.navigationName == "Search") {
          this.isShowSearchedGrid = false;
          this.isShowAddFolderButton = false;
          this.isShowAddDocumentButton = false;
          this.isShowMapFolderButton = false;
          this.isShowBulkCheckInButton = false;
          this.isShowBulkPublishButton = false;
          this.isShowBulkSelfLockButton = false;
          this.folderDocListForDataGrid = [];
          this.documentBreadcrumbList = ["Documents", "Search"];

          this.selectedSearchValue = "documentNo";
          this.isProcessing = true;
          this.dropDownFordocumentTypeList = [];
          this.appService.getDocumentTypeBasedOnModule("DOCS")
            .subscribe((data: any) => {
              this.dropDownFordocumentTypeList = data;
              this.isProcessing = false;
              this.documentTypeDropdown = [];
              for (let i = 0; i < this.dropDownFordocumentTypeList.length; i++) {
                this.documentTypeDropdown = this.documentTypeDropdown.concat({
                  valueExp: this.dropDownFordocumentTypeList[i].documentTypeCode,
                  displayExp: this.dropDownFordocumentTypeList[i].documentTypeName
                });
              }

            })
        } else {
          this.isShowSearchedGrid = true;
          this.parentFolderId = this.appService.getParentFolderId();
          this.documentBreadcrumbList = this.appService.getDocumentBreadcrumbList();


          this.appService.getDmsFolderDataById(this.parentFolderId)
            .subscribe((data: any) => {
              this.parentFolderData = data[0];
              this.folderNameToDisplay = this.parentFolderData.folderName;
              this.appService.getDocumentPrivUser(this.parentFolderId).subscribe((data: any) => {
                if (data.length > 0) {
                  if (data[0].author == "Y" || data[0].allusrAuthor == "Y" || data[0].rmAuthor == "Y") {
                    this.isShowAddDocumentButton = true;
                    this.isShowBulkCheckInButton = true;
                    this.isShowMapFolderButton = false;
                  } else {
                    this.isShowAddDocumentButton = false;
                    this.isShowBulkCheckInButton = false;
                    this.isShowBulkSelfLockButton = false;
                  }
                  if (data[0].publisher == "Y" || data[0].allusrPublisher == "Y" || data[0].rmPublisher == "Y") {
                    this.isShowBulkSelfLockButton = true;
                    this.isShowBulkPublishButton = true;
                  } else {
                    this.isShowBulkPublishButton = false;
                    this.isShowBulkSelfLockButton = false;
                  }
                } else {
                  this.isShowAddDocumentButton = false;
                  this.isShowBulkCheckInButton = false;
                }
                if (this.parentFolderData.isDistributedFolder == "Y") {
                  this.isShowAddDocumentButton = false;
                  this.isShowBulkCheckInButton = false;
                  this.isShowBulkSelfLockButton = false;
                  this.isShowBulkPublishButton = false;
                  this.isShowMapFolderButton = true;
                }
              })
              this.isProcessing = true;
              this.dropDownFordocumentTypeList = [];
              this.appService.getDocumentTypeBasedOnModule("DOCS")
                .subscribe((data: any) => {
                  this.dropDownFordocumentTypeList = data;
                  this.isProcessing = false;
                  this.documentTypeDropdown = [];
                  for (let i = 0; i < this.dropDownFordocumentTypeList.length; i++) {
                    this.documentTypeDropdown = this.documentTypeDropdown.concat({
                      valueExp: this.dropDownFordocumentTypeList[i].documentTypeCode,
                      displayExp: this.dropDownFordocumentTypeList[i].documentTypeName
                    });
                  }
                  if (this.parentFolderData.documentTypeCode != null) {
                    this.documentTypeDropdownForPlaceholder = [];
                    let docTypes = this.parentFolderData.documentTypeCode.split(",");
                    for (let j = 0; j < docTypes.length; j++) {
                      for (let i = 0; i < this.dropDownFordocumentTypeList.length; i++) {
                        if (docTypes[j] == this.dropDownFordocumentTypeList[i].documentTypeCode) {
                          this.documentTypeDropdownForPlaceholder = this.documentTypeDropdownForPlaceholder.concat({
                            valueExp: this.dropDownFordocumentTypeList[i].documentTypeCode,
                            displayExp: this.dropDownFordocumentTypeList[i].documentTypeName
                          });
                        }
                      }
                    }
                  } else {
                    this.documentTypeDropdownForPlaceholder = [];
                    for (let i = 0; i < this.dropDownFordocumentTypeList.length; i++) {
                      this.documentTypeDropdownForPlaceholder = this.documentTypeDropdownForPlaceholder.concat({
                        valueExp: this.dropDownFordocumentTypeList[i].documentTypeCode,
                        displayExp: this.dropDownFordocumentTypeList[i].documentTypeName
                      });
                    }
                  }
                })
            })
          this.getCall();
          this.appService.getSubFolderPrivUser(this.parentFolderId).subscribe((data: any) => {
            if (data > 0) {
              this.isShowAddFolderButton = true;
            } else {
              this.isShowAddFolderButton = false;
            }
          })
          this.appService.getDmsFolderDataById(this.parentFolderId)
            .subscribe((data: any) => {
              this.folderData = data[0];
              if (this.folderData.allowToInputVersionManually == "Y") {
                this.isVersionManually = true;
              } else {
                this.isVersionManually = false;
              }
              if (this.folderData.allowToInputDocumentNoManually == "Y") {
                this.isDocumentNoManually = true;
              } else {
                this.isDocumentNoManually = false;
              }
            })
        }



      }
    );
    const now = new Date();
    this.today = new Date();
    this.dateCustomClasses = [{ date: now, classes: ['bg-warning'] }];


  }

  backToFolderWise() {
    this.documentBreadcrumbList.pop();
    this.appService.setDocumentBreadcrumbList(this.documentBreadcrumbList);
    this.appService.setParentFolderId(this.parentFolderData.parentFolderId);
    if (this.parentFolderData.parentFolderId == 0) {
      this.router.navigate(['/dashboard/rootFolder']);
    } else {
      this.router.navigate(['/dashboard/subFolder', this.documentBreadcrumbList[this.documentBreadcrumbList.length - 1] + "?v=" + Math.random()]);
    }
  }

  @ViewChild('addAndEditPopup', { static: true }) addAndEditPopup: TemplateRef<any>;
  @ViewChild('addAndEditPlaceholderPopup', { static: true }) addAndEditPlaceholderPopup: TemplateRef<any>;
  @ViewChild('deletePopup', { static: true }) deletePopup: TemplateRef<any>;
  @ViewChild('searchDocument', { static: true }) searchDocument: TemplateRef<any>;
  @ViewChild('extensionPopup', { static: true }) extensionPopup: TemplateRef<any>;
  @ViewChild('mapFolderPopup', { static: true }) mapFolderPopup: TemplateRef<any>;
  @ViewChild('addDocumentForDocType', { static: true }) addDocumentForDocType: TemplateRef<any>;
  @ViewChild('templatePopup', { static: true }) templatePopup: TemplateRef<any>;
  @ViewChild('addUserGroupPopup', { static: true }) addUserGroupPopup: TemplateRef<any>;
  visibleConfirmWithReason: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmWithReasonPopup', { static: true }) confirmWithReasonPopup: TemplateRef<any>;
  @ViewChild('issuanceHistoryPopup', { static: true }) issuanceHistoryPopup: TemplateRef<any>;
  @ViewChild('documentHistoryPopup', { static: true }) documentHistoryPopup: TemplateRef<any>;
  @ViewChild('redactPopup', { static: true }) redactPopup: TemplateRef<any>;
  @ViewChild('redactConfirmationPopup', { static: true }) redactConfirmationPopup: TemplateRef<any>;
  @ViewChild('documentPropertiesPopup', { static: true }) documentPropertiesPopup: TemplateRef<any>;
  @ViewChild('moveDocumentPopup', { static: true }) moveDocumentPopup: TemplateRef<any>;
  @ViewChild('warningPopupTemplate', { static: true }) warningPopupTemplate: TemplateRef<any>;
  @ViewChild('viewRelatedTrainingsPopup', { static: true }) viewRelatedTrainingsPopup: TemplateRef<any>;
  @ViewChild('bulkActionPopupTemplate', { static: true }) bulkActionPopupTemplate: TemplateRef<any>;
  @ViewChild('bulkResultPopupTemplate', { static: true }) bulkResultPopupTemplate: TemplateRef<any>;
  visibleBulkResultPopup: MatDialogRef<TemplateRef<any>> | null = null;
  visibleBulkActionPopup: MatDialogRef<TemplateRef<any>> | null = null;
  visibleViewRelatedTrainingsPopup: MatDialogRef<TemplateRef<any>>;
  visibleAddAndEditPopup: MatDialogRef<TemplateRef<any>>;
  visibleAddAndEditPlaceholderPopup: MatDialogRef<TemplateRef<any>>;
  visibleDeletePopup: MatDialogRef<TemplateRef<any>>;
  visibleSearchDocumentPopup: MatDialogRef<TemplateRef<any>>;
  visibleSExtensionPopup: MatDialogRef<TemplateRef<any>>;
  visibleMapFolderPopup: MatDialogRef<TemplateRef<any>>;
  visibleSDownloadPopup: MatDialogRef<TemplateRef<any>>;
  visibleAddDocForDocumentTypePopup: MatDialogRef<TemplateRef<any>>;
  visibleTemplatePopup: MatDialogRef<TemplateRef<any>>;
  visibleAddUserGroupPopup: MatDialogRef<TemplateRef<any>>;
  visibleConfirm: MatDialogRef<TemplateRef<any>>;
  visibleIssuanceHistPopup: MatDialogRef<TemplateRef<any>>;
  visibleDocumentHistPopup: MatDialogRef<TemplateRef<any>>;
  visibleRedactPopup: MatDialogRef<TemplateRef<any>>;
  visibleRedactConfirmationPopup: MatDialogRef<TemplateRef<any>>;
  visibleDocumentPropertiesPopup: MatDialogRef<TemplateRef<any>>;
  visibleMoveDocumentPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('confirmPopup', { static: true }) confirmPopup: TemplateRef<any>;

  visiblePropertiesPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('propertiesPopup', { static: true }) propertiesPopup: TemplateRef<any>;
  visibleSavedReportPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('savedReportPopup', { static: true }) savedReportPopup: TemplateRef<any>;
  @ViewChild('downloadPopup', { static: true }) downloadPopup: TemplateRef<any>;

  visibleDownloadTemplatePopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('downloadTemplatePopup', { static: true }) downloadTemplatePopup: TemplateRef<any>;

  downloadTemplatePopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  viewRelatedTrainingsPopupConfig = {
    width: '1200px',
    minHeight: '300px',
    maxHeight: '80vh',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  propertiesPopupConfig = {
    width: '1200px',
    minHeight: '300px',
    maxHeight: '70vh',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  moveDocumentPopupConfig = {
    width: '900px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };


  documentPropertiesPopupConfig = {
    width: '1200px',
    minHeight: '300px',
    maxHeight: '70vh',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  issuanceHistoryPopupConfig = {
    width: '1200px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };
  documentHistoryPopupConfig = {
    width: '1200px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };
  redactPopupConfig = {
    width: '1000px',
    height: 'auto',
    minHeight: '400px',
    maxHeight: '90vh',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  redactConfirmationPopupConfig = {
    width: '1200px',
    height: 'auto',
    minHeight: '400px',
    maxHeight: '90vh',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  confirmWithReasonPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  templatePopupConfig = {
    width: '60%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };
  savedReportPopupConfig = {
    width: '800px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  addUserGroupPopupConfig = {
    width: '60%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  propertiesdownloadPopupConfig = {
    width: '1200px',
    minHeight: '300px',
    maxHeight: '90vh',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };

  addDocForDocTypePopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '10px' },
  };



  confirmPopupConfig = {
    width: '500px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  extensionPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  mapFolderPopupConfig = {
    width: '80%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  addAndEditPopupConfig = {
    width: '800px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  searchDocumentConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  addAndEditPlaceholderPopupConfig = {
    width: '1000px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '60px' },
  };

  deletePopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
  };

  multiSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: true,
    allowSearchFilter: true,
    singleSelection: false,
    itemsShowLimit: 4,
  };

  viewableExtensionsList: any = [];
  dropDownForDesignationCode: any = [];
  dropDownForDepartmentCode: any = [];
  designationCodeDropdown: any = [];
  departmentCodeDropdown: any = [];
  userGroupsList: any = [];
  userGroupsDropdown: any = [];
  selectedUserGroups: any = null;
  isVersionManually = false;
  uiDateFormat: any = 'dd-MMM-yyyy';
  uiDateTimeFormat: any = 'dd-MMM-yyyy HH:mm:ss'
  settingsObj: any = {};
  isDocumentNoManually = false;
  listOfDmsIssuanceTypes: any = [];
  ngOnInit(): void {
    let obj = JSON.parse(sessionStorage.getItem('getUserTimezoneDetails') || '{}');
    if (obj.uiDateFormat != undefined && obj.uiDateFormat != null) {
      this.uiDateFormat = obj.uiDateFormat.replace("DD", 'dd').replace("MON", "MMM").replace("YYYY", "yyyy");

    }
    if (obj.uiDateIMEFormat != undefined && obj.uiDateIMEFormat != null) {
      this.uiDateTimeFormat = obj.uiDateIMEFormat.replace("DD", 'dd').replace("HH24:MI:SS", 'HH:mm:ss').replace("MON", "MMM").replace("YYYY", "yyyy");
    }
    this.wvDocumentLoadedHandler = this.wvDocumentLoadedHandler.bind(this);
    this.dropDownForDesignationCode = JSON.parse(sessionStorage.getItem('dropDownForDesignationCode') || '{}');
    this.dropDownForDepartmentCode = JSON.parse(sessionStorage.getItem('dropDownForDepartmentCode') || '{}');
    this.selectBoxeForDesignationCode();
    this.selectBoxeForDepartmentCode();
    this.appService.getDmsSettingVw().subscribe((data: any) => {
      this.settingsObj = data;
      if (data.viewableFileExtns != null) {
        this.viewableExtensionsList = data.viewableFileExtns.split(",");
      }
      if (data.allowedFileExtns != null) {
        this.allowedFileExtns = null;
        let extns = data.allowedFileExtns.split(",");
        for (let i = 0; i < extns.length; i++) {
          this.allowedFileExtns = this.allowedFileExtns == null ? "." + extns[i].toLowerCase() : this.allowedFileExtns + "," + "." + extns[i].toLowerCase();
        }
      }

    })
    this.appService.getCodeListsByGroup("DOCUMENT_ISSUANCE_TYPE").subscribe((data: any) => {
      this.listOfDmsIssuanceTypes = data;

    })

    this.appService.getDmsGroupsVwDetails().subscribe(
      (data: any) => {
        this.userGroupsList = data || [];
        this.isProcessing = false;

        this.userGroupsDropdown = this.userGroupsList
          .filter((group: any) => group.isActive === 'Y')
          .map((group: any) => ({
            valueExp: group.groupId,
            displayExp: group.groupName ? group.groupName.trim() : ''
          }))
          .sort((a: any, b: any) => a.displayExp.localeCompare(b.displayExp));
      },
      (error) => {
        console.error("Error fetching groups:", error);
        this.isProcessing = false;
        this.userGroupsDropdown = [];
      }
    );
  }



  wvDocumentLoadedHandler(): void {
    // const { documentViewer, annotationManager, Annotations } = this.wvInstance.Core;
  }

  selectBoxeForDesignationCode() {
    for (let i = 0; i < this.dropDownForDesignationCode.length; i++) {
      this.designationCodeDropdown = this.designationCodeDropdown.concat({
        valueExp: this.dropDownForDesignationCode[i].codelistCode,
        displayExp: this.dropDownForDesignationCode[i].codelistName
      });
    }
  }

  selectBoxeForDepartmentCode() {
    for (let i = 0; i < this.dropDownForDepartmentCode.length; i++) {
      this.departmentCodeDropdown = this.departmentCodeDropdown.concat({
        valueExp: this.dropDownForDepartmentCode[i].codelistCode,
        displayExp: this.dropDownForDepartmentCode[i].codelistName
      });
    }
  }

  refreshFunc() {
    this.getCall();
  }

  resetDocSearch() {
    this.docIdOrName = null;
    this.folderDocListForDataGrid = [];
    this.collectionSize = 0;
    this.pager.totalPages = undefined;
    this.setPage(1, 0);
  }
  docIdOrName: any = "";
  searchedDocumentsList: any = [];
  selectedSearchValue: any = null;
  searchDocuments() {
    this.searchedDocumentsList = [];
    let data: any = {};
    if (this.selectedSearchValue == "documentNo") {
      data['documentNo'] = this.docIdOrName;
      data['documentName'] = "undefined"
    } else {
      data['documentNo'] = "undefined";
      data['documentName'] = this.docIdOrName;
    }
    this.folderDocListForDataGrid = [];
    this.isProcessing = true;
    this.appService.searchDocumentsBasedOnCondition(data).subscribe((data: any) => {
      this.isShowSearchedGrid = true;
      this.isProcessing = false;
      this.searchedDocumentsList = data;
      for (let i = 0; i < data.length; i++) {
        if (data[i].documentSizeInKb > 1000000) {
          data[i].documentSizeInKb = (data[i].documentSizeInKb / 1000000).toFixed(2) + " GB"
        } else if (data[i].documentSizeInKb < 1000000 && data[i].documentSizeInKb > 1000) {
          data[i].documentSizeInKb = (data[i].documentSizeInKb / 1000).toFixed(2) + " MB"
        } else {
          data[i].documentSizeInKb = data[i].documentSizeInKb + " KB"
        }
        data[i].type = "Document";
        data[i].isExpired = false;
        this.folderDocListForDataGrid.push(data[i]);
        if (data[i].expirationDate != null) {
          if (new Date(data[i].expirationDate) < this.today) {
            data[i].expired = true;
          }
        }
      }
      this.collectionSize = this.folderDocListForDataGrid.length;
      this.pager.totalPages = undefined;
      this.setPage(1, 0);

    })

  }

  getCall() {
    this.folderDocListForDataGrid = [];
    this.isProcessing = true;
    this.appService.getDmsFolderList(this.parentFolderId).subscribe((data: any) => {
      for (let i = 0; i < data.length; i++) {
        data[i].type = "Folder";
        this.folderDocListForDataGrid.push(data[i]);
      }
      this.appService.getDmsDocumentsList(this.parentFolderId).subscribe((data: any) => {
        this.isProcessing = false;
        for (let i = 0; i < data.length; i++) {
          if (data[i].documentSizeInKb > 1000000) {
            data[i].documentSizeInKb = (data[i].documentSizeInKb / 1000000).toFixed(2) + " GB"
          } else if (data[i].documentSizeInKb < 1000000 && data[i].documentSizeInKb > 1000) {
            data[i].documentSizeInKb = (data[i].documentSizeInKb / 1000).toFixed(2) + " MB"
          } else {
            data[i].documentSizeInKb = data[i].documentSizeInKb + " KB"
          }
          data[i].type = "Document";
          data[i].isExpired = false;
          this.folderDocListForDataGrid.push(data[i]);
          if (data[i].expirationDate != null) {
            if (new Date(data[i].expirationDate) < this.today) {
              data[i].expired = true;
            }
          }
        }
        this.collectionSize = this.folderDocListForDataGrid.length;
        this.pager.totalPages = undefined;
        this.setPage(1, 0);
      }, (error) => {
        this.isProcessing = false;
      });
    }, (error) => {
      this.isProcessing = false;
    });
  }

  itemsPerPage = 5; // Number of items to display per page
  currentPage = 1; // Current page number
  totalPages = 0; // Total number of pages

  maxSize = 3;
  collectionSize: number;
  perPage = 10;
  perPage3 = 10;
  calculateTotalPages: number;

  showingResultsText = "Showing results";
  displayingClaimsText = "Displaying claims";
  rowText = "Rows";
  showingRowsText = "Showing rows";
  private users: any[];
  pager: any = {};
  pager3: any = {};
  pagedItems: any[];
  pagedItems2: any[];
  pagedItems3: any[];
  pagedItemForSavedReport: any = [];
  error = '';
  setPage(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.folderDocListForDataGrid.length, page, this.perPage, targetpage);
    this.pagedItems = this.folderDocListForDataGrid.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall(value: number) {
    this.perPage = value;
    this.setPage(this.pager.currentPage, 0);
  }

  setPagedorserch(page: number, targetpage: number) {

    if (Number.isNaN(page)) {
      page = 1;
    }

    if (this.folderListForDataGridTemp.length > 0) {
      this.pager = this.paginationService.getPager(this.folderListForDataGridTemp.length, page, this.perPage, targetpage);
      this.pagedItems = this.folderListForDataGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItems = [];
    }
  }

  folderListForDataGridTemp: any = [];
  applyFilter2(event: Event) {
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();
    if (filter === '') {
      this.folderListForDataGridTemp = this.folderDocListForDataGrid;
      this.collectionSize = this.folderListForDataGridTemp.length;
      this.pager = this.paginationService.getPager(this.folderListForDataGridTemp.length, 1, this.perPage, 0);
      this.pagedItems = this.folderListForDataGridTemp.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {

      if (this.folderDocListForDataGrid == undefined) {
        return this.folderDocListForDataGrid;
      }
      if (!this.folderDocListForDataGrid.length) {
        return this.folderDocListForDataGrid;
      }
      if (filter != undefined) {
        this.folderListForDataGridTemp = this.folderDocListForDataGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase().includes(filter);
        });

      } else {
        this.folderListForDataGridTemp = this.folderDocListForDataGrid.filter(function (item: any) {
          return JSON.stringify(item).toLowerCase();
        });


      }
      this.collectionSize = this.folderListForDataGridTemp.length;
      this.setPagedorserch(1, 0);
    }
  }

  templateList: any = [];
  setPage2(page: number, targetpage: number) {
    if (page < 1 || page > this.pager.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager = this.paginationService.getPager(this.templateList.length, page, this.perPage, targetpage);
    this.pagedItems2 = this.templateList.slice(this.pager.startIndex, this.pager.endIndex + 1);
  }

  paginationCall2(value: number) {
    this.perPage = value;
    this.setPage2(this.pager.currentPage, 0);
  }

  dmsGroupsList: any = [];
  setPage3(page: number, targetpage: number) {
    if (page < 1 || page > this.pager3.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pager3 = this.paginationService.getPager(this.dmsGroupsList.length, page, this.perPage3, targetpage);
    this.pagedItems3 = this.dmsGroupsList.slice(this.pager3.startIndex, this.pager3.endIndex + 1);
  }

  paginationCall3(value: number) {
    this.perPage3 = value;
    this.setPage3(this.pager3.currentPage, 0);
  }

  issuanceHistList: any = [];
  pagerForIssHist: any = {};
  pagedItemsForIssHist: any = [];
  setPageForIssHist(page: number, targetpage: number) {
    if (page < 1 || page > this.pagerForIssHist.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pagerForIssHist = this.paginationService.getPager(this.issuanceHistList.length, page, this.perPage, targetpage);
    this.pagedItemsForIssHist = this.issuanceHistList.slice(this.pagerForIssHist.startIndex, this.pagerForIssHist.endIndex + 1);
  }

  paginationCallForIssHist(value: number) {
    this.perPage = value;
    this.setPageForIssHist(this.pagerForIssHist.currentPage, 0);
  }

  setPageForSavedReport(page: number, targetpage: number) {
    if (page < 1 || page > this.pagerForPopup.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pagerForPopup = this.paginationService.getPager(this.savedReportsList.length, page, this.perPage, targetpage);
    this.pagedItemForSavedReport = this.savedReportsList.slice(this.pagerForPopup.startIndex, this.pagerForPopup.endIndex + 1);
  }

  paginationCallForSavedReport(value: number) {
    this.perPage = value;
    this.setPageForIssHist(this.pagerForPopup.currentPage, 0);
  }

  pagedItemsForViewHist: any = [];


  paginationCallForViewHist(value: number) {
    this.perPage = value;
    this.setPageForViewHist(this.currentPageRevision, 0);
  }
  paginationCallForMoveHist(value: number) {
    this.perPage = value;
    this.setPageForMoveHist(1, 0);
  }

  pagedItemsForMoveHist: any = [];
  moveHistList: any = [];
  selectedTabIndex3 = 0;
  pagerForRevision: any = {};
  collectionSizeForRevision: number = 0;

  pagerForMove: any = {};
  collectionSizeForMove: number = 0;
  documentHistList: any = [];
  currentPageRevision: number = 1;
  setPageForViewHist(page: number, targetpage: number) {
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pagerForRevision = this.paginationService.getPager(this.documentHistList.length, page, this.perPage, targetpage);
    this.pagedItemsForViewHist = this.documentHistList.slice(this.pagerForRevision.startIndex, this.pagerForRevision.endIndex + 1);
  }
  setPageForMoveHist(page: number, targetpage: number) {
    if (page < 1 || (this.pagerForMove.totalPages && page > this.pagerForMove.totalPages)) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }
    this.pagerForMove = this.paginationService.getPager(this.moveHistList.length, page, this.perPage, targetpage);
    this.pagedItemsForMoveHist = this.moveHistList.slice(this.pagerForMove.startIndex, this.pagerForMove.endIndex + 1);
  }

  onTabChanged3(event: any) {
    let data = event.tab.textLabel;

    if (data == "Move History") {
      this.isProcessing = true;
      this.collectionSizeForMove = 0; // Reset specific variable
      this.appService.getDocumentMoveHistory(this.rightClickData['documentId'])
        .subscribe((data: any) => {
          this.moveHistList = data;
          this.isProcessing = false;

          // Update specific variables
          this.collectionSizeForMove = this.moveHistList.length;
          this.pagerForMove = {};
          this.setPageForMoveHist(1, 0);
        });
    }
  }
  addFolderFunc() {
    this.title = "Add Folder";
    this.visibleAddButton = true;
    this.visibleEditButton = false;
    this.folderData = {};

    this.folderData['folderName'] = "";
    this.folderData['folderDescription'] = null;
    this.folderData['documentTypeCode'] = null;
    this.folderData['parentFolderId'] = this.parentFolderId;
    this.folderData['folderCode'] = null;
    this.folderData['documentNoFormat'] = null;
    this.folderData['documentNoRegeneration'] = null;
    this.folderData['documentNoNoOfDigits'] = null;
    this.folderData['allowToInputDocumentNoManually1'] = false;
    this.folderData['enablePublishMailForFolderUsers1'] = false;
    this.folderData['allowToInputVersionManually1'] = false;
    this.folderData['overrideDocumentNumberFormatAtFolder'] = false;
    this.selectedUserGroups = null;
    this.cascaseToChild = false;
    if (this.parentFolderData.isDistributedFolder == "Y") {
      this.folderData['isDistributedFolder1'] = true;
    } else {
      this.folderData['isDistributedFolder1'] = false;
    }

    this.selectedDocumentType = [];
    this.selectedDocumentTypeValue = "";
    this.operationFlag = "ADD";
    this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
  }

  placeholderData: any = {};
  selectedPlaceholderDocumentType: any = null;
  selectedPlaceholderDocumentTypeValue: any;
  visiblePlaceholderAddButton: boolean = false;
  visiblePlaceholderEditButton: boolean = false;
  addPlaceholderFunc() {
    this.isRightClickAdd = false;
    this.title = "Add Document";
    this.visiblePlaceholderAddButton = true;
    this.visiblePlaceholderEditButton = false;
    this.placeholderData = {};

    this.placeholderData['documentName'] = "";
    this.placeholderData['version'] = "";
    this.placeholderData['crNo'] = "";
    this.placeholderData['documentDescription'] = "";
    this.placeholderData['documentTypeCode'] = null;
    this.placeholderData['folderId'] = this.parentFolderId;
    this.placeholderData['docOrPlaceholder'] = "PLACEHOLDER";
    this.placeholderData['documentNo'] = null;
    this.placeholderData['associatedDocumentId'] = null;
    this.placeholderData['isBlinded'] = false;
    this.placeholderData['isBlinded1'] = false;
    this.placeholderData.effectiveDate = null;
    this.placeholderData.expirationDate = null;
    this.selectedPlaceholderDocumentType = null;
    this.selectedPlaceholderDocumentTypeValue = "";
    this.placeholderData.crId = null;
    this.operationFlag = "ADD";
    this.documentAddOption = null;
    this.visibleAddAndEditPlaceholderPopup = this.dialog.open(this.addAndEditPlaceholderPopup, this.addAndEditPlaceholderPopupConfig);
  }

  cancelAddAndEditPlaFunction() {
    this.visibleAddAndEditPlaceholderPopup.close();
  }

  isDisableOverrideDocType: boolean = false;

  ondocumentTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      setTimeout(() => {
        this.documentTypeSelection = this.documentTypeDropdown.length == this.selectedDocumentType.length;
      })
    }
  }

  ondocumentTypeRemoved(item: any) {

  }

  @ViewChild('documentTypeId') documentTypeId: MatSelect;
  documentTypeSelection = false;

  toggleAllSelection(value: any) {
    if (value == 'documentType') {
      if (this.documentTypeSelection) this.documentTypeId.options.forEach((item: MatOption) => item.select());
      else {
        this.documentTypeId.options.forEach((item: MatOption) => item.deselect())
        this.selectedDocumentType = [];
      }

    }
  }
  isShowAssociatedDocumentField: boolean = false;
  isShowisAmendementDocType: boolean = false;
  isShowCrFieldsForPlaceholder = false;
  isShowAssociatedDocumentFieldForPlaceholder = false;
  isShowUserBelongsToFieldForPlaceholder = false;
  isShowIsBlindedFlagForPlaceholder = false;
  isShowExpDate = false;
  onPlaceholderdocumentTypeSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.selectedPlaceholderDocumentTypeValue = item.valueExp;
        [
          this.isShowAssociatedDocumentFieldForPlaceholder,
          this.isShowUserBelongsToFieldForPlaceholder,
          this.isShowCrFieldsForPlaceholder,
          this.isShowIsBlindedFlagForPlaceholder,
          this.isShowExpDate
        ] = [false, false, false, false, false];

        this.placeholderData['documentTypeCode'] = this.selectedPlaceholderDocumentTypeValue;
        for (const element of this.dropDownFordocumentTypeList) {
          if (element.documentTypeCode == item.valueExp) {
            this.documentTypeData = element;
            this.isShowAssociatedDocumentFieldForPlaceholder = element.isAssociatedDocumentType == "Y";
            this.isShowUserBelongsToFieldForPlaceholder = element.belongsToIndividual == "Y";
            this.isShowIsBlindedFlagForPlaceholder = element.isBlindable == "Y";

            if (element.crProcess == "Mandatory" || element.crProcess == "Non Mandatory") {
              this.isShowCrFieldsForPlaceholder = true;
              if (element.crProcess == "Mandatory") {
                this.isCrFeildIsMandatory = true;
              }
            }
            if (element.isExpiryApplicable == "Y") {
              this.isShowExpDate = true;
            }
          }
        }
        if (this.placeholderData['effectiveDate'] != null) {
          this.selectExpValueForPlaceholder(new Date(this.placeholderData['effectiveDate']));
        }
      } else {
        this.selectedPlaceholderDocumentTypeValue = null;
        [
          this.isShowAssociatedDocumentFieldForPlaceholder,
          this.isShowUserBelongsToFieldForPlaceholder,
          this.isShowCrFieldsForPlaceholder,
          this.isShowIsBlindedFlagForPlaceholder,
          this.selectedPlaceholderDocumentTypeValue
        ] = [false, false, false, false, null];
      }
    }
  }

  onPlaceholderdocumentTypeSelectOld(item: any) {
    this.selectedPlaceholderDocumentTypeValue = item.valueExp;
    this.isShowAssociatedDocumentFieldForPlaceholder = false;
    this.isShowUserBelongsToFieldForPlaceholder = false;
    this.isShowCrFieldsForPlaceholder = false;
    this.isShowIsBlindedFlagForPlaceholder = false;
    this.placeholderData['documentTypeCode'] = this.selectedPlaceholderDocumentTypeValue;
    for (let i = 0; i < this.dropDownFordocumentTypeList.length; i++) {
      if (this.dropDownFordocumentTypeList[i].documentTypeCode == item.valueExp) {
        this.documentTypeData = this.dropDownFordocumentTypeList[i];
        if (this.dropDownFordocumentTypeList[i].isAssociatedDocumentType == "Y") {
          this.isShowAssociatedDocumentFieldForPlaceholder = true;
        }
        if (this.dropDownFordocumentTypeList[i].belongsToIndividual == "Y") {
          this.isShowUserBelongsToFieldForPlaceholder = true;
        }
        if (this.dropDownFordocumentTypeList[i].isBlindable == "Y") {
          this.isShowIsBlindedFlagForPlaceholder = true;
        }
        if (this.dropDownFordocumentTypeList[i].crProcess == "Mandatory" || this.dropDownFordocumentTypeList[i].crProcess == "Non Mandatory") {

          this.isShowCrFieldsForPlaceholder = true;
          if (this.dropDownFordocumentTypeList[i].crProcess == "Mandatory") {
            this.isCrFeildIsMandatory = true;
          }
        }
      }
    }
    if (this.placeholderData['effectiveDate'] != null) {
      this.selectExpValueForPlaceholder(new Date(this.placeholderData['effectiveDate']));
    }
  }
  onPlaceholderdocumentTypeRemoved(item: any) {
    this.selectedPlaceholderDocumentTypeValue = null;
    this.isShowCrFieldsForPlaceholder = false;
    this.isShowIsBlindedFlagForPlaceholder = false;
    this.isShowAssociatedDocumentFieldForPlaceholder = false;
    this.isShowUserBelongsToFieldForPlaceholder = false;
  }

  cancelAddAndEditFunction() {
    this.visibleAddAndEditPopup.close();
  }

  folderName: any;
  folderNameRequiredMsg: any;

  updateReason: any;
  updateReasonRequiredMsg: any;
  fieldValidation() {
    this.folderName = document.getElementById('folderName') as HTMLInputElement;
    this.folderNameRequiredMsg = document.getElementById('folderName-required-msg') as HTMLInputElement;

    this.updateReason = document.getElementById('updateReason') as HTMLInputElement;
    this.updateReasonRequiredMsg = document.getElementById('updateReason-required-msg') as HTMLInputElement;

    if (this.folderData.folderName == "") {
      this.folderName.style.border = '1px solid red';
      this.folderNameRequiredMsg.style.display = 'block';
    } else {
      this.folderName.style.border = 'none';
      this.folderNameRequiredMsg.style.display = 'none';
    }

    if (this.visibleEditButton) {
      if (this.folderData.updateReason == "") {
        this.updateReason.style.border = '1px solid red';
        this.updateReasonRequiredMsg.style.display = 'block';
      } else {
        this.updateReason.style.border = 'none';
        this.updateReasonRequiredMsg.style.display = 'none';
      }
    }
  }

  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;

  addAndEditFunction(folderData: any) {
    this.isProcessing = true;
    if (folderData.folderName == "" || (this.visibleEditButton && this.folderData.updateReason == "")) {
      this.fieldValidation();
      this.isProcessing = false;
    } else {
      if (this.operationFlag == 'ADD') {
        folderData.isDistributedFolder = this.folderData.isDistributedFolder1 ? 'Y' : 'N';
        folderData.allowToInputDocumentNoManually = this.folderData.allowToInputDocumentNoManually1 ? 'Y' : 'N';
        folderData.enablePublishMailForFolderUsers = this.folderData.enablePublishMailForFolderUsers1 ? 'Y' : 'N';


        folderData.allowToInputVersionManually = this.folderData.allowToInputVersionManually1 ? 'Y' : 'N';
        this.selectedDocumentTypeValue = this.selectedDocumentType.length ? this.selectedDocumentType.join(',') : null;

        folderData.documentTypeCode = this.selectedDocumentTypeValue;
        this.appService.createDmsFolder(folderData).subscribe((Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            let folderId = Response.folderId;
            if (this.selectedUserGroups != null) {
              this.isProcessing = true;
              let data = {
                groupId: this.selectedUserGroups,
                folderId: folderId,
                cascaseToChild: this.cascaseToChild ? 'Y' : 'N',
              }


              this.appService.createDmsGruoupFolders(data).subscribe((Response: any) => {
                this.isProcessing = true;
                if (Response.resultType == 'S') {
                  this.visibleAddAndEditPopup.close();
                  this.getCall();
                  this.isProcessing = false;
                } else {
                  let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                    duration: 5000,
                    data: {
                      message: Response.result,
                      type: Response.resultType == 'S' ? 'Success' : 'Error',
                      buttonLabel: "Ok"
                    },
                    horizontalPosition: 'center',
                    verticalPosition: 'top',
                    panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
                  });
                  sb.onAction().subscribe(() => {
                    sb.dismiss();
                  });
                }

                this.isProcessing = false;
              }, (error) => {
                this.isProcessing = false;
                throw error;
              });
            } else {
              this.visibleAddAndEditPopup.close();
              this.getCall();
              this.isProcessing = false;
            }

            /*    } */

          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            //duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
              pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.secondLevel : this.message.breadcrumbData.thirdLevel
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        });
      } else {
        delete folderData.createdOn;
        delete folderData.updatedOn;


        folderData.isDistributedFolder = this.folderData.isDistributedFolder1 ? 'Y' : 'N';
        folderData.allowToInputDocumentNoManually = this.folderData.allowToInputDocumentNoManually1 ? 'Y' : 'N';
        folderData.enablePublishMailForFolderUsers = this.folderData.enablePublishMailForFolderUsers1 ? 'Y' : 'N';

        folderData.allowToInputVersionManually = this.folderData.allowToInputVersionManually1 ? 'Y' : 'N';
        this.selectedDocumentTypeValue = this.selectedDocumentType.length ? this.selectedDocumentType.join(',') : null;

        folderData.documentTypeCode = this.selectedDocumentTypeValue;
        this.appService.updateDmsFolder(folderData).subscribe((Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.visibleAddAndEditPopup.close();
            this.getCall();
            this.isProcessing = false;
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            //duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
              pageName: this.message.breadcrumbData.thirdLevel ? this.message.breadcrumbData.secondLevel : this.message.breadcrumbData.thirdLevel
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }, (error: any) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        });

      }
    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }

  goToSubfolderPage(object: any) {
    this.isSingleClick = false;
    if (object.type == "Folder") {
      this.appService.setParentFolderId(object.folderId);
      this.documentBreadcrumbList.push(object.folderName);
      this.appService.setDocumentBreadcrumbList(this.documentBreadcrumbList);
      this.router.navigate(['/dashboard/subFolder', object.folderName + "?v=" + Math.random()]);
    } else {
      if (this.parentFolderData.isDistributedFolder != "Y") {
        this.appService.setParentFolderId(object.folderId);
      } else {
        this.appService.setParentFolderId(this.parentFolderData.folderId);
      }
      this.isProcessing = true;
      this.appService.getDocumentByDocumentId(
        object.documentId, object.version).subscribe((data: any) => {
          this.documentData = data[0];
          this.isProcessing = false;
          this.appService.prevDocumentId = null;
          this.appService.prevDocVersion = null;
          this.documentData['opern'] = "Manage";
          this.router.navigate(['/dashboard/addDocument'], {
            state: {
              documentData: this.documentData,
              dropDownFordocumentTypeList: this.dropDownFordocumentTypeList
            }
          });
        })

    }
  }

  cancelDownloadFunction() {
    this.visibleSDownloadPopup.close();
  }

  documentData: any = {};
  documentDataForType: any = {};
  documentTypeDataForParent: any = {};
  addDocumentFunc() {
    this.appService.setParentFolderId(this.parentFolderData.folderId);
    this.documentData = {};
    if (this.documentAddOption == "Add From Template") {
      this.documentData['addFrom'] = "Add From Template";
    } else {
      this.documentData['addFrom'] = "Add Manually";
    }
    this.appService.prevDocumentId = null;
    this.appService.prevDocVersion = null;
    this.documentData['opern'] = "Manage";
    this.router.navigate(['/dashboard/addDocument'], {
      state: {
        documentData: this.documentData,
        dropDownFordocumentTypeList: this.dropDownFordocumentTypeList
      }
    });
  }

  rightClickData: any = {};
  menuTopLeftPosition = { x: '0', y: '0' }
  @ViewChild(MatMenuTrigger, { static: true }) matMenuTrigger: MatMenuTrigger;
  actionLabels: any = [];
  onRightClick(event: MouseEvent, item: any) {
    // preventDefault avoids to show the visualization of the right-click menu of the browser
    event.preventDefault();
    this.rightClickData = item;
    // we record the mouse position in our object
    this.menuTopLeftPosition.x = event.clientX + 'px';
    this.menuTopLeftPosition.y = event.clientY + 'px';
    if (item.type == "Folder") {
      let data = {

        folderId: item.folderId,
        status: item.status
      }
      this.appService.getFolderActionLabels(data).subscribe((data: any) => {
        let actionLabels = data.actionLabels != null ? data.actionLabels.split(",") : [];
        let uiActionLabels = data.uiActionLabels != null ? data.uiActionLabels.split(",") : [];
        this.actionLabels = [];
        for (let i = 0; i < actionLabels.length; i++) {
          let iconstemp;
          if (actionLabels[i] == "Delete") {
            iconstemp = "fa fa-trash";
          }
          else if (actionLabels[i] == "Lock") {
            iconstemp = "fa fa-lock";
          } else if (actionLabels[i] == "Inactivate") {
            iconstemp = "fa fa-ban";
          } else if (actionLabels[i] == "Activate") {
            iconstemp = "Activelogo";
          }
          else if (actionLabels[i] == "Unlock") {
            iconstemp = "fa fa-unlock";
          } else if (actionLabels[i] == "Additional Notification") {
            iconstemp = "fa fa-flag-o";
          }
          else if (actionLabels[i] == "Add Usergroup") {
            iconstemp = "addUser";
          }
          else if (actionLabels[i] == "Revoke Privileges") {
            iconstemp = "removeUser";
          }
          else if (actionLabels[i] == "Quality Check") {
            iconstemp = "Auditimg";

          } else if (actionLabels[i] == "Raise Query") {
            iconstemp = "monitorauditrisequery";

          } else if (actionLabels[i] == "Sticky Note") {
            iconstemp = "strickynote";

          }


          else if (actionLabels[i] == "Export") {
            iconstemp = "ExporDocuments";
          }
          else if (actionLabels[i] == "Update Status") {
            iconstemp = "UpdateStatus";
          } else if (actionLabels[i] == "Distribute") {

            iconstemp = "Distribute";

          } else if (actionLabels[i] == "Pin") {

            iconstemp = "fa  fa-thumb-tack";

          } else if (actionLabels[i] == "Unpin") {

            iconstemp = "fa  fa-thumb-tack";

          } else if (actionLabels[i] == "Tag to Home") {
            iconstemp = "fa fa-tag";
          }
          else {
            //iconstemp="download"
          }

          if (actionLabels[i] != "") {
            this.actionLabels.push({
              text: actionLabels[i],
              icons: iconstemp
            })
          }
        }
        for (let i = 0; i < uiActionLabels.length; i++) {
          let iconstemp;
          if (uiActionLabels[i] == "Properties") {
            iconstemp = "fa fa-ellipsis-v";
          } else if (uiActionLabels[i] == "Delete") {
            iconstemp = "fa fa-trash";
          } else if (uiActionLabels[i] == "Template") {
            iconstemp = "fa fa-file-text-o";
          } else if (uiActionLabels[i] == "Map Folder") {
            iconstemp = "fa fa-folder";
          } else if (uiActionLabels[i] == "Edit") {
            iconstemp = "fa fa-pencil";
          }

          else if (uiActionLabels[i] == "View History") {
            iconstemp = "fa fa-history";
          } else if (uiActionLabels[i] == "Add Usergroup") {
            iconstemp = "addUser";
          } else if (uiActionLabels[i] == "Audit Trail") {
            iconstemp = "fa-solid fa-clipboard";
          } else if (uiActionLabels[i] == "Tag to Home") {
            iconstemp = "fa fa-tag";
          }
          else {
            //iconstemp="download"
          }

          if (uiActionLabels[i] != "") {
            this.actionLabels.push({
              text: uiActionLabels[i],
              icons: iconstemp
            })
          }
        }
        this.matMenuTrigger.menuData = { item: this.actionLabels };
        this.matMenuTrigger.openMenu();
      })
    } else {
      let data = {
        folderId: this.parentFolderId,
        status: item.status,
        documentId: item.documentId,
        version: item.version
      }
      if (this.navigationName == "Search") {
        data.folderId = item.folderId;
      }
      this.appService.getDocumentActionLabels(data).subscribe((data: any) => {
        let actionLabels = data.actionLabels ? data.actionLabels.split(",") : [];
        let uiActionLabels = data.uiActionLabels ? data.uiActionLabels.split(",") : [];
        this.actionLabels = [];
        for (let i = 0; i < actionLabels.length; i++) {
          let iconstemp;
          if (actionLabels[i] == "CheckOut") {
            iconstemp = "fa fa-unlock";
          }
          else if (actionLabels[i] == "Document History") {
            iconstemp = "fa fa-file-text";
          }
          else if (actionLabels[i] == "View Related Trainings") {
            iconstemp = "fa fa-graduation-cap";
          }
          else if (actionLabels[i] == "Move Document") {
            iconstemp = "fa fa-arrow-circle-right";
          } else if (actionLabels[i] == "Properties") {
            iconstemp = "fa fa-ellipsis-v";
          } else if (actionLabels[i] == "Copy") {
            iconstemp = "fa fa-copy";
          } else if (actionLabels[i] == "Set Document Roles") {
            iconstemp = "fa fa-users";
          } else if (actionLabels[i] == "Set Expiry") {
            iconstemp = "fa fa-clock-o";
          } else if (actionLabels[i] == "Edit") {
            iconstemp = "fa fa-pencil";
          } else if (actionLabels[i] == "CheckIn") {
            iconstemp = "fa fa-lock";
          } else if (actionLabels[i] == "Uncheck") {
            iconstemp = "fa fa-times-circle-o";
          } else if (actionLabels[i] == "Publish") {
            iconstemp = "publishlogo";
          } else if (actionLabels[i] == "Unpublish") {
            iconstemp = "unpublishlogo";
          } else if (actionLabels[i] == "Update Revision/Purpose") {
            iconstemp = "fa fa-edit";
          } else if (actionLabels[i] == "UnBlind") {
            iconstemp = "fa fa-eye";
          } else if (actionLabels[i] == "InActivate") {
            iconstemp = "fa fa-ban";
          } else if (actionLabels[i] == "Activate") {
            iconstemp = "Activelogo";
          } else if (actionLabels[i] == "Link/Delink Documents") {
            iconstemp = "linkdilink";
          } else if (actionLabels[i] == "Blind") {
            iconstemp = "fa fa-eye-slash";
          } else if (actionLabels[i] == "Withdraw") {
            iconstemp = "withdrawlogo";
          } else if (actionLabels[i] == "Destruct") {
            iconstemp = "destructionlogo";
          } else if (actionLabels[i] == "Tag to Home") {
            iconstemp = "fa fa-tag";
          }
          else if (actionLabels[i] == "Convert/Upload Pdf") {
            iconstemp = "ConvertToPdf";
          }
          else if (actionLabels[i] == "Remove") {
            iconstemp = "fa fa-minus-square-o";
          }
          else if (actionLabels[i] == "Approve") {
            iconstemp = "fa fa-eye";
          }
          else if (actionLabels[i] == "Review") {
            iconstemp = "fa fa-eye";
          } else if (actionLabels[i] == "Set as Optional") {
            iconstemp = "setoptional";
          }
          else if (actionLabels[i] == "Set as Mandatory") {
            iconstemp = "setmandaraty";
          }
          else if (actionLabels[i] == "Quality Check") {
            iconstemp = "Auditimg";

          } else if (actionLabels[i] == "Self Assign") {
            iconstemp = "assign";

          } else if (actionLabels[i] == "Release") {
            iconstemp = "unassign";

          }
          else if (actionLabels[i] == "Resend") {
            iconstemp = "fa fa-repeat";

          } else if (actionLabels[i] == "Undo") {
            iconstemp = "fa fa-undo";

          }
          else if (actionLabels[i] == "Signoff") {
            iconstemp = "fa fa-sign-out";
          } else if (actionLabels[i] == "Pin") {
            iconstemp = "fa fa-thumb-tack";
          } else if (actionLabels[i] == "Unpin") {
            iconstemp = "fa  fa-thumb-tack";
          } else if (actionLabels[i] == "Revision History") {
            iconstemp = "fa fa-file-text-o";
          } else if (actionLabels[i] == "Document History") {
            iconstemp = "fa fa-file-text";
          } else if (actionLabels[i] == "Enable at Forms/Logs" || actionLabels[i] == "Disable at Forms/Logs") {
            iconstemp = "formslogs"
          } else if (actionLabels[i] == "Tag to Home") {
            iconstemp = "fa fa-tag";
          }
          else {
            //iconstemp="download"
          }

          if (actionLabels[i] != "") {
            this.actionLabels.push({
              text: actionLabels[i],
              icons: iconstemp
            })
          }
        }
        for (let i = 0; i < uiActionLabels.length; i++) {
          let iconstemp;

          if (uiActionLabels[i] == "Properties") {
            iconstemp = "fa fa-ellipsis-v";
          } else if (uiActionLabels[i] == "Issuance History") {
            iconstemp = "fa fa-file-text-o";
          }
          else if (uiActionLabels[i] == "View") {
            iconstemp = "fa fa-history";
          } else if (uiActionLabels[i] == "Destruct") {
            iconstemp = "destructionlogo";
          } else if (uiActionLabels[i] == "Notes") {
            iconstemp = "strickynote";
          }
          else if (uiActionLabels[i] == "View Related Trainings") {
            iconstemp = "fa fa-graduation-cap";

          } else if (uiActionLabels[i] == "Redact") {
            iconstemp = "Redaction";

          } else if (uiActionLabels[i] == "Move Document") {
            iconstemp = "moveDocument";

          } else if (uiActionLabels[i].includes("Add")) {
            iconstemp = "fa fa-plus-square-o";
          } else if (uiActionLabels[i] == "Raise Query") {
            iconstemp = "monitorauditrisequery";

          } else if (uiActionLabels[i] == "Download" || uiActionLabels[i] == "Download(Original)") {
            iconstemp = "fa fa-download";
          } else if (uiActionLabels[i] == "Document History") {
            iconstemp = "fa fa-file-text";
          } else if (uiActionLabels[i] == "Request Issuance") {
            iconstemp = "fa fa-window-restore";
          } else if (uiActionLabels[i] == "Extend") {
            iconstemp = "fa fa-expand";
          } else if (uiActionLabels[i] == "Tag to Home") {
            iconstemp = "fa fa-tag";
          } else if (uiActionLabels[i] == "Print") {
            iconstemp = "fa fa-print";
          }
          else if (uiActionLabels[i] == "E-Signature") {
            iconstemp = "fa fa-pencil-square-o";
          }

          else {
            //iconstemp="download"
          }
          if (uiActionLabels[i] != "") {
            this.actionLabels.push({
              text: uiActionLabels[i],
              icons: iconstemp
            })
          }
        }
        this.matMenuTrigger.menuData = { item: this.actionLabels };
        this.matMenuTrigger.openMenu();
      })
    }
  }

  config: EditorConfig = {
    placeholder: '',
    buttons: ST_BUTTONS,
  };
  @ViewChild(HomepagetagComponent) homepagetagComponent!: HomepagetagComponent;
  openTag(value: any) {
    let data = {
      pageName: value.type,
      labelName: "Tag",
      taskId: value.type == 'Folder' ? value.folderId : value.documentId,
      tagRef: value.type == 'Folder' ? value.folderCode == null ? value.folderName : value.folderCode + "-" + value.folderName : value.documentTypeCode + '-' + value.documentName
    };
    this.homepagetagComponent.openpopup(data);
  }

  onTagChildValueEmitted() {
  };
  dynamicTitle: any;
  buttonData: any;
  columnList: any = [];
  isShowMovDocCommentField = false;
  isAddDocForDocType: boolean = false;
  isDisabledEditingDocType: boolean = false;
  completeHistory: boolean = false;
  savedReportsList: any = [];
  followSameExpDate1: boolean = false;
  parentExpiryDate: Date | null = null;
  performOperationFunc(button: any) {
    this.buttonData = button;
    if (this.rightClickData.type == "Folder") {
      if (button.text == 'Tag to Home') {
        this.openTag(this.rightClickData);
      } else
        if (button.text == "Edit") {
          this.isDisabledEditingDocType = false;
          this.title = "Edit Folder";
          this.visibleAddButton = false;
          this.visibleEditButton = true;
          this.selectedDocumentType = [];
          this.selectedDocumentTypeValue = "";
          this.appService.getDmsFolderDataById(this.rightClickData.folderId)
            .subscribe((data: any) => {
              this.folderData = data[0];
              this.folderData.updateReason = "";
              this.folderData.isDistributedFolder = this.folderData.isDistributedFolder === "Y";
              this.folderData.isDistributedFolder1 = this.folderData.isDistributedFolder;
              this.folderData.allowToInputDocumentNoManually1 = this.folderData.allowToInputDocumentNoManually === "Y";
              this.folderData.enablePublishMailForFolderUsers1 = this.folderData.enablePublishMailForFolderUsers === "Y";

              this.folderData.allowToInputVersionManually1 = this.folderData.allowToInputVersionManually === "Y";

              if (this.folderData.documentNoFormat != null || this.folderData.documentNoRegeneration != null || this.folderData.documentNoNoOfDigits != null) {
                this.folderData.overrideDocumentNumberFormatAtFolder = true;
              } else {
                this.folderData.overrideDocumentNumberFormatAtFolder = false;
              }
              if (this.folderData.documentTypeCode != null) {
                let docTypeArrayValue: [] = this.folderData.documentTypeCode.split(",");
                this.selectedDocumentType = docTypeArrayValue;

              }

            })

          this.operationFlag = "EDIT";
          this.visibleAddAndEditPopup = this.dialog.open(this.addAndEditPopup, this.addAndEditPopupConfig);
        } else if (button.text == "Delete" || button.text == "Lock" || button.text == "Unlock" || button.text == "Inactivate"
          || button.text == "Activate") {
          this.title = button.text;
          this.comments = "";
          this.visibleConfirm = this.dialog.open(this.confirmPopup, this.confirmPopupConfig);
        } else if (button.text == "Properties") {
          this.columnList = [{ "name": "Group", "width": "350px" }, { "name": "Priviledge Type", "width": "300px" }, { "name": "Assigned On", "width": "250px" },
          { "name": "Assigned By", "width": "250px" }]
          this.isProcessing = true;
          this.appService.getGroupPrivForFolders(this.rightClickData['folderId'])
            .subscribe((data: any) => {
              this.groupAllFolderList = data;
              this.isProcessing = false;
              this.collectionSizeForPopup = this.groupAllFolderList.length;
              this.pagerForPopup.totalPages = undefined;
              this.setPageForPopup(1, 0, this.groupAllFolderList);
            })
          this.visiblePropertiesPopup = this.dialog.open(this.propertiesPopup, this.propertiesPopupConfig);
        } else if (button.text == "Map Folder") {
          this.isProcessing = true;
          this.appService.getDmsFolderDataById(this.rightClickData.folderId)
            .subscribe((data: any) => {
              this.isProcessing = false;
              this.folderData = data[0];
            })
          this.visibleMapFolderPopup = this.dialog.open(this.mapFolderPopup, this.mapFolderPopupConfig);
        } else if (button.text == "Template") {
          this.clearTemplateSelections();
          this.columnList = [{ "name": "Template Name", "width": "200px" }, { "name": "Template", "width": "120px" }, { "name": "Template Extn", "width": "150px" },
          { "name": "Is Active?", "width": "150px" }]
          this.isProcessing = true;
          this.appService.getDocumentTemplateByFolderId(this.rightClickData.folderId,
          ).subscribe((data: any) => {
            this.isProcessing = false;
            this.templateList = data;
            this.collectionSizeForPopup = this.templateList.length;
            this.pagerForPopup.totalPages = undefined;
            this.setPageForPopup(1, 0, this.templateList);
            this.visibleTemplatePopup = this.dialog.open(this.templatePopup, this.templatePopupConfig);
          })
        } else if (button.text == "Add Usergroup") {
          this.columnList = [{ "name": "Group Name", "width": "120px" }, { "name": "Description", "width": "300px" }, { "name": "Is Active?", "width": "100px" }]
          this.cascaseToChild = false;
          this.isProcessing = true;
          this.searchValue1 = '';
          this.searchValue3 = '';
          this.appService.getUserGroupsForFolders(this.rightClickData.folderId).subscribe((data: any) => {
            this.isProcessing = false;
            this.dmsGroupsList = data;
            this.collectionSizeForPopup = this.dmsGroupsList.length;
            this.pagerForPopup.totalPages = undefined;
            this.setPageForPopup(1, 0, this.dmsGroupsList);
            this.visibleAddUserGroupPopup = this.dialog.open(this.addUserGroupPopup, this.addUserGroupPopupConfig);
          })
        } else if (button.text == "Audit Trail") {
          this.openAuditTrail('folder', 'individual', this.rightClickData.folderId);
        }
    } else {
      if (button.text == 'Tag to Home') {
        this.openTag(this.rightClickData);
      } else
        if (button.text == "Edit") {

        } else if (button.text == "Extend" || button.text == "Withdraw" || button.text == "Destruct") {
          this.extensionOrWithdrawData['crId'] = null;
          this.extensionOrWithdrawData['crNo'] = null;
          this.extensionOrWithdrawData['reason'] = null;
          this.getSelectedCrNo = null;
          this.getSelectedCrId = null;
          if (button.text == "Extend") {
            this.title = "Extend";
            this.documentData = this.rightClickData;
            if (this.documentData.associatedDocumentId) {
              this.isProcessing = true; // Show loading while fetching parent
              // Use getDocumentByDocIdFirstTime to get the parent's base info
              this.appService.getDocumentByDocIdFirstTime(
                this.documentData.associatedDocumentId // Use the associatedDocumentId as the target ID
              ).subscribe(
                (parentData: any) => {
                  this.isProcessing = false;
                  if (parentData && Array.isArray(parentData) && parentData.length > 0 && parentData[0].expirationDate) {
                    // Assuming the first entry from getDocumentByDocIdFirstTime is the relevant one
                    // and it contains the expirationDate. Adjust if the structure is different.
                    this.parentExpiryDate = new Date(parentData[0].expirationDate);
                    console.log('Parent Expiry Date (from getDocumentByDocIdFirstTime):', this.parentExpiryDate); // Debug log
                  } else {
                    // Handle case where parent has no expiry date or fetch fails or returns unexpected format
                    console.error("Could not retrieve parent expiry date from getDocumentByDocIdFirstTime response:", parentData);
                    this.parentExpiryDate = null;
                  }
                },
                (error) => {
                  this.isProcessing = false;
                  console.error("Error fetching parent document base info (getDocumentByDocIdFirstTime) for expiry check:", error);
                  this.parentExpiryDate = null; // Assume no conflict on error
                }
              );
            } else {
              this.parentExpiryDate = null;
            }
            for (let i = 0; i < this.dropDownFordocumentTypeList.length; i++) {
              if (this.dropDownFordocumentTypeList[i].documentTypeCode == this.documentData['documentTypeCode']) {
                this.documentTypeData = this.dropDownFordocumentTypeList[i];
                if (this.dropDownFordocumentTypeList[i].crProcess == "Mandatory" || this.dropDownFordocumentTypeList[i].crProcess == "Non Mandatory") {
                  this.isShowCrFields = true;
                  if (this.dropDownFordocumentTypeList[i].crProcess == "Mandatory") {
                    this.isCrFeildIsMandatory = true;
                  } else {
                    this.isCrFeildIsMandatory = false;
                  }
                } else {
                  this.isShowCrFields = false;
                }
              }
            }
            this.documentData['folderId'] = this.parentFolderId;
            this.extensionOrWithdrawData['documentId'] = this.documentData['documentId'];
            this.extensionOrWithdrawData['version'] = this.documentData['version'];
            this.extensionOrWithdrawData['folderId'] = this.documentData['folderId'];
            this.extensionOrWithdrawData['currentExpiryDate'] = null;
            this.extensionOrWithdrawData['toBeExtendedTill'] = null;
            if (this.documentData['expirationDate'] != null) {
              this.extensionOrWithdrawData['currentExpiryDate'] = new Date(this.documentData['expirationDate']);
              this.extensionOrWithdrawData['toBeExtendedTill'] = new Date(this.documentData['expirationDate']);
              if (this.documentTypeData.expiryInUnit == "Days") {
                this.extensionOrWithdrawData['toBeExtendedTill'].setDate(new Date(this.documentData['expirationDate']).getDate() + this.documentTypeData.expiryIn);
              } else if (this.documentTypeData.expiryInUnit == "Month") {
                this.extensionOrWithdrawData['toBeExtendedTill'].setMonth(new Date(this.documentData['expirationDate']).getMonth() + this.documentTypeData.expiryIn);
              } else {
                this.extensionOrWithdrawData['toBeExtendedTill'].setFullYear(new Date(this.documentData['expirationDate']).getFullYear() + this.documentTypeData.expiryIn);
              }
            }

          } else if (button.text == "Destruct") {
            this.title = "Destruct";
            this.documentData = this.rightClickData;
            this.documentData['folderId'] = this.parentFolderId;
            this.extensionOrWithdrawData['documentId'] = this.documentData['documentId'];
            this.extensionOrWithdrawData['version'] = this.documentData['version'];
            this.extensionOrWithdrawData['folderId'] = this.documentData['folderId'];

            for (let i = 0; i < this.dropDownFordocumentTypeList.length; i++) {
              if (this.dropDownFordocumentTypeList[i].documentTypeCode == this.documentData['documentTypeCode']) {
                this.documentTypeData = this.dropDownFordocumentTypeList[i];
                if (this.dropDownFordocumentTypeList[i].crProcess == "Mandatory" || this.dropDownFordocumentTypeList[i].crProcess == "Non Mandatory") {
                  this.isShowCrFields = true;
                  if (this.dropDownFordocumentTypeList[i].crProcess == "Mandatory") {
                    this.isCrFeildIsMandatory = true;
                  } else {
                    this.isCrFeildIsMandatory = false;
                  }
                }
              }
            }
          } else {
            this.title = "Withdraw";
            this.documentData = this.rightClickData;
            this.documentData['folderId'] = this.parentFolderId;
            this.extensionOrWithdrawData['documentId'] = this.documentData['documentId'];
            this.extensionOrWithdrawData['version'] = this.documentData['version'];
            this.extensionOrWithdrawData['folderId'] = this.documentData['folderId'];

            for (let i = 0; i < this.dropDownFordocumentTypeList.length; i++) {
              if (this.dropDownFordocumentTypeList[i].documentTypeCode == this.documentData['documentTypeCode']) {
                this.documentTypeData = this.dropDownFordocumentTypeList[i];
                if (this.dropDownFordocumentTypeList[i].crProcess == "Mandatory" || this.dropDownFordocumentTypeList[i].crProcess == "Non Mandatory") {
                  this.isShowCrFields = true;
                  if (this.dropDownFordocumentTypeList[i].crProcess == "Mandatory") {
                    this.isCrFeildIsMandatory = true;
                  } else {
                    this.isCrFeildIsMandatory = false;
                  }
                }
              }
            }
          }

          this.visibleSExtensionPopup = this.dialog.open(this.extensionPopup, this.extensionPopupConfig);
        } else if (button.text == "Download") {
          this.isPrintDownloadMode = false;
          this.isOnlyPreviewMode = true;
          this.title = "Download";
          this.documentData = this.rightClickData;
          this.selectedOptionforDownload = null;
          this.selectedOptionforDownload = null;
          this.resetDownloadData();
          this.visibleSDownloadPopup = this.dialog.open(this.downloadPopup, this.propertiesdownloadPopupConfig);
        } else if (button.text == "View Related Trainings") {
          this.dynamicTitle = this.rightClickData.documentName + " document's - Related Trainings";
          this.title = this.dynamicTitle;
          this.documentData = this.rightClickData;

          this.gridConfig = {
            gridName: 'DOCUMENT_ADDED_FOR_TMS_TRAININGS',
            groupId: 0,
            showAddButton: false,
            showEditIcon: false,
            showDeleteIcon: false,
            showReorderButton: false,
            showSettings: false,    // Added: Hides the Settings button
            showAuditTrail: false,  // Added: Hides the Audit Trail button
            buttonsTooltipSubName: '',
          };

          this.gridClause = {
            documentId: this.rightClickData.documentId
          };

          this.gridTrail = {
            gridName: 'DOCUMENT_ADDED_FOR_TMS_TRAININGS',
            refKey: 'VIEW_RELATED_TRAININGS',
            trailName: this.dynamicTitle + ' Audit Trail'
          };

          this.gridReport = {
            reportName: this.dynamicTitle,
            reportType: 'Dynamic',
            excludeGroupId: true,
            documentId: this.documentData.documentId
          } as any;

          this.gridSettings = {
            module: 'DOCS',
            groupId: 0
          };

          this.visibleViewRelatedTrainingsPopup = this.dialog.open(this.viewRelatedTrainingsPopup, this.viewRelatedTrainingsPopupConfig);
        }
        else if (button.text == "Request Issuance") {
          this.title = "Issuance Request";
          this.documentData = this.rightClickData;
          if (!this.documentData.folderId) {
            this.documentData.folderId = this.parentFolderId;
          }
          this.resetDownloadData();
          this.visibleSDownloadPopup = this.dialog.open(this.downloadPopup, this.propertiesdownloadPopupConfig);
        } if (button.text == "Print") {
          this.isOnlyPreviewMode = false;
          this.isPrintDownloadMode = true;
          this.title = "Print";
          this.documentData = this.rightClickData;
          this.selectedOptionforDownload = "Issue Document";
          this.resetDownloadData();
          this.visibleSDownloadPopup = this.dialog.open(this.downloadPopup, this.propertiesdownloadPopupConfig);
        } else if (button.text == "CheckOut" || button.text == "UnBlind" || button.text == "Blind" || button.text == "Enable at Forms/Logs" || button.text == "Disable at Forms/Logs") {
          this.title = button.text;
          this.documentData = this.rightClickData;
          for (let i = 0; i < this.dropDownFordocumentTypeList.length; i++) {
            if (this.dropDownFordocumentTypeList[i].documentTypeCode == this.documentData['documentTypeCode']) {
              this.documentTypeData = this.dropDownFordocumentTypeList[i];
              if (this.dropDownFordocumentTypeList[i].crProcess == "Mandatory" || this.dropDownFordocumentTypeList[i].crProcess == "Non Mandatory") {
                this.isShowCrFields = true;
                if (this.dropDownFordocumentTypeList[i].crProcess == "Mandatory") {
                  this.isCrFeildIsMandatory = true;
                } else {
                  this.isCrFeildIsMandatory = false;
                }
              }
            }
          }
          if (button.text == "CheckOut") {
            this.isProcessing = true;
            this.appService.getAssociatedDocumentsDetail(
              this.documentData['documentId'], this.documentData['version']).subscribe((data: any) => {
                this.isProcessing = false;
                this.associatedDocumentsList = data;
                this.associatedDocumentListForCheckout = [];
                for (let k = 0; k < this.associatedDocumentsList.length; k++) {
                  if (this.documentTypeListOfAssosciatedDocs.indexOf(this.associatedDocumentsList[k].documentTypeName) == -1) {
                    this.documentTypeListOfAssosciatedDocs.push(this.associatedDocumentsList[k].documentTypeName);
                  }
                  for (let m = 0; m < this.dropDownFordocumentTypeList.length; m++) {
                    if (this.associatedDocumentsList[k].documentTypeName == this.dropDownFordocumentTypeList[m].documentTypeName) {
                      if (this.dropDownFordocumentTypeList[m].isAmendementDocType != "Y") {
                        this.associatedDocumentListForCheckout.push(this.associatedDocumentsList[k]);
                      }
                    }
                  }
                }
                for (let l = 0; l < this.documentTypeListOfAssosciatedDocs.length; l++) {
                  const list = [];
                  const key = this.documentTypeListOfAssosciatedDocs[l];
                  for (let j = 0; j < this.associatedDocumentsList.length; j++) {
                    if (this.associatedDocumentsList[j].documentTypeName == this.documentTypeListOfAssosciatedDocs[l]) {
                      list.push(this.associatedDocumentsList[j]);
                    }
                  }
                  this.documentsByDocTypeList[key] = list;
                }
              })
          }
          this.reason = null;
          this.checkoutcrId = null;
          this.checkoutcrNo = null;
          this.visibleConfirmWithReason = this.dialog.open(this.confirmWithReasonPopup, this.confirmWithReasonPopupConfig);
        } else if (button.text == "View") {
          this.documentData = this.rightClickData;
          this.appService.setParentFolderId(this.parentFolderId);
          this.isProcessing = true;
          this.appService.getDocumentByDocumentId(
            this.documentData.documentId, this.documentData.version).subscribe((data: any) => {
              this.documentData = data[0];
              this.appService.prevDocumentId = null;
              this.appService.prevDocVersion = null;
              this.documentData['opern'] = "View";
              this.isProcessing = false;

              this.router.navigate(['/dashboard/addDocument'], {
                state: {
                  documentData: this.documentData,
                  dropDownFordocumentTypeList: this.dropDownFordocumentTypeList
                }
              });
            })
        } else if (button.text.includes("Add")) {
          this.isRightClickAdd = true;
          this.documentDataForType = this.rightClickData;
          for (let i = 0; i < this.dropDownFordocumentTypeList.length; i++) {
            if (this.dropDownFordocumentTypeList[i].documentTypeName == this.documentDataForType.documentTypeName) {
              if (this.dropDownFordocumentTypeList[i].associatedDocToFollowSameExpiry == "Y") {
                this.documentTypeDataForParent = this.dropDownFordocumentTypeList[i];
                this.followSameExpDate1 = true;
              } else {
                this.followSameExpDate1 = false;
              }
              ;
            }
          }

          this.documentDataForDocType = {};
          this.previousFileName = "";
          this.loadInLoader = false;
          this.documentAddOptionForFolder = null;
          let data = button.text.split(" ");
          data = data.filter((obj: string) => { return obj !== "Add" });
          let docType = data.map((item: any) => item).join(" ");
          for (let i = 0; i < this.dropDownFordocumentTypeList.length; i++) {
            if (this.dropDownFordocumentTypeList[i].documentTypeName == docType) {
              this.appService.setDocumentTypeOfFolder(this.dropDownFordocumentTypeList[i].documentTypeCode);
              this.docTypToAddDocument = this.dropDownFordocumentTypeList[i].documentTypeCode;
            }
          }
          this.appService.setDocFolderTreeType('DOCTYPEADD');
          this.isAddDocForDocType = true;
          this.isShowAddPanel = false;
          this.showuploaddiv = false;
          this.isShowAddDocForDocType = false;
          this.documentDataForDocType['crId'] = null;
          this.documentDataForDocType['crNo'] = null;
          this.visibleAddDocForDocumentTypePopup = this.dialog.open(this.addDocumentForDocType, this.addDocForDocTypePopupConfig);
        } else if (button.text == "Issuance History") {
          this.columnList = [{ "name": "Issuance Type", "width": "150px" }, { "name": "Issuance Reason", "width": "180px" }, { "name": "Issued To", "width": "150px" },
          { "name": "Prints Taken", "width": "120px" }, { "name": "Status", "width": "120px" }, { "name": "Cover Page?", "width": "100px" }, { "name": "Revision History?", "width": "100px" },
          { "name": "Amendment?", "width": "100px" }, { "name": "Approval?", "width": "100px" }, { "name": "Associated documents?", "width": "100px" }, { "name": "Publisher Details", "width": "100px" }
            , { "name": "Watermark", "width": "180px" }, { "name": "Issued By", "width": "140px" }, { "name": "Issued On", "width": "140px" }]
          this.issuanceHistList = [];
          this.pagedItemsForIssHist = [];
          this.isProcessing = true;
          this.appService.getIssuanceHistory(this.rightClickData['documentId'],
            this.rightClickData['version']).subscribe((data: any) => {
              this.isProcessing = false;
              this.issuanceHistList = data;
              this.collectionSizeForPopup = this.issuanceHistList.length;
              this.pagerForIssHist.totalPages = undefined;
              this.setPageForIssHist(1, 0);
              this.visibleIssuanceHistPopup = this.dialog.open(this.issuanceHistoryPopup, this.issuanceHistoryPopupConfig)
            })
        } else if (button.text == "Redact") {
          this.documentData = this.rightClickData;
          this.comments = null;
          this.savedReportsList = [];
          this.isProcessing = true;
          this.appService.getDocumentByDocumentId(
            this.documentData.documentId, this.documentData.version).subscribe((data: any) => {
              this.documentData = data[0];
              this.isProcessing = false;
              if (this.documentData.documentExtn != null) {
                if (this.viewableExtensionsList.length > 0) {
                  for (let q = 0; q < this.viewableExtensionsList.length; q++) {
                    if (this.viewableExtensionsList[q].toUpperCase() == this.documentData.documentExtn.toUpperCase()) {
                      this.isViewableFile = false;
                      this.appService.getDocumentsToViewForDms(
                        this.documentData['documentId'], this.documentData['version']).subscribe((data: any) => {
                          this.loadDataInViewerForRedact(data, this.documentData.documentExtn);

                        })
                      this.visibleRedactPopup = this.dialog.open(this.redactPopup, this.redactPopupConfig);
                      break;
                    }

                  }
                } else {
                  this.isViewableFile = true;
                  alert("Viewable extensions is not maintained.");
                }

              }
            })

        } else if (button.text == "Download(Original)") {
          this.isPrintDownloadMode = false;
          this.isOnlyPreviewMode = true;
          this.selectedTemplateData = this.rightClickData;
          this.selectedTemplateData.module = "Document";
          this.downloadType = "single";
          this.reason = "";
          this.visibleDownloadTemplatePopup = this.dialog.open(this.downloadTemplatePopup, this.downloadTemplatePopupConfig);
        } else if (button.text == "Document History") {
          this.columnList = [{ "name": "Document No", "width": "120px" }, { "name": "Version", "width": "80px" }, { "name": "Name", "width": "140px" },
          { "name": "Description", "width": "180px" }, { "name": "Document Type", "width": "140px" }, { "name": "Status", "width": "120px" }, { "name": "Revision history", "width": "120px" },
          { "name": "Effective Date", "width": "120px" }, { "name": "Expiration Date", "width": "120px" }, { "name": "Extension", "width": "120px" },
          { "name": "Document Size", "width": "120px" }, { "name": "Parent document", "width": "120px" }, { "name": "Belongs To User", "width": "120px" },
          { "name": "CR Details", "width": "140px" }, { "name": "Is Distributed Folder?", "width": "120px" }, { "name": "Is Associated Document Type?", "width": "120px" },
          { "name": "Belongs To Individual?", "width": "120px" }, { "name": "Assignable At Trainings?", "width": "120px" }, { "name": "Checkout Flag", "width": "120px" },
          { "name": "Checkedin By", "width": "120px" }, { "name": "Checkedout On", "width": "120px" }, { "name": "Checkedout By", "width": "120px" },
          { "name": "Checkinout Comments", "width": "120px" }, { "name": "Is Latest Version?", "width": "120px" }, { "name": "Is Latest Published Version?", "width": "120px" }
            , { "name": "Is Blinded?", "width": "120px" }, { "name": "Blinded On", "width": "120px" }, { "name": "Published On", "width": "120px" }]
          this.documentHistList = [];
          this.moveHistList = [];
          this.pagedItemsForIssHist = [];
          this.isProcessing = true;
          this.appService.getDocumentHistory(this.rightClickData['documentId'],
            this.rightClickData['version']).subscribe((data: any) => {
              this.isProcessing = false;
              this.documentHistList = data;
              this.collectionSizeForRevision = this.documentHistList.length;
              this.pagerForRevision = {};
              this.currentPageRevision = 1;
              this.setPageForViewHist(1, 0);
              this.visibleDocumentHistPopup = this.dialog.open(this.documentHistoryPopup, this.documentHistoryPopupConfig)
            })

        } else if (button.text == "Move Document") {
          this.selectedFolderToMovDocData = {};
          this.isShowMovDocCommentField = false;
          this.reason = "";
          this.documentData = this.rightClickData;
          this.isProcessing = true;
          this.appService.getDmsFolderDataById(this.documentData.folderId)
            .subscribe((data: any) => {
              this.isProcessing = false;
              this.folderData = data[0];
            })
          this.buttonText = "Move Document";
          this.visibleMoveDocumentPopup = this.dialog.open(this.moveDocumentPopup, this.moveDocumentPopupConfig);
        } else if (button.text == "E-Signature") {
          this.openEsignature();
        } else if (button.text == "Properties") {
          this.isProcessing = true;
          this.appService.getDocumentByDocumentId(
            this.rightClickData.documentId, this.rightClickData.version).subscribe((data: any) => {
              this.appService.getDocumentVersionByDocId(this.rightClickData.documentId).subscribe((versionData: any) => {
                this.versionValueDropdown1 = versionData;
                this.selectBoxeForVersion();
                this.documentData = data[0];
                this.documentData['saveButtonForDocument'] = false;
                this.documentData['module'] = "DOCS";
                this.documentData.isBlinded = this.documentData.isBlinded == "Y" ? true : false;
                if (this.documentData.effectiveDate != null) {
                  this.documentData.effectiveDate = new Date(this.documentData.effectiveDate);
                }
                if (this.documentData.expirationDate != null) {
                  this.documentData.expirationDate = new Date(this.documentData.expirationDate);
                }
                this.isProcessing = false;
                this.selectedTabIndex = 0;
                this.visibleDocumentPropertiesPopup = this.dialog.open(this.documentPropertiesPopup, this.documentPropertiesPopupConfig);
                this.callForFlexifields();
                this.appService.getTaskStages(this.documentData['documentId'], this.documentData['version'])
                  .subscribe((data: any) => {
                    this.taskStagesList = data;
                    this.isProcessing = false;
                  })


                this.isProcessing = true;
                this.appService.getAssociatedDocumentsDetail(
                  this.documentData['documentId'], this.documentData['version']).subscribe((data: any) => {
                    this.isProcessing = false;
                    this.associatedDocumentsList = data;
                    this.associatedDocumentListForCheckout = [];
                    for (let k = 0; k < this.associatedDocumentsList.length; k++) {
                      if (this.documentTypeListOfAssosciatedDocs.indexOf(this.associatedDocumentsList[k].documentTypeName) == -1) {
                        this.documentTypeListOfAssosciatedDocs.push(this.associatedDocumentsList[k].documentTypeName);
                      }
                      for (let m = 0; m < this.dropDownFordocumentTypeList.length; m++) {
                        if (this.associatedDocumentsList[k].documentTypeName == this.dropDownFordocumentTypeList[m].documentTypeName) {
                          if (this.dropDownFordocumentTypeList[m].isAmendementDocType != "Y") {
                            this.associatedDocumentListForCheckout.push(this.associatedDocumentsList[k]);
                          }
                        }
                      }
                    }
                    for (let l = 0; l < this.documentTypeListOfAssosciatedDocs.length; l++) {
                      const list = [];
                      const key = this.documentTypeListOfAssosciatedDocs[l];
                      for (let j = 0; j < this.associatedDocumentsList.length; j++) {
                        if (this.associatedDocumentsList[j].documentTypeName == this.documentTypeListOfAssosciatedDocs[l]) {
                          list.push(this.associatedDocumentsList[j]);
                        }
                      }
                      this.documentsByDocTypeList[key] = list;
                    }
                  })

              })
            })
        }
    }
  }

  get isChildExpiryLaterThanParent(): boolean {
    const parentExpiry = this.parentExpiryDate ?? null;
    const childExpiry = this.extensionOrWithdrawData?.toBeExtendedTill
      ? new Date(this.extensionOrWithdrawData.toBeExtendedTill)
      : null;

    // Only compare if both are valid Date objects
    if (parentExpiry instanceof Date && childExpiry instanceof Date) {
      return childExpiry > parentExpiry;
    }

    return false; // Default case when one or both are missing
  }


  resetDownloadData() {
    this.documentIssuanceType = [];
    this.documentWatermark = null;
    this.documentNameForDownload = null;
    this.issuanceReason = null;
    this.issuanceTo = null;
    this.issuanceCopy = null;
    this.completeHistory = false;
    this.onLastPage = false;
    this.incudeRevisionhistory = false;
    this.incudeRevisionhistoryTitle = null;
    this.incudeCoverPgae = false;
    this.incudeCoverPgaeTitle = null;
    this.incudeAmendment = false;
    this.incudeAmendmentTitle = null;
    this.incudeApproval = false;
    this.incudeApprovalTitle = null;
    this.historyYear = null;
    this.isLatestOnTop = false;
    this.incudeFooter = false;
    this.incudePageNo = false;
    this.publisherDetails = false;
    this.linkedDocuments = false
    this.incudeNotes = false;
    this.incudeNotesTitle = null;
  }

  selectedTabIndex2: any = 0;
  getDocs(type: any) {
    return this.documentsByDocTypeList[type];
  }

  openEsignature() {
    // Fetch full document data — same pattern as "View" action in performOperationFunc
    this.isProcessing = true;
    this.appService.getDocumentByDocumentId(
      this.rightClickData.documentId,
      this.rightClickData.version
    ).subscribe((data: any) => {
      this.isProcessing = false;
      const fullDocumentData = data[0];

      // Navigate to E-Signature setup component
      // Router state passes document data + dropdown list
      // Received in EsignatureSetupComponent constructor via router.getCurrentNavigation()
      this.router.navigate(['/dashboard/esignatureSetup'], {
        state: {
          documentData: fullDocumentData,
          dropDownFordocumentTypeList: this.dropDownFordocumentTypeList
        }
      });
    }, (error: any) => {
      this.isProcessing = false;
      this.showSnackBar('Could not load document for E-Signature. Please try again.', 'E');
    });
  }

  taskStagesList: any = [];
  documentTypeListOfAssosciatedDocs: any = [];
  documentsByDocTypeList: any = [];
  associatedDocumentsList: any = [];
  associatedDocumentListForCheckout: any = [];
  downloadRedactedDoc(event: any) {
    this.visibleRedactConfirmationPopup.close();

    event.preventDefault();
    let contentData = this.redactedDocToDownload;
    let downloadLink = document.createElement("a");
    downloadLink.href = contentData;

    downloadLink.download = this.documentData.documentName + ".pdf";
    downloadLink.click();
  }

  downloadRedactedFile(data: any) {
    let contentData = "data:application/octet-stream;base64," + data.documentContent;
    let downloadLink = document.createElement("a");
    downloadLink.href = contentData;

    downloadLink.download = data.statusWhenItsGenerated + "_" + data.documentType + "." + data.documentExtn;
    downloadLink.click();
  }

  cancelSavedReportPopup() {
    this.visibleSavedReportPopup.close();
  }

  openRedactDocFunc() {
    this.visibleSavedReportPopup = this.dialog.open(this.savedReportPopup, this.savedReportPopupConfig);
  }

  historyYear: any = null;
  validateYear(event: any) {
    if (event.key === 'e' || event.key === 'E' || event.key === '+' || event.key === '-' || event.key === '.') {
      event.preventDefault();
    }
  }

  extensionOrWithdrawData: any = {};
  groupAllFolderList: any = [];
  groupUsersAllFolderList: any = [];
  isShowAddPanel: boolean = false;
  mapFolderOpenPopup() {
    this.isProcessing = true;
    this.appService.getDmsFolderDataById(this.parentFolderData.folderId)
      .subscribe((data: any) => {
        this.isProcessing = false;
        this.folderData = data[0];
      })
    this.visibleMapFolderPopup = this.dialog.open(this.mapFolderPopup, this.mapFolderPopupConfig);
  }

  commentsCss: any;
  commnetsCssRequiredMsg: any;
  operationFieldValidation() {
    this.commentsCss = document.getElementById('comments') as HTMLInputElement;
    this.commnetsCssRequiredMsg = document.getElementById('comments-required-msg') as HTMLInputElement;

    if (this.comments == "") {
      this.commentsCss.style.border = '1px solid red';
      this.commnetsCssRequiredMsg.style.display = 'block';
    } else {
      this.commentsCss.style.border = 'none';
      this.commnetsCssRequiredMsg.style.display = 'none';
    }
  }

  confirmOkFunc() {
    this.isProcessing = true;
    if (this.comments == "") {
      this.operationFieldValidation();
      this.isProcessing = false;
    } else {
      let data = {

        folderId: this.rightClickData['folderId'],
        status: this.rightClickData['status'],
        action: this.buttonData.text,
        comments: this.comments
      }
      this.appService.performOperationForFolder(data).subscribe((Response: any) => {
        this.isProcessing = false;
        this.visibleConfirm.close();
        if (Response.resultType == "S") {

          this.getCall();
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      })
    }
  }

  cancelConfirmFunc() {
    this.visibleConfirm.close();
  }


  cancelDeleteFunction() {
    this.visibleDeletePopup.close();
  }
  deleteReason: any = "";
  deleteFiledValue: any;
  deleteFiledValueRequiredMsg: any;
  deleteValidation() {
    this.deleteFiledValue = document.getElementById('deleteTextarea') as HTMLInputElement;
    this.deleteFiledValueRequiredMsg = document.getElementById('deleteTextarea-required-msg') as HTMLInputElement;
    if (this.deleteReason == '') {
      this.isProcessing = false;
      this.deleteFiledValue.style.border = '1px solid red';
      this.deleteFiledValueRequiredMsg.style.display = 'block';
    } else {
      this.deleteFiledValue.style.border = 'none';
      this.deleteFiledValueRequiredMsg.style.display = 'none';
    }
  }

  deleteFunction() {
    this.isProcessing = true;
    if (this.deleteReason == '') {
      this.deleteValidation();
      this.isProcessing = false;
    } else {
      if (this.title == "Delete Folder") {
        delete this.folderData.createdOn;
        delete this.folderData.updatedOn;
        this.folderData.isDistributedFolder = this.folderData.isDistributedFolder ? "Y" : "N";
        this.folderData.deleteReason = this.deleteReason;
        this.appService.deleteDmsFolder(this.folderData).subscribe((Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.visibleDeletePopup.close();
            this.getCall();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });

        }, (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        });
      } else {
        delete this.documentData.createdOn;
        delete this.documentData.updatedOn;
        this.documentData.deleteReason = this.deleteReason;
        this.appService.deleteDmsDocuments(this.documentData).subscribe((Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.visibleDeletePopup.close();
            this.getCall();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });

        }, (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        });
      }

    }
  }

  searchDocumentParentCheckBox: boolean = false;
  isLatestOnTop: boolean = true;
  searchDocumentChildCheckBoxs: boolean = false;
  searchDocumentChildCheckBoxsMenu: boolean = false;

  searchDocumentDataGridParentCheckBoxChecked(e: any) {

    if (e.target.checked == true) {

      for (let k = 0; k < this.getDmsDocumentsVwDetailsTableData.length; k++) {
        this.getDmsDocumentsVwDetailsTableData[k].searchDocumentChildCheckBoxs = true;
      }

    } else {
      for (let k = 0; k < this.getDmsDocumentsVwDetailsTableData.length; k++) {
        this.getDmsDocumentsVwDetailsTableData[k].searchDocumentChildCheckBoxs = false;
      }

    }
  }

  getSelectedDocumentId: any;
  getSelectedDocumentName: String;
  searchDocumentChildCheckBoxChecked(e: any, listOfDocumentsVwDetails: any, idx: any) {

    if (e.target.checked) {
      listOfDocumentsVwDetails.searchDocumentChildCheckBoxs = true;
      this.getSelectedDocumentId = listOfDocumentsVwDetails.documentId;
      this.getSelectedDocumentName = listOfDocumentsVwDetails.documentName;
    } else {
      listOfDocumentsVwDetails.searchDocumentChildCheckBoxs = false;
      this.getSelectedDocumentId = null;
      this.getSelectedDocumentName = '';
    }

  }

  showDocumentsSearchGrid: boolean;
  searchByDocumentId: any = null;
  searchByDocumetnName: any = null;
  searchByDocumentType: any = [];
  documentTypeValue: any;
  searchDmsDocumentsVwDetails: any;
  getDmsDocumentsVwDetailsTableData: any = [];
  popupDataTitle = {
    title: ""
  }
  selectedIssuanceAddType: any;
  searchDocumentFunction() {
    this.searchDocumentChildCheckBoxs = false;
    this.showDocumentsSearchGrid = false;
    this.searchByDocumentId = null;
    this.searchByDocumetnName = null;
    this.searchByDocumentType = [];
    this.popupDataTitle.title = "Search Document";
    this.visibleSearchDocumentPopup = this.dialog.open(this.searchDocument, this.searchDocumentConfig);
  }

  radioButtonDownloadChange(data: MatRadioChange) {
    this.selectedOptionforDownload = data.value;
    if (data.value == 'Issue Document') {
      this.documentWatermark = "";
      this.documentNameForDownload = "";
      this.resetDownloadData();
      this.completeHistory = true;
      this.isProcessing = true;

      this.typeDmsDocumentsVw = {
        documentId: this.rightClickData.documentId,
        version: this.rightClickData.version,

      };
      this.appService.getDocumentType(this.typeDmsDocumentsVw).subscribe((responsedata: any) => {
        this.isProcessing = false;
        this.documentIssuanceTypeDropdown = [];
        this.documentIssuanceTypeList = responsedata;

        for (let i = 0; i < this.documentIssuanceTypeList.length; i++) {
          this.documentIssuanceTypeDropdown = this.documentIssuanceTypeDropdown.concat({
            valueExp: this.documentIssuanceTypeList[i],
            displayExp: this.documentIssuanceTypeList[i]
          });
        }
      })
      this.documentIssuanceTypeAddDropdown = [];
      for (let i = 0; i < this.documentIssuanceTypeAddList.length; i++) {
        this.documentIssuanceTypeAddDropdown = this.documentIssuanceTypeAddDropdown.concat({
          valueExp: this.documentIssuanceTypeAddList[i],
          displayExp: this.documentIssuanceTypeAddList[i],
          isChecked: false,
          title: this.documentIssuanceTypeAddList[i]
        });
      };

      this.documentIssuanceTypeIncludeDropdown = [];
      for (let i = 0; i < this.documentIssuanceTypeIncludeList.length; i++) {
        this.documentIssuanceTypeIncludeDropdown = this.documentIssuanceTypeIncludeDropdown.concat({
          valueExp: this.documentIssuanceTypeIncludeList[i],
          displayExp: this.documentIssuanceTypeIncludeList[i]
        });
      }

    } else {
      this.documentWatermark = "";
      this.documentNameForDownload = "";
      this.resetDownloadData();
      this.completeHistory = true;
    }



  }
  documentIssuanceTypeAddDropdown: any = [];
  documentIssuanceAddType: any;
  documentIssuanceTypeAddList: any = ["Cover page / Sign", "Revision history", "Amendment", "Approval"];
  documentIssuanceTypeIncludeList: any = ["Footer", "Page Number", "Publisher details", "Linked documents", "Notes"];

  documentIssuanceTypeIncludeDropdown: any = [];

  addDocumentFunction() {
    this.placeholderData.associatedDocumentId = this.selectedFolderForCreateDoc.documentId;
    this.placeholderData.associatedDocumentName = this.selectedFolderForCreateDoc.documentName;
    this.visibleSearchDocumentPopup.close();
  }

  cancelSearchDocumentFunction() {
    this.getSelectedDocumentId = null;
    this.getSelectedDocumentName = '';
    this.visibleSearchDocumentPopup.close();
  }

  searchDocumentGridDataFunction() {
    this.isProcessing = true;
    if (this.searchByDocumentType.length > 0) {
      this.documentTypeValue = this.searchByDocumentType[0].valueExp;
    } else {
      this.documentTypeValue = null;
    }
    this.searchDmsDocumentsVwDetails = {

      documentId: this.searchByDocumentId,
      documentName: this.searchByDocumetnName,
      documentType: this.documentTypeValue,
    };
    this.appService.searchDocuments(this.searchDmsDocumentsVwDetails).subscribe((response: any) => {
      this.getDmsDocumentsVwDetailsTableData = response;
      this.showDocumentsSearchGrid = true;
      this.isProcessing = false;
    })
  }

  resetSearchDocumentGridDataFunction() {
    this.isProcessing = true;
    this.searchByDocumentId = null;
    this.searchByDocumetnName = null;
    this.documentTypeValue = "";
    this.showDocumentsSearchGrid = false;
    this.isProcessing = false;
  }

  onSearchDocTypeSelect(item: any) {
    this.documentTypeValue = item.valueExp;
  }

  onSearchDocTypeRemoved(item: any) {
    this.documentTypeValue = "";
  }

  addAndEditPlaceholderFunction(data: any) {
    this.isProcessing = true;
    if (this.placeholderData['documentName'] == "" || !this.selectedPlaceholderDocumentType
      || (this.isCrFeildIsMandatory && this.placeholderData.crNo == null) || (this.isVersionManually && (this.placeholderData.version == "" || this.placeholderData.version == null))
      || (this.isDocumentNoManually && (this.placeholderData.documentNo == "" || this.placeholderData.documentNo == null))) {
      this.placeholderFieldValidation();
      this.isProcessing = false;
    } else {
      if (this.operationFlag == "ADD") {

        data.documentTypeCode = this.selectedPlaceholderDocumentTypeValue;
        data.isBlinded = this.placeholderData.isBlinded1 ? "Y" : "N";
        data.folderId = this.parentFolderId;
        data.docOrPlaceholder = "PLACEHOLDER";
        const formData = new FormData();
        let document: File | any = '';
        formData.append('file', document ? '' : document);
        const json = JSON.stringify(data);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        formData.append('dmsDocumentDto', blob);
        this.isProcessing = true;
        this.appService.createDmsDocument(formData).subscribe((Response: any) => {
          this.isProcessing = false;
          if (Response.resultType == "S") {
            this.isBeforeSaveUploadDiffFile = false;
            let documentId = Response.documentId;
            this.placeholderFieldValidation();
            this.getCall();
            this.visibleAddAndEditPlaceholderPopup.close();

          } else {
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        });
      } else {

        data.documentTypeCode = this.selectedDocumentTypeValue;
        data.isBlinded = this.documentData.isBlinded1 ? "Y" : "N";
        data.folderId = this.parentFolderId;
        const formData = new FormData();
        formData.append('file', '');
        const json = JSON.stringify(data);
        const blob = new Blob([json], {
          type: 'application/json'
        });
        formData.append('dmsDocumentDto', blob);
        this.isProcessing = true;
        this.appService.updateDmsDocument(formData).subscribe((Response: any) => {
          this.isProcessing = false;
          if (Response.resultType == "S") {
            this.placeholderFieldValidation();
            this.getCall();
            this.visibleAddAndEditPlaceholderPopup.close();

          } else {
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        });
      }

    }
    setTimeout(() => {
      this.isProcessing = false;
    }, 3000);
  }


  placeholderName: any;
  documentTypeForPlaceholder: any;
  placeholderNameRequiredMsg: any;
  descriptionForPlaceholder: any;
  belongsToUserForPlaceholder: any;
  crFeildForPlaceholder: any;
  versionForPlaceholder: any;
  documentNoForPlaceholder: any;
  documentTypeRequiredMsgForPlaceholder: any;
  belongsToUserRequiredMsgForPlaceholder: any;
  descriptionRequiredMsgForPlaceholder: any;
  crFieldRequiredMsgForPlaceholder: any;
  versionForPlaceholderRequiredMsg: any;
  documentNoForPlaceholderRequiredMsg: any;
  placeholderFieldValidation() {
    this.placeholderName = document.getElementById('placeholderName') as HTMLInputElement;
    this.placeholderNameRequiredMsg = document.getElementById('placeholderName-required-msg') as HTMLInputElement;
    this.documentTypeForPlaceholder = document.getElementById('documentTypeForPlaceholder') as HTMLInputElement;
    this.descriptionForPlaceholder = document.getElementById('descriptionForPlaceholder') as HTMLInputElement;
    this.belongsToUserForPlaceholder = document.getElementById('belongsToUserForPlaceholder') as HTMLInputElement;
    this.crFeildForPlaceholder = document.getElementById('crForPlaceholder') as HTMLInputElement;
    this.documentTypeRequiredMsgForPlaceholder = document.getElementById('documentTypeForPlaceholder-required-msg') as HTMLInputElement;
    this.belongsToUserRequiredMsgForPlaceholder = document.getElementById('belongsToUserForPlaceholder-required-msg') as HTMLInputElement;
    this.descriptionRequiredMsgForPlaceholder = document.getElementById('descriptionForPlaceholder-required-msg') as HTMLInputElement;
    this.crFieldRequiredMsgForPlaceholder = document.getElementById('crForPlaceholder-required-msg') as HTMLInputElement;

    if (this.placeholderData.documentName == "") {
      this.placeholderName.style.border = '1px solid red';
      this.placeholderNameRequiredMsg.style.display = 'block';
    } else {
      this.placeholderName.style.border = 'none';
      this.placeholderNameRequiredMsg.style.display = 'none';
    }



    if (!this.selectedPlaceholderDocumentType) {
      this.documentTypeForPlaceholder.style.border = '1px solid red';
      this.documentTypeRequiredMsgForPlaceholder.style.display = 'block';
    } else {
      this.documentTypeForPlaceholder.style.border = 'none';
      this.documentTypeRequiredMsgForPlaceholder.style.display = 'none';
    }

    if (this.isCrFeildIsMandatory) {
      if (this.placeholderData.crNo == null) {
        this.crFeildForPlaceholder.style.border = '1px solid red';
        this.crFieldRequiredMsgForPlaceholder.style.display = 'block';
      } else {
        this.crFeildForPlaceholder.style.border = 'none';
        this.crFieldRequiredMsgForPlaceholder.style.display = 'none';
      }
    }

    if (this.isVersionManually) {
      this.versionForPlaceholder = document.getElementById('version') as HTMLInputElement;
      this.versionForPlaceholderRequiredMsg = document.getElementById('version-required-msg') as HTMLInputElement;
      if (this.placeholderData.version == null || this.placeholderData.version == "") {
        this.versionForPlaceholder.style.border = '1px solid red';
        this.versionForPlaceholderRequiredMsg.style.display = 'block';
      } else {
        this.versionForPlaceholder.style.border = 'none';
        this.versionForPlaceholderRequiredMsg.style.display = 'none';
      }
    }

    if (this.isDocumentNoManually) {
      this.documentNoForPlaceholder = document.getElementById('documentNo') as HTMLInputElement;
      this.documentNoForPlaceholderRequiredMsg = document.getElementById('documentNo-required-msg') as HTMLInputElement;
      if (this.placeholderData.documentNo == null || this.placeholderData.documentNo == "") {
        this.documentNoForPlaceholder.style.border = '1px solid red';
        this.documentNoForPlaceholderRequiredMsg.style.display = 'block';
      } else {
        this.documentNoForPlaceholder.style.border = 'none';
        this.documentNoForPlaceholderRequiredMsg.style.display = 'none';
      }
    }

  }

  isSingleClick: Boolean = true;
  openDocumentFunc(object: any) {
    this.isSingleClick = true;
    setTimeout(() => {
      if (this.isSingleClick) {

      }
    }, 250)
  }

  changeInChild(event: any) {
    if (event) {
      if (this.visibleSDownloadPopup != undefined) {
        this.visibleSDownloadPopup.close();
      }
      if (this.visibleRedactConfirmationPopup != undefined) {
        this.visibleRedactConfirmationPopup.close();
      }
    }
  }

  chooseOptionOfAdd(option: any) {
    if (option == "Add Manually" || option == "Add From Template") {
      this.addDocumentFunc();
      this.visibleAddAndEditPlaceholderPopup.close();
    } else {
      this.isProcessing = true;
      this.appService.getDocumentPrivUser(this.parentFolderId).subscribe((data: any) => {
        this.isProcessing = false;
        this.userPrivData = data[0];
        if (this.userPrivData.blinded == "Y") {
          this.iSBlindTheDoc = true;
        }
      })
      this.isShowAssociatedDocumentFieldForPlaceholder = false;
      this.isShowUserBelongsToFieldForPlaceholder = false;
      this.isShowCrFieldsForPlaceholder = false;
      this.isShowIsBlindedFlagForPlaceholder = false;
    }
  }

  cancelPropertiesPopupFunction() {
    this.visiblePropertiesPopup.close();
  }
  collectionSizeForPopup: any;
  onTabChanged($event: any) {
    let data = $event.tab.textLabel;
    this.tabName = data;
    if (data == "Folder User Privilege") {
      this.columnList = [{ "name": "User or Role", "width": "200px" }, { "name": "Folder Administrator", "width": "150px" }, { "name": "Author", "width": "100px" },
      { "name": "Reviewer", "width": "100px" }, { "name": "Approver", "width": "100px" }, { "name": "QA", "width": "100px" }, { "name": "Training Coordinator", "width": "100px" },
      { "name": "Publisher", "width": "100px" }, { "name": "Blinded", "width": "100px" }, { "name": "Blindbreak", "width": "100px" }, { "name": "Redactor", "width": "100px" },
      { "name": "Downloader", "width": "100px" }, { "name": "Viewer", "width": "100px" }, { "name": "Authorizer", "width": "100px" }, { "name": "Extension Reviewer", "width": "140px" },
      { "name": "Extension Approver", "width": "140px" }, { "name": "Withdrawal Reviewer", "width": "140px" }, { "name": "Withdrawal Approver", "width": "140px" }, { "name": "Destruction Reviewer", "width": "150px" },
      { "name": "Destruction Approver", "width": "150px" }, { "name": "Printer", "width": "100px" },
      { "name": "Current Version Viewer", "width": "160px" }]
      if (this.groupUsersAllFolderList.length == 0) {
        this.isProcessing = true;
        this.appService.getGroupUserPrivForFolders(this.rightClickData['folderId'])
          .subscribe((data: any) => {
            this.groupUsersAllFolderList = data;
            this.isProcessing = false;
            this.collectionSizeForPopup = this.groupUsersAllFolderList.length;
            this.pagerForPopup.totalPages = undefined;
            this.setPageForPopup(1, 0, this.groupUsersAllFolderList);
          })
      } else {

        this.collectionSizeForPopup = this.groupUsersAllFolderList.length;
        this.pagerForPopup.totalPages = undefined;
        this.setPageForPopup(1, 0, this.groupUsersAllFolderList);
      }

    } else {
      this.columnList = [{ "name": "Group", "width": "350px" }, { "name": "Priviledge Type", "width": "300px" }, { "name": "Assigned On", "width": "250px" },
      { "name": "Assigned By", "width": "250px" }]
      this.collectionSizeForPopup = this.groupAllFolderList.length;
      this.pagerForPopup.totalPages = undefined;
      this.setPageForPopup(1, 0, this.groupAllFolderList);
    }
  }


  closepdfviwer() {
    this.isBeforeSaveUploadDiffFile = true;
    this.showuploaddiv = false;
    this.isShowToUploadDiffFile = false;
    this.viewerValue.style.display = 'none';
  }

  isBeforeSaveUploadDiffFile: any = false;
  downloadTemplateData: any;
  downloadtemplate(event: any) {
    event.preventDefault();
    let contentData = "";
    if (this.documentData.documentId == null || this.documentData.documentId == undefined) {
      if (this.documentData.templateName != null && this.documentData.templateName != undefined && this.documentData.templateName != "") {
        const blob = new Blob([this.downloadTemplateData.body]);
        let url = URL.createObjectURL(blob);
        contentData = url;
      } else {

        const blob = new Blob([this.downloadTemplateData.body]);
        let url = URL.createObjectURL(blob);
        contentData = url;
      }
    } else {

      if (this.isBeforeSaveUploadDiffFile) {

        const blob = new Blob([this.downloadTemplateData.body]);
        let url = URL.createObjectURL(blob);
        contentData = url;
      } else {
        const blob = new Blob([this.document.body]);
        let url = URL.createObjectURL(blob);
        contentData = url;
      }

    }

    let downloadLink = document.createElement("a");
    downloadLink.href = contentData;
    downloadLink.download = this.previousFileName;
    downloadLink.click();
  }

  onTabChanged1(event: any) {

  }

  extensionOrWithdrawn: any;
  crForExtnCss: any;
  extensionOrWithdrawnRequiredMsg: any;
  crForExtnReqdMsg: any;
  extensionOrWithdrawnFieldValidation() {
    this.extensionOrWithdrawn = document.getElementById('extedOrWithdrawReason') as HTMLInputElement;
    this.crForExtnCss = document.getElementById('crForExtn') as HTMLInputElement;
    this.extensionOrWithdrawnRequiredMsg = document.getElementById('extedOrWithdrawReason-required-msg') as HTMLInputElement;
    this.crForExtnReqdMsg = document.getElementById('crForExtn-required-msg') as HTMLInputElement;

    if (this.extensionOrWithdrawData.reason == null || this.extensionOrWithdrawData.reason === "") {
      this.extensionOrWithdrawn.style.border = '1px solid red';
      this.extensionOrWithdrawnRequiredMsg.style.display = 'block';
    } else {
      this.extensionOrWithdrawn.style.border = 'none';
      this.extensionOrWithdrawnRequiredMsg.style.display = 'none';
    }

    if (this.isCrFeildIsMandatory) {
      if (this.extensionOrWithdrawData.crNo == null) {
        this.crForExtnCss.style.border = '1px solid red';
        this.crForExtnReqdMsg.style.display = 'block';
      } else {
        this.crForExtnCss.style.border = 'none';
        this.crForExtnReqdMsg.style.display = 'none';
      }
    }
  }

  addOrUpdateExtension(extensionData: any) {
    if (extensionData['reason'] == null || extensionData['reason'] === "" || (this.isCrFeildIsMandatory && extensionData.crId == null)) {
      this.extensionOrWithdrawnFieldValidation();
    } else {
      if (this.title == "Extend") {
        this.isProcessing = true;
        this.appService.addDocumentExtension(this.extensionOrWithdrawData).subscribe((data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.visibleSExtensionPopup.close();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        });
      } else if (this.title == "Destruct") {
        this.isProcessing = true;
        this.appService.addDocumentDestruction(this.extensionOrWithdrawData).subscribe((data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.visibleSExtensionPopup.close();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        });
      } else {
        this.isProcessing = true;

        this.appService.addDocumentWithdrawal(this.extensionOrWithdrawData).subscribe((data: any) => {
          this.isProcessing = false;
          if (data.resultType == "S") {
            this.visibleSExtensionPopup.close();
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        }, (error) => {
          this.displayMessage = error;
          this.displaySuccessMessage = false;
          this.displayErrorMessage = true;
          this.isProcessing = false;
          throw error;
        });
      }
    }


  }

  cancelExtensionFunction() {
    this.visibleSExtensionPopup.close();
    this.visibleSDownloadPopup.close();
  }
  @ViewChild('searchCr', { static: true }) searchCr: TemplateRef<any>;
  visibleSearchCrPopup: MatDialogRef<TemplateRef<any>>;

  searchCrConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  selectedCrGroup: any = null;
  qmsGroupsList: any = [];
  checkoutcrId: any = null;
  checkoutcrNo: any = null;
  crValue: any = null;
  searchCrFunction(data: any) {
    this.selectedCrGroup = null;
    this.selectedCrGroupValue = null;
    this.searchedCrList = [];
    this.crValue = data;
    this.qmsGroupsList = [];
    this.appService.getQmsGroups().subscribe((data: any) => {
      for (let i = 0; i < data.length; i++) {
        if (data[i].modules.includes('CR')) {
          this.qmsGroupsList.push(data[i]);
        }
      }

      this.selectedCrGroup = null;
      this.selectBoxeForGroupValue();

    })
    this.isShowSearchedCrGrid = false;
    this.visibleSearchCrPopup = this.dialog.open(this.searchCr, this.searchCrConfig);
  }
  groupValueDropdown: any = [];
  selectedCrGroupValue: any = null;
  selectBoxeForGroupValue() {
    this.groupValueDropdown = [];
    for (let i = 0; i < this.qmsGroupsList.length; i++) {
      this.groupValueDropdown.push({
        valueExp: this.qmsGroupsList[i].groupId,
        displayExp: this.qmsGroupsList[i].groupName
      });
    }
  }

  onGroupValueSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.selectedCrGroupValue = item.valueExp;
      }
    }
  }

  onGroupValueSelectOld(item: any) {
    this.selectedCrGroupValue = item.valueExp;
  }

  onGroupValueRemoved(item: any) {

  }

  gridResetFunction() {
    this.searchedCrList = [];
    this.selectedCrGroup = null;
    this.selectedCrGroupValue = null;
  }

  isShowSearchedCrGrid = false;
  searchedCrList: any = [];
  seachCrForDocumentsFunc() {
    if (this.selectedCrGroupValue == null || this.selectedCrGroupValue == "") {
      this.groupFieldValidation();
    } else {
      this.isShowSearchedCrGrid = true;
      this.isProcessing = true;
      this.appService.getCrForDocuments(this.selectedCrGroupValue)
        .subscribe((data: any) => {
          this.searchedCrList = data;
          this.isProcessing = false;
        })
    }
  }

  groupCss: any;
  groupCssReqdMsg: any;
  groupFieldValidation() {
    this.groupCss = document.getElementById('groupSearch') as HTMLInputElement;
    this.groupCssReqdMsg = document.getElementById('groupSearch-required-msg') as HTMLInputElement;

    if (this.selectedCrGroupValue == null || this.selectedCrGroupValue == "") {
      this.groupCss.style.border = '1px solid red';
      this.groupCssReqdMsg.style.display = 'block';
    } else {
      this.groupCss.style.border = 'none';
      this.groupCssReqdMsg.style.display = 'none';
    }
  }

  getSelectedCrNo: any = null
  getSelectedCrId: any = null
  searchCrChildCheckBoxChecked(e: any, cr: any, index: any) {
    if (e.target.checked) {
      cr.searchCrChildCheckBoxs = true;
      this.getSelectedCrNo = cr.crNo;
      this.getSelectedCrId = cr.crId;
      if (this.crValue == "Document") {
        this.isProcessing = true;
        this.appService.getCrCountForDoc(cr.crNo).subscribe((data: any) => {
          this.isProcessing = false;
          if (data > 0) {
            this.warningMsg = "The selected CR is already assigned to different document.";
            this.visibleCrInfoPopup = this.dialog.open(this.infoPopup, this.crInfoPopupConfig);
          }
        })
      }
    } else {
      cr.searchCrChildCheckBoxs = false;
      this.getSelectedCrNo = null;
      this.getSelectedCrId = null;
    }
  }


  addCrFunction() {
    if (this.crValue == "Document") {
      this.documentDataForDocType.crNo = this.getSelectedCrNo;
      this.documentDataForDocType.crId = this.getSelectedCrId;
    } else if (this.crValue == "Placeholder") {
      this.placeholderData.crNo = this.getSelectedCrNo;
      this.placeholderData.crId = this.getSelectedCrId;
    } else if (this.crValue == "Checkout") {
      this.checkoutcrNo = this.getSelectedCrNo;
      this.checkoutcrId = this.getSelectedCrId;
    } else {
      this.extensionOrWithdrawData.crNo = this.getSelectedCrNo;
      this.extensionOrWithdrawData.crId = this.getSelectedCrId;
    }

    this.visibleSearchCrPopup.close();
  }

  cancelCrFunction() {
    this.visibleSearchCrPopup.close();
  }
  downloadForrevisonHistory(data: any) {

    this.isProcessing = true;
    let obj = {

      documentId: this.rightClickData.documentId,
      version: this.rightClickData.version,
      documentTypeCode: this.documentIssuanceIncludeType,
      printParentDetails: "Y",
      effectiveDate: this.rightClickData.effectiveDate,
      expirationDate: this.rightClickData.expirationDate,
      documentName: this.rightClickData.documentName,
      documentNo: this.rightClickData.documentNo,
      parentDocId: this.rightClickData.associatedDocumentId,
      incudeCoverPgae: this.incudeCoverPgae,
      incudeCoverPgaeTitle: this.incudeCoverPgaeTitle,
      incudeRevisionhistory: this.incudeRevisionhistory,
      incudeRevisionhistoryTitle: this.incudeRevisionhistoryTitle,
      incudeFooter: this.incudeFooter,
      incudeFooterTitle: this.incudeFooterTitle,
      incudeAmendment: this.incudeAmendment,
      incudeAmendmentTitle: this.incudeAmendmentTitle,
      incudeApproval: this.incudeApproval,
      incudeApprovalTitle: this.incudeApprovalTitle,
      watermarkMsg: this.documentWatermark,
      onLastPage: this.onLastPage,
      completeHistory: this.completeHistory,
      historyYear: this.historyYear,
      isLatestOnTop: this.isLatestOnTop,
      incudePageNo: this.incudePageNo,
      publisherDetails: this.publisherDetails,
      linkedDocuments: this.linkedDocuments ? false : this.linkedDocuments,
      watermarkColor: this.watermarkColor
    }
    this.appService.downloadDocumentsDmsrevision(obj, this.rightClickData.documentName).subscribe(
      (response: any) => {
        let dataType = response.type;
        let binaryData = [];
        binaryData.push(response);
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
        if (this.documentNameForDownload)
          downloadLink.setAttribute('download', this.documentNameForDownload);
        document.body.appendChild(downloadLink);
        downloadLink.click();
        this.isProcessing = false;
      })


  }

  downloadFordocument(data: any) {


    let obj = {

      documentId: this.rightClickData.documentId,
      version: this.rightClickData.version,
      documentTypeCode: this.documentIssuanceIncludeType,
      printParentDetails: "Y",
      effectiveDate: this.rightClickData.effectiveDate,
      expirationDate: this.rightClickData.expirationDate,
      documentName: this.rightClickData.documentName,
      documentNo: this.rightClickData.documentNo,
      parentDocId: this.rightClickData.associatedDocumentId,
      incudeCoverPgae: this.incudeCoverPgae,
      incudeCoverPgaeTitle: this.incudeCoverPgaeTitle,
      incudeRevisionhistory: this.incudeRevisionhistory,
      incudeRevisionhistoryTitle: this.incudeRevisionhistoryTitle,
      incudeFooter: this.incudeFooter,
      incudeFooterTitle: this.incudeFooterTitle,
      incudeAmendment: this.incudeAmendment,
      incudeAmendmentTitle: this.incudeAmendmentTitle,
      incudeApproval: this.incudeApproval,
      incudeApprovalTitle: this.incudeApprovalTitle,
      watermarkMsg: this.documentWatermark,
      onLastPage: this.onLastPage,
      completeHistory: this.completeHistory,
      historyYear: this.historyYear,
      isLatestOnTop: this.isLatestOnTop,
      incudePageNo: this.incudePageNo,
      publisherDetails: this.publisherDetails ? false : this.publisherDetails,
      incudeNotes: this.incudeNotes == null ? false : this.incudeNotes,
      incudeNotesTitle: this.incudeNotesTitle,
      linkedDocuments: this.linkedDocuments == null ? false : this.linkedDocuments,
      issuanceReason: this.issuanceReason,
      issuanceTo: this.issuanceTo,
      noOfCopy: this.issuanceCopy,
      watermarkColor: this.watermarkColor

    }
    this.callIssuancePkg(obj);
    this.isProcessing = true;
    this.isProcessing = false;
  }
  cancelMapFolder() {
    this.visibleMapFolderPopup.close();
  }

  cancelAddDocForDocType() {
    this.visibleAddDocForDocumentTypePopup.close();
  }

  callIssuancePkg(data1: any) {
    let object = {

      documentId: data1.documentId,
      version: data1.version,
      folderId: this.parentFolderId,
      issuanceType: data1.documentTypeCode,
      issuanceReason: this.issuanceReason,
      issuanceTo: this.issuanceTo,
      noOfCopy: this.issuanceCopy,
      coverPage: this.incudeCoverPgae ? "Y" : "N",
      revisionHistory: this.incudeRevisionhistory ? "Y" : "N",
      amendment: this.incudeAmendment ? "Y" : "N",
      approval: this.incudeApproval ? "Y" : "N",
      associatedDocuments: "N",
      publisherDetails: null,
      watermark: this.documentWatermark,
      issuanceId: null,
      downloadedFileName: this.rightClickData.documentName
    }
    this.isProcessing = true;
    this.appService.performIssuanceHistory(object).subscribe((data: any) => {
      this.isProcessing = false;
      if (data.resultType == "S") {
        data1.issuanceId = data.issuanceId;
        this.isProcessing = true;
        this.appService.downloadDocumentsDms(data1, this.rightClickData.documentName).subscribe(
          (response: any) => {
            let dataType = response.type;
            let binaryData = [];
            binaryData.push(response);
            let downloadLink = document.createElement('a');
            downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, { type: dataType }));
            if (this.documentNameForDownload)
              downloadLink.setAttribute('download', this.documentNameForDownload);
            document.body.appendChild(downloadLink);
            downloadLink.click();
            this.isProcessing = false;
          })

      } else {
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: data.result,
            type: data.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: data.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
      }
    })
  }

  model = {
    documentData: {},
  };
  selectedFolderForCreateDoc: any = {};
  documentAddOptionForFolder: any;
  documentDataForDocType: any = {
    expirationDate: Date
  }
  changeInFolderStructureChild(data: any) {
    this.model = data;
    this.selectedFolderForCreateDoc = this.model.documentData;
    this.isShowAddPanel = true;
    this.isAddDocForDocType = false;

  }

  selectedFolderToMovDocData: any = {};
  changeInFolderStructureChildForMove(data: any) {
    this.model = data;
    this.selectedFolderToMovDocData = this.model.documentData;
    this.isShowMovDocCommentField = true;

  }

  selectDiffFolderFunc() {
    this.isShowAddPanel = false;
    this.isAddDocForDocType = true;
    this.isVersionManuallyForDocType = false;
    this.isDocumentNoManuallyForDocType = false;
  }


  //Add Document to DocType Logic

  docTypToAddDocument: any;
  selectedOptionforDownload: any = "Revision History";



  @ViewChild('searchUser', { static: true }) searchUser: TemplateRef<any>;
  visibleSearchUserPopup: MatDialogRef<TemplateRef<any>>;

  searchUserConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  crInfoPopupConfig = {
    width: '500px',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };


  viewerValue: any;
  NotviewableValue: any;
  userPrivData: any = {};
  selectedDocumentTypeForDoc: any = null;
  iSBlindTheDoc: any;
  isShowAddDocForDocType = false;
  isShowViewerForDocType = false;
  isVersionManuallyForDocType = false;
  isDocumentNoManuallyForDocType = false;
  chooseOptionOfAddForDocType(data: any) {
    this.isProcessing = true;
    this.appService.getDmsFolderDataById(this.selectedFolderForCreateDoc.folderId)
      .subscribe((data: any) => {
        this.isProcessing = false;
        if (data[0].allowToInputDocumentNoManually == "Y") {
          this.isDocumentNoManuallyForDocType = true;
        } else {
          this.isDocumentNoManuallyForDocType = false;
        }
        if (data[0].allowToInputVersionManually == "Y") {
          this.isVersionManuallyForDocType = true;
        } else {
          this.isVersionManuallyForDocType = false;
        }
      })
    this.documentDataForDocType = {};
    if (data == "Add From Template" || data == "Add Manually") {
      this.isShowViewerForDocType = true;
      this.documentDataForDocType.addDocOrPlaceholder = "DOCUMENT";
    } else {
      this.document = null;
      this.isShowViewerForDocType = false;
      this.documentDataForDocType.addDocOrPlaceholder = "PLACEHOLDER";
    }
    this.selectedDocumentTypeForDoc = null;
    if (data == "Add From Template") {
      this.documentDataForDocType['addFrom'] = "Add From Template";
    } else {
      this.documentDataForDocType['addFrom'] = "Add Manually";
    }

    this.isShowAddDocForDocType = true;
    this.viewerValue = document.getElementById('viewerHideShow') as HTMLInputElement
    this.viewerValue.style.display = 'none';
    this.NotviewableValue = document.getElementById('isNotViewableFile') as HTMLInputElement
    this.NotviewableValue.style.display = 'block';
    this.documentDataForDocType['associatedDocumentName'] = this.rightClickData['documentName'];
    this.documentDataForDocType['associatedDocumentId'] = this.rightClickData['documentId'];
    this.documentDataForDocType['effectiveDate'] = null;
    this.documentDataForDocType['expirationDate'] = null;
    if (this.rightClickData.status === 'Published') {
      this.documentDataForDocType['crId'] = null;
      this.documentDataForDocType['crNo'] = null;
    } else {
      this.documentDataForDocType['crId'] = this.rightClickData['crDetails'];
      this.documentDataForDocType['crNo'] = this.rightClickData['crNo'];
    }
    this.appService.getDocumentPrivUser(this.parentFolderId).subscribe((data: any) => {
      this.userPrivData = data[0];
      if (this.userPrivData.blinded == "Y") {
        this.iSBlindTheDoc = true;
      }
    })
    if (this.docTypToAddDocument != null) {
      for (let i = 0; i < this.documentTypeDropdown.length; i++) {
        if (this.documentTypeDropdown[i].valueExp == this.docTypToAddDocument) {
          this.selectedDocumentTypeForDoc = this.documentTypeDropdown[i].valueExp
          this.ondocumentTypeForDocSelect({ isUserInput: true }, this.selectedDocumentTypeForDoc);
        }
      }
    }


  }

  flexifields: any = null;
  flexiFieldsList: any = [];
  selectedFlexifieldValue: any = [];
  flexifieldObj: any = {};
  isShowFlexifieldBlock = false;
  callForFlexifields() {
    for (let i = 0; i < this.dropDownFordocumentTypeList.length; i++) {
      if (this.dropDownFordocumentTypeList[i].documentTypeCode == this.documentData['documentTypeCode']) {
        this.flexifields = this.dropDownFordocumentTypeList[i].listOfFlexifields;
        break;
      }
    }
    if (this.flexifields != null) {
      let obj = {

        flexifieldIds: this.flexifields,
        module: "DOCS"
      }
      this.appService.getFlexifieldsListForDocument(obj).subscribe((data: any) => {
        this.flexiFieldsList = data;
        this.isShowFlexifieldBlock = true;
        for (let i = 0; i < this.flexiFieldsList.length; i++) {
          this.flexiFieldsList[i].dropDownValues = [];
          this.flexiFieldsList[i].dropdowns = [];
          this.flexiFieldsList[i].checkedCheckBoxValue = [];
          this.flexiFieldsList[i].selectedFlexifieldValue = [];
          if (this.flexiFieldsList[i].fieldType == "Drop Down" || this.flexiFieldsList[i].fieldType == "Horizontal Checkbox Button" || this.flexiFieldsList[i].fieldType == "Multiselect Drop Down" ||
            this.flexiFieldsList[i].fieldType == "Vertical Checkbox Button" || this.flexiFieldsList[i].fieldType == "Horizontal Radio Button" ||
            this.flexiFieldsList[i].fieldType == "Vertical Radio Button") {
            if (this.flexiFieldsList[i].fieldLovValues != null) {
              this.flexiFieldsList[i].dropDownValues = this.flexiFieldsList[i].fieldLovValues.split(",");
              for (let j = 0; j < this.flexiFieldsList[i].dropDownValues.length; j++) {
                this.flexiFieldsList[i].dropdowns = this.flexiFieldsList[i].dropdowns.concat({
                  valueExp: this.flexiFieldsList[i].dropDownValues[j],
                  displayExp: this.flexiFieldsList[i].dropDownValues[j]
                });
              }
            }
          }
        }
        if (this.documentData['documentId'] != null) {
          this.appService.getFlexifieldDataWithDocIdAndVersion(this.documentData['documentId'],
            this.documentData['version']).subscribe((data: any) => {
              if (data.length > 0) {
                this.flexifieldObj = data[0];
                for (let j = 0; j < this.flexiFieldsList.length; j++) {
                  if (this.flexiFieldsList[j].mappingColumn != null) {
                    let finalvariable = this.makeVariable(this.flexiFieldsList[j]);
                    if (data[0][finalvariable] != null) {
                      this.flexiFieldsList[j].recordId = data[0].recordId;
                      if (this.flexiFieldsList[j].fieldDatatype == "Date") {
                        this.flexiFieldsList[j].fieldDefaultValue = new Date(data[0][finalvariable]);
                      } else {
                        this.flexiFieldsList[j].fieldDefaultValue = data[0][finalvariable];
                      }


                      if (data[0][finalvariable] != null) {
                        if (this.flexiFieldsList[j].fieldType == "Drop Down") {
                          this.flexiFieldsList[j].selectedFlexifieldValue = [{
                            valueExp: data[0][finalvariable],
                            displayExp: data[0][finalvariable]
                          }];
                        } else if (this.flexiFieldsList[j].fieldType == "Multiselect Drop Down") {
                          let multiValues = data[0][finalvariable].toString().split(',');
                          let formattedValues = [];
                          for (let k = 0; k < multiValues.length; k++) {
                            formattedValues.push({
                              valueExp: multiValues[k],
                              displayExp: multiValues[k]
                            });
                          }
                          this.flexiFieldsList[j].selectedFlexifieldValue = formattedValues;
                        }
                      }


                      if (this.flexiFieldsList[j].fieldType == "Vertical Checkbox Button" || this.flexiFieldsList[j].fieldType == "Horizontal Checkbox Button") {
                        if (this.flexiFieldsList[j].fieldDefaultValue != null) {
                          this.flexiFieldsList[j].checkedCheckBoxValue = this.flexiFieldsList[j].fieldDefaultValue.split(",");
                        }
                      }
                    }
                  }
                }
              }
            })
        }
      })
    } else {
      this.isShowFlexifieldBlock = false;
    }

  }

  onFlexifieldSelect(item: any, data: any) {
    data.fieldDefaultValue = item.valueExp;
  }

  onFlexifieldRemoved(item: any) {

  }

  checkBoxChecked(data: any, event: any, val: any) {
    if (event.checked) {
      data.checkedCheckBoxValue.push(val);
    } else {
      let index = data.checkedCheckBoxValue.indexOf(val);
      data.checkedCheckBoxValue.splice(index, 1);
    }
  }

  checkBoxCheckedforadd(event: any, val: any) {
    val.isChecked = event.checked;

  }

  checkBoxisLatestOnTop(event: any) {
    this.isLatestOnTop = event.checked;

  }

  mandatoryCheck() {
    for (let i = 0; i < this.flexiFieldsList.length; i++) {
      if (this.flexiFieldsList[i].mappingColumn != null) {
        let finalVariable = this.makeVariable(this.flexiFieldsList[i]);
        if (this.flexiFieldsList[i].fieldType == "Horizontal Checkbox Button" || this.flexiFieldsList[i].fieldType == "Vertical Checkbox Button") {
          this.flexiFieldsList[i].fieldDefaultValue = null;
          for (let k = 0; k < this.flexiFieldsList[i].checkedCheckBoxValue.length; k++) {
            if (this.flexiFieldsList[i].fieldDefaultValue == null) {
              this.flexiFieldsList[i].fieldDefaultValue = this.flexiFieldsList[i].checkedCheckBoxValue[k];
            } else {
              this.flexiFieldsList[i].fieldDefaultValue = this.flexiFieldsList[i].fieldDefaultValue + "," + this.flexiFieldsList[i].checkedCheckBoxValue[k];
            }
          }

        }
      } else {

      }
      if (this.flexiFieldsList[i].fieldDefaultValue == null && this.flexiFieldsList[i].isMandatory == 'Y') {
        this.isMandatoryField = true;
      }
    }
    if (this.isMandatoryField) {
      this.isProcessing = false;
      this.flexifieldValidation();
    }
  }

  isMandatoryField = false;
  saveFlexifieldData() {
    this.isProcessing = true;
    let obj: any = {

      refId: this.documentData['documentId'],
      version: this.documentData['version'],

    }
    for (let i = 0; i < this.flexiFieldsList.length; i++) {
      if (this.flexiFieldsList[i].mappingColumn != null) {
        let finalVariable = this.makeVariable(this.flexiFieldsList[i]);
        obj[finalVariable] = this.flexiFieldsList[i].fieldDefaultValue;
      } else {

      }
      if (this.flexiFieldsList[i].fieldDefaultValue == null && this.flexiFieldsList[i].isMandatory == 'Y') {
        this.isMandatoryField = true;
      }
    }
    if (this.isMandatoryField) {
      this.isProcessing = false;
      this.flexifieldValidation();
    } else {
      if (this.flexifieldObj['recordId'] != null) {
        obj.recordId = this.flexifieldObj['recordId'];
        this.appService.updateFlexifieldData(obj).subscribe((data: any) => {

          if (data.resultType == "S") {
            this.isProcessing = false;
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        })
      } else {
        this.appService.addFlexifieldData(obj).subscribe((data: any) => {

          if (data.resultType == "S") {
            this.isProcessing = false;
          }
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: 5000,
            data: {
              message: data.result,
              type: data.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok"
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: data.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
          this.isProcessing = false;
        })
      }
    }

  }

  makeVariable(data: any) {
    let splittedData = data.mappingColumn.toLowerCase().split("_");
    for (let j = 1; j < splittedData.length; j++) {
      splittedData[j] = splittedData[j].charAt(0).toUpperCase() + splittedData[j].slice(1);
    }
    let finalvariable = splittedData.join('');
    return finalvariable;
  }

  flexifield: any;
  flexifieldNameRequiredMsg: any;
  flexifieldValidation() {
    for (let i = 0; i < this.flexiFieldsList.length; i++) {
      this.flexifield = document.getElementById('flexifield' + i) as HTMLInputElement;
      this.flexifieldNameRequiredMsg = document.getElementById('flexifield' + i + '-required-msg') as HTMLInputElement;

      if (this.flexiFieldsList[i].fieldDefaultValue == null && this.flexiFieldsList[i].isMandatory == 'Y') {
        this.flexifield.style.border = '1px solid red';
        this.flexifieldNameRequiredMsg.style.display = 'block';
      } else {
        this.flexifield.style.border = 'none';
        this.flexifieldNameRequiredMsg.style.display = 'none';
      }
    }

  }

  isShowUserBelongsToField = false;
  isShowCrFields: boolean = false;
  isCrFeildIsMandatory: boolean = false;
  documentTypeData: any;
  isShowIsBlindedFlag = false;
  templateData: any;
  isViewableFile = false;
  document: File | any;
  previousFileName: any = "";
  isDownloadTemplate: boolean = false;
  isShowViewer = false;
  selectedTabIndex = 0;

  snackBarRef: any;

  showSnackBar(message: string, type: string) {
    this.snackBarRef = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
      duration: 5000,
      data: {
        message,
        type: type === 'S' ? 'Success' : 'Warning!',
        buttonLabel: "Ok"
      },
      horizontalPosition: 'center',
      verticalPosition: 'top',
      panelClass: type === 'S' ? 'Success' : 'Error',
    });

    this.snackBarRef.onAction().subscribe(() => {
      this.snackBarRef.dismiss();
    });
  }

  ondocumentTypeForDocSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (item) {
        this.selectedDocumentTypeValue = item;
        this.isShowAssociatedDocumentField = false;
        this.isShowisAmendementDocType = false;
        this.isShowUserBelongsToField = false;
        this.isShowExpDate = false;
        this.documentDataForDocType['documentTypeCode'] = this.selectedDocumentTypeValue;
        for (const element of this.dropDownFordocumentTypeList) {
          if (element.documentTypeCode == item) {
            this.documentTypeData = element;
            if (element.isAssociatedDocumentType == "Y") {
              this.isShowAssociatedDocumentField = true;
            }
            if (element.isAmendementDocType == "Y") {
              this.isShowisAmendementDocType = true;
            }
            if (element.belongsToIndividual == "Y") {
              this.isShowUserBelongsToField = true;
            }
            if (element.isBlindable == "Y") {
              this.isShowIsBlindedFlag = true;
            }
            if (element.isExpiryApplicable == "Y") {
              this.isShowExpDate = true;
            }
            if (element.isAmendementDocType == "Y") {
              if (this.rightClickData['expirationDate'] != null) {
                this.documentDataForDocType['expirationDate'] = new Date(this.rightClickData['expirationDate']);
              }
            }
            if (element.crProcess == "Mandatory" || element.crProcess == "Non Mandatory") {
              this.isShowCrFields = true;
              if (element.crProcess == "Mandatory") {
                this.isCrFeildIsMandatory = true;
              }
            }
          }
        }
        if (this.followSameExpDate1) {
          if (this.isShowAssociatedDocumentField && !this.isShowisAmendementDocType) {
            this.documentDataForDocType['expirationDate'] = null;
          } else if (this.documentDataForDocType.expirationDate != null) {
            this.documentDataForDocType.expirationDate = new Date(this.documentDataForDocType.expirationDate);
          } else {
            this.selectExpValue1(new Date());
          }

        } else {
          if (this.isShowAssociatedDocumentField && !this.isShowisAmendementDocType) {
            this.documentDataForDocType['expirationDate'] = null;
          } else {
            this.selectExpValue(new Date());
          }
        }

        if (this.documentDataForDocType['addFrom'] == "Add From Template") {

          if (this.documentTypeData.templateId != null && this.documentTypeData.templateId != undefined) {
            this.isProcessing = true;
            this.appService.getDmsDocumentTemplateVwDetailsByTemplateId(this.documentTypeData.templateId)
              .subscribe((data: any) => {
                if (data.isActive == 'N') {
                  this.isProcessing = false;
                  this.isViewableFile = false;
                  this.showSnackBar("The template is Inactive", 'W');
                  return
                }
                this.isProcessing = false;
                this.templateData = data;
                this.isViewableFile = false;
                if (this.viewableExtensionsList.length > 0) {
                  for (const element of this.viewableExtensionsList) {
                    if (element.toUpperCase() == this.templateData.templateExtn.toUpperCase()) {
                      this.isViewableFile = false;
                      this.isProcessing = true;
                      this.appService.getDocumentTemplateToView(this.documentTypeData.templateId).subscribe((data: any) => {
                        this.isProcessing = false;
                        this.downloadTemplateData = data;
                        this.document = new Blob([this.templateData.template]);
                        this.documentDataForDocType.documentExtn = this.templateData.templateExtn;
                        this.documentDataForDocType.templateName = this.templateData.templateName;
                        this.previousFileName = this.templateData.templateName + "." + this.templateData.templateExtn;
                        this.loadDataInViewer(data, this.templateData.templateExtn);
                        this.isDownloadTemplate = true;
                      })

                      break;
                    } else {
                      this.isViewableFile = true;
                      this.isShowToUploadDiffFile = true;
                      this.NotviewableValue.style.display = 'none';
                      this.isDownloadTemplate = false;
                    }

                  }
                } else {
                  this.isViewableFile = true;
                  this.isShowToUploadDiffFile = true;
                  this.NotviewableValue.style.display = 'none';
                  this.isDownloadTemplate = false;
                }

              })

          } else {
            this.NotviewableValue = document.getElementById('isNotViewableFile') as HTMLInputElement
            this.NotviewableValue.style.display = 'block';
          }
        }
        this.callForFlexifields();
      } else {
        [
          this.selectedDocumentTypeValue,
          this.isShowCrFields,
          this.isShowIsBlindedFlag,
          this.isShowAssociatedDocumentField,
          this.isShowUserBelongsToField
        ] = ['', false, false, false, false]
      }
    }
  }


  selectExpValue(date: Date) {
    if (this.documentTypeData.expiryInUnit != null) {
      this.documentDataForDocType['expirationDate'] = new Date();
      this.documentDataForDocType['expirationDate'].setDate(date.getDate());
      this.documentDataForDocType['expirationDate'].setMonth(date.getMonth());
      this.documentDataForDocType['expirationDate'].setFullYear(date.getFullYear());

      if (this.documentTypeData.expiryInUnit == "Days") {
        this.documentDataForDocType['expirationDate'].setDate(date.getDate() + this.documentTypeData.expiryIn);
      } else if (this.documentTypeData.expiryInUnit == "Month") {
        this.documentDataForDocType['expirationDate'].setMonth(date.getMonth() + this.documentTypeData.expiryIn);
      } else {
        this.documentDataForDocType['expirationDate'].setFullYear(date.getFullYear() + this.documentTypeData.expiryIn);
      }
    }
  }
  documentTypeData1: any;
  selectExpValue1(date: Date) {
    this.documentTypeData1 = this.documentTypeDataForParent;
    if (this.documentTypeData1.expiryInUnit != null) {
      this.documentDataForDocType['expirationDate'] = new Date();
      this.documentDataForDocType['expirationDate'].setDate(date.getDate());
      this.documentDataForDocType['expirationDate'].setMonth(date.getMonth());
      this.documentDataForDocType['expirationDate'].setFullYear(date.getFullYear());
      if (this.documentTypeData1.expiryInUnit == "Days") {
        this.documentDataForDocType['expirationDate'].setDate(date.getDate() + this.documentTypeData1.expiryIn);
      } else if (this.documentTypeData1.expiryInUnit == "Month") {
        this.documentDataForDocType['expirationDate'].setMonth(date.getMonth() + this.documentTypeData1.expiryIn);
      } else {
        this.documentDataForDocType['expirationDate'].setFullYear(date.getFullYear() + this.documentTypeData1.expiryIn);
      }
    } else {
      this.documentDataForDocType['expirationDate'] = new Date();
    }

  }
  selectExpValueForPlaceholder(date: Date) {
    if (this.documentTypeData.expiryInUnit != null && date) {
      // Clone the selected date to avoid mutating the original
      const expirationDate = new Date(date);

      if (this.documentTypeData.expiryInUnit == "Days") {
        expirationDate.setDate(expirationDate.getDate() + this.documentTypeData.expiryIn);
      } else if (this.documentTypeData.expiryInUnit == "Month") {
        expirationDate.setMonth(expirationDate.getMonth() + this.documentTypeData.expiryIn);
      } else {
        expirationDate.setFullYear(expirationDate.getFullYear() + this.documentTypeData.expiryIn);
      }

      this.placeholderData.expirationDate = expirationDate;
    }
  }


  validateCodeFields(event: KeyboardEvent) {
    const forbiddenKeys = ['.', ' ', '/', '\\'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  validateNumberFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  loadInLoader: any = false;
  ondocumentTypeForDocRemoved(item: any) {
    this.selectedDocumentTypeValue = "";
    this.isShowCrFields = false;
    this.isShowIsBlindedFlag = false;
    this.isShowAssociatedDocumentField = false;
    this.isShowUserBelongsToField = false;
    this.isShowExpDate = false;
  }
  wvInstance: any;
  showuploaddiv: boolean = false;
  isShowToUploadDiffFile: boolean = false;
  loadDataInViewer(data: any, extn: any) {
    this.showuploaddiv = true;
    this.NotviewableValue.style.display = 'block';
    this.viewerValue.style.display = 'block';

    if (this.wvInstance != undefined && this.wvInstance.UI && this.loadInLoader) {
      if (extn == null) {
        this.wvInstance.UI.loadDocument(data);
      } else {
        this.wvInstance.UI.loadDocument(data.body, { extension: extn });
      }
    } else {
      WebViewer({
        path: '../../../wv-resources/lib',
        licenseKey: 'Clinevo Technologies Private Limited (clinevotech.com):OEM:eTrials::B+:AMS(20231004):FEA5C54D0427360AF360B13AC982737B60610F8BAF461E35E56C05DA5C956EAE0AFAB6F5C7', // sign up to get a key at https://dev.apryse.com
        fullAPI: true,
        //webViewerServer : true,
        disabledElements: [
          'leftPanelButton',
          'toolbarGroup-Annotate',
          'highlightToolGroupButton',
          'underlineToolGroupButton',
          'strikeoutToolGroupButton',
          'squigglyToolGroupButton',
          'freeTextToolGroupButton',
          'shapeToolGroupButton',
          'stickyToolGroupButton',
          'freeHandToolGroupButton',
          'toolsOverlay',
          'eraserToolButton',
          'redoButton',
          'stickyToolButton',
          'textPopup',
          'toggleNotesButton',
          'selectToolButton',
          'highlightToolButton',
          'freeHandToolButton',
          'freeTextToolButton',
          'toolsHeader',
          'printButton',

        ]
      }, this.viewer1.nativeElement).then((instance: any) => {
        this.wvInstance = instance;

        instance.UI.disableElements(['printButton']);
        instance.UI.disableFeatures([instance.UI.Feature.Print]);

        // Also block Ctrl+P inside viewer (built-in PDFTron shortcut)
        instance.UI.addEventListener(instance.UI.Events.KEY_DOWN, (e: KeyboardEvent) => {
          instance.UI.addEventListener(instance.UI.Events.KEY_DOWN, (e: KeyboardEvent) => {
            if (e.ctrlKey && e.key.toLowerCase() === 'p') {
              e.preventDefault();
              e.stopPropagation();
              alert('Printing is disabled.');
            } else {
              e.preventDefault();
              e.stopPropagation();
            }
            return false;
          });
        });
        instance.UI.setTheme('dark');
        instance.print = false;
        instance.UI.disableElements(['toolbarGroup-Shapes']);
        instance.UI.disableElements(['toolbarGroup-Edit']);
        instance.UI.disableElements(['toolbarGroup-Insert']);
        instance.UI.disableElements(['menuButton']);
        instance.UI.disableElements(['undoButton']);
        instance.UI.disableElements(['highlightToolGroupButton']);
        instance.UI.enableFeatures([instance.Feature.Redaction]);
        if (extn == null) {
          instance.UI.loadDocument(this.document);
        } else {
          instance.UI.loadDocument(data.body, { extension: extn });
        }
        this.loadInLoader = true;
        const { documentViewer } = instance.Core;
        documentViewer.addEventListener('documentLoaded', () => {

        });

        const UIEvents = instance.UI.Events;
        instance.UI.addEventListener(UIEvents.LOAD_ERROR, function (err: any) {
          console.log(err);
        });

        // now you can access APIs through this.webviewer.getInstance()
        //instance.UI.openElement('notesPanel');
        // see https://docs.apryse.com/documentation/web/guides/ui/apis
        // for the full list of APIs

        instance.Core.documentViewer.addEventListener('documentLoaded', this.wvDocumentLoadedHandler)
      })
    }

  }

  redactedDocument: any;
  redactedDocToDownload: any;
  comments: any;
  loadDataInViewerForRedact(data: any, extn: any) {
    this.showuploaddiv = true;
    //this.NotviewableValue.style.display = 'block';
    //this.viewerValue.style.display = 'block';

    if (this.wvInstance != undefined && this.wvInstance.UI && false) {
      if (extn == null) {
        this.wvInstance.UI.loadDocument(data);
      } else {
        this.wvInstance.UI.loadDocument(data.body, { extension: extn });
      }
    } else {
      WebViewer({
        path: '../../../wv-resources/lib',
        licenseKey: 'Clinevo Technologies Private Limited (clinevotech.com):OEM:eTrials::B+:AMS(20231004):FEA5C54D0427360AF360B13AC982737B60610F8BAF461E35E56C05DA5C956EAE0AFAB6F5C7', // sign up to get a key at https://dev.apryse.com
        fullAPI: true,
        enableRedaction: true,
        loadAsPDF: true,
        //webViewerServer : true,
        disabledElements: [
          'leftPanelButton',
          'toolbarGroup-Annotate',
          'highlightToolGroupButton',
          'underlineToolGroupButton',
          'strikeoutToolGroupButton',
          'squigglyToolGroupButton',
          'freeTextToolGroupButton',
          'shapeToolGroupButton',
          'stickyToolGroupButton',
          'freeHandToolGroupButton',
          'toolsOverlay',
          'eraserToolButton',
          'redoButton',
          'stickyToolButton',
          'textPopup',
          'toggleNotesButton',
          'selectToolButton',
          'highlightToolButton',
          'freeHandToolButton',
          'freeTextToolButton',
          'toolsHeader'

        ]
      }, this.viewer.nativeElement).then((instance: any) => {
        this.wvInstance = instance;
        const docViewer = instance.docViewer;
        const annotManager = instance.annotManager;
        // call methods from instance, docViewer and annotManager as needed
        instance.UI.setTheme('dark');
        instance.print = false;
        const { Tools } = instance.Core;
        instance.UI.setToolMode(Tools.ToolNames.REDACTION);
        instance.UI.disableElements(['toolbarGroup-Shapes']);
        instance.UI.disableElements(['toolbarGroup-Edit']);
        instance.UI.disableElements(['toolbarGroup-Insert']);
        instance.UI.disableElements(['menuButton']);
        instance.UI.disableElements(['undoButton']);
        instance.UI.disableElements(['highlightToolGroupButton']);
        instance.UI.enableElement(['redactionToolGroupButton']);
        instance.UI.enableFeatures([instance.Feature.Redaction]);
        let FitMode = instance.FitMode;
        if (extn == null) {
          instance.UI.loadDocument(this.document);
        } else {
          instance.UI.loadDocument(data.body, { extension: extn });
        }

        const { documentViewer } = instance.Core;
        documentViewer.addEventListener('documentLoaded', () => {
          instance.setHeaderItems((header: any) => {
            header.push({
              type: 'actionButton',
              img: 'export.png',
              title: 'Save',
              onClick: async () => {
                const doc = documentViewer.getDocument();
                const xfdfString = await annotManager.exportAnnotations();
                const data = await doc.getFileData({
                  xfdfString
                });

                let filenameforsave = doc.filename;
                const arr = new Uint8Array(data);
                const blob = new Blob([arr], { type: 'application/pdf' });
                let url = URL.createObjectURL(blob);
                const blobToFile = (theBlob: any, fileName: any) => {
                  theBlob.lastModifiedDate = new Date();
                  theBlob.name = this.documentData.documentName;
                  theBlob.type = 'application/pdf';
                  return theBlob;
                }
                this.redactedDocToDownload = url;
                let blobss = await fetch(url).then(r => r.blob());
                this.redactedDocument = new File([blob], filenameforsave);
                this.visibleRedactPopup.close();
                this.visibleRedactConfirmationPopup = this.dialog.open(this.redactConfirmationPopup, this.redactConfirmationPopupConfig);
              }
            })
          })
        });

        instance.Core.annotationManager.enableRedaction();

        const UIEvents = instance.UI.Events;
        instance.UI.addEventListener(UIEvents.LOAD_ERROR, function (err: any) {
          console.log(err);
        });

        // now you can access APIs through this.webviewer.getInstance()
        //instance.UI.openElement('notesPanel');
        // see https://docs.apryse.com/documentation/web/guides/ui/apis
        // for the full list of APIs

        instance.Core.documentViewer.addEventListener('documentLoaded', this.wvDocumentLoadedHandler)
      })
    }

  }

  cancelRedactConfirmationPopup() {
    this.visibleRedactConfirmationPopup.close();
  }
  warningMsg = "";
  allowedFileExtns: any = "*.*";
  @ViewChild('viewer1', { static: false }) viewer1: ElementRef;
  @ViewChild('viewer', { static: false }) viewer: ElementRef;
  isFileValid: any;
  onFileSelected(event: any) {
    const file: File = event.target.files[0];
    if (file) {
      this.isShowViewer = true;
      this.previousFileName = file.name;

      this.document = file;
      this.documentDataForDocType.documentExtn = (file.name.split('.').pop() ?? '').toLowerCase();
      if (!this.allowedFileExtns.includes(this.documentDataForDocType.documentExtn)) {
        let warningMsgType = "E";
        this.warningMsg = this.documentDataForDocType.documentExtn + " file type is not allowed, please choose allowed file type.";
        //this.visibleCrInfoPopup = this.dialog.open(this.infoPopup,this.crInfoPopupConfig);
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: this.warningMsg,
            type: warningMsgType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: warningMsgType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
      } else {
        let name = file.name.substr(0, file.name.lastIndexOf('.'));
        if (this.documentDataForDocType.documentName == "" || this.documentDataForDocType.documentName == null) {
          this.documentDataForDocType.documentName = name;
        }

        this.isViewableFile = false;
        if (this.viewableExtensionsList.length > 0) {
          for (let q = 0; q < this.viewableExtensionsList.length; q++) {
            if (this.viewableExtensionsList[q].toUpperCase() == this.documentDataForDocType.documentExtn.toUpperCase()) {
              this.isViewableFile = false;
              this.loadDataInViewer(this.document, null);
              break;
            } else {
              this.isViewableFile = true;
              this.isShowToUploadDiffFile = true;
              this.NotviewableValue.style.display = 'none';
            }

          }
        } else {
          this.isViewableFile = true;
          this.isShowToUploadDiffFile = true;
          this.NotviewableValue.style.display = 'none';
        }

        let extension: any = (file.name.split('.').pop() ?? '').toLowerCase();
        const formData = new FormData();
        formData.append('file', file == undefined ? '' : file);
        formData.append("pageName", "DMS");
        formData.append("fileName", name);
        formData.append("extension", extension);
        this.isProcessing = true;
        this.appService.fileUploadToServer(formData)
          .subscribe((data: any) => {
            this.isProcessing = false;
            if (data.resultType == "S") {
              this.isFileValid = true;
              this.downloadTemplateData = data.file;
              this.uploadFilePathextension = extension;
              this.uploadFilePath = data.uploadPath + "/" + data.fileName;
            } else {
              this.isFileValid = false;
              this.document = null;
              this.documentDataForDocType.documentExtn = '';
              this.uploadFilePathextension = null;
              this.uploadFilePath = data.uploadPath + "/" + data.fileName;
              let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: 5000,
                data: {
                  message: data.result,
                  type: data.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: "Ok"
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: data.resultType == 'S' ? 'Success' : 'Error',
              });
              sb.onAction().subscribe(() => {
                sb.dismiss();
              });
            }
          }, (error) => {
            this.displayMessage = error;
            this.displaySuccessMessage = false;
            this.displayErrorMessage = true;
            this.isProcessing = false;
            throw error;
          })
      }
    } else {
      this.isShowViewer = false;
      this.document = '';
      this.documentDataForDocType.documentExtn = '';
    }
  }

  searchUserParentCheckBox: boolean = false;
  searchUserChildCheckBoxs: boolean = false;
  searchUserChildCheckBoxsMenu: boolean = false;

  searchUserDataGridParentCheckBoxChecked(e: any) {
    if (e.target.checked == true) {
      //this.searchManagerChildCheckBoxs = true;
      //this.searchManagerChildCheckBoxsMenu=true;
      for (let k = 0; k < this.getOneQmsUsersVwDetailsTableData.length; k++) {
        this.getOneQmsUsersVwDetailsTableData[k].searchUserChildCheckBoxs = true;
      }

    } else {
      for (let k = 0; k < this.getOneQmsUsersVwDetailsTableData.length; k++) {
        this.getOneQmsUsersVwDetailsTableData[k].searchUserChildCheckBoxs = false;
      }
      //this.searchManagerChildCheckBoxs = false;
      //this.searchManagerChildCheckBoxsMenu=false;
    }
  }

  getSelectedUserId: any;
  getSelectedUserName: String;
  searchUserChildCheckBoxChecked(e: any, listOfUsersVwDetails: any, idx: any) {

    if (e.target.checked) {
      listOfUsersVwDetails.searchUserChildCheckBoxs = true;
      this.getSelectedUserId = listOfUsersVwDetails.userId;
      this.getSelectedUserName = listOfUsersVwDetails.userName;
    } else {
      listOfUsersVwDetails.searchUserChildCheckBoxs = false;
      this.getSelectedUserId = null;
      this.getSelectedUserName = '';
    }

  }

  showUserSearchGrid: boolean;
  searchByUserName: any = null;
  searchByFirstName: any = null;
  searchByLastName: any = null;
  searchByDesignationCode: any = null;
  searchByDepartmentCode: any = null;
  searchingByStatusCode: any = [];
  designationCodeValue: any;
  departmentCodeValue: any;
  statusCodeValue: any;
  searchOneQmsUserVwDetails: any;
  getOneQmsUsersVwDetailsTableData: any = [];

  searchUserValue: any;

  searchUserFunction(value: any) {
    this.searchUserValue = value;
    this.searchUserChildCheckBoxs = false;
    this.showUserSearchGrid = false;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.popupDataTitle.title = "Search User";
    this.visibleSearchUserPopup = this.dialog.open(this.searchUser, this.searchUserConfig);


  }

  addUserNameFunction() {
    if (this.searchUserValue == "Document") {
      this.documentDataForDocType.belongsUserId = this.getSelectedUserId;
      this.documentDataForDocType.belongsUserName = this.getSelectedUserName;
    } else {
      this.placeholderData.belongsUserId = this.getSelectedUserId;
      this.placeholderData.belongsUserName = this.getSelectedUserName;
    }

    this.visibleSearchUserPopup.close();
  }

  cancelSearchUserFunction() {
    this.getSelectedUserId = null;
    this.getSelectedUserName = '';
    this.visibleSearchUserPopup.close();
  }

  searchUserGridDataFunction() {
    this.isProcessing = true;
    this.designationCodeValue = this.searchByDesignationCode ?? null;
    this.departmentCodeValue = this.searchByDepartmentCode ?? null;


    let searchByUserName;
    if (this.searchByUserName != null) {
      searchByUserName = this.searchByUserName.toUpperCase();
    } else {
      this.searchByUserName = '';
    }
    this.searchOneQmsUserVwDetails = {
      userName: searchByUserName,
      firstName: this.searchByFirstName,
      lastName: this.searchByLastName,
      designationCode: this.designationCodeValue,
      departmentCode: this.departmentCodeValue,
      status: "active"
    };
    if (this.userPrivData.author == "Y") {
      this.searchOneQmsUserVwDetails.userPriv = "AUTHOR";
    } else if (this.userPrivData.allusrAuthor == "Y" && this.userPrivData.rmAuthor == "Y") {
      this.searchOneQmsUserVwDetails.userPriv = "ALLUSERRMAUTHOR";
    } else if (this.userPrivData.allusrAuthor == "Y") {
      this.searchOneQmsUserVwDetails.userPriv = "ALLUSERAUTHOR";
    } else if (this.userPrivData.rmAuthor == "Y") {
      this.searchOneQmsUserVwDetails.userPriv = "RMAUTHOR";
    }
    this.appService.searchUsersForDmsDocuments(this.searchOneQmsUserVwDetails).subscribe((response: any) => {
      this.getOneQmsUsersVwDetailsTableData = response;
      this.showUserSearchGrid = true;
      this.isProcessing = false;
    })
  }

  resetSearchUserGridDataFunction() {
    this.isProcessing = true;
    this.searchByUserName = null;
    this.searchByFirstName = null;
    this.searchByLastName = null;
    this.searchByDesignationCode = null;
    this.searchByDepartmentCode = null;
    this.getOneQmsUsersVwDetailsTableData = [];
    this.showUserSearchGrid = false;
    this.isProcessing = false;
  }

  selectedDesignationValue: any;
  selectedDepartmentValue: any;
  onDesignationCodeSelect(event: any, item: any) {
    if (event.isUserInput) {

      this.selectedDesignationValue = item?.valueExp ?? null;
    }
  }

  onDesignationCodeSelectOLd(item: any) {

    this.selectedDesignationValue = item.valueExp;
  }
  onDesignationCodeRemoved(item: any) { }

  onDepartmentCodeSelect(event: any, item: any) {
    if (event.isUserInput) {

      this.selectedDepartmentValue = item?.valueExp ?? null;
    }
  }

  onDepartmentCodeSelectOld(item: any) {

    this.selectedDepartmentValue = item.valueExp;
  }
  onDepartmentCodeRemoved(item: any) { }

  visibleCrInfoPopup: MatDialogRef<TemplateRef<any>>;
  @ViewChild('infoPopup', { static: true }) infoPopup: TemplateRef<any>;
  okInfo() {
    this.visibleCrInfoPopup.close();
  }

  documentName: any;
  documentType: any;
  belongsToUser: any;
  description: any;
  crFeild: any;
  versionCss: any;
  documentNoCss: any;
  documentNameRequiredMsg: any;
  documentTypeRequiredMsg: any;
  belongsToUserRequiredMsg: any;
  descriptionRequiredMsg: any;
  crFieldRequiredMsg: any;
  versionCssReqdMsg: any;
  documentNoCssReqdMsg: any;
  fieldDocumentValidation() {
    this.documentName = document.getElementById('documentName') as HTMLInputElement;
    this.documentType = document.getElementById('documentType') as HTMLInputElement;
    this.belongsToUser = document.getElementById('documentName') as HTMLInputElement;
    this.description = document.getElementById('description') as HTMLInputElement;
    this.crFeild = document.getElementById('cr') as HTMLInputElement;

    this.documentNameRequiredMsg = document.getElementById('documentName-required-msg') as HTMLInputElement;
    this.documentTypeRequiredMsg = document.getElementById('documentType-required-msg') as HTMLInputElement;
    this.belongsToUserRequiredMsg = document.getElementById('belongsToUser-required-msg') as HTMLInputElement;
    this.descriptionRequiredMsg = document.getElementById('description-required-msg') as HTMLInputElement;
    this.crFieldRequiredMsg = document.getElementById('cr-required-msg') as HTMLInputElement;

    if (this.documentDataForDocType.documentName == "") {
      this.documentName.style.border = '1px solid red';
      this.documentNameRequiredMsg.style.display = 'block';
    } else {
      this.documentName.style.border = 'none';
      this.documentNameRequiredMsg.style.display = 'none';
    }

    if (this.documentDataForDocType.documentDescription == null) {
      this.description.style.border = '1px solid red';
      this.descriptionRequiredMsg.style.display = 'block';
    } else {
      this.description.style.border = 'none';
      this.descriptionRequiredMsg.style.display = 'none';
    }

    if (!this.selectedDocumentTypeForDoc) {
      this.documentType.style.border = '1px solid red';
      this.documentTypeRequiredMsg.style.display = 'block';
    } else {
      this.documentType.style.border = 'none';
      this.documentTypeRequiredMsg.style.display = 'none';
    }

    if (this.isCrFeildIsMandatory) {
      if (this.documentDataForDocType.crNo == null) {
        this.crFeild.style.border = '1px solid red';
        this.crFieldRequiredMsg.style.display = 'block';
      } else {
        this.crFeild.style.border = 'none';
        this.crFieldRequiredMsg.style.display = 'none';
      }
    }

    if (this.isVersionManuallyForDocType) {
      this.versionCss = document.getElementById('versionForDocType') as HTMLInputElement;
      this.versionCssReqdMsg = document.getElementById('versionForDocType-required-msg') as HTMLInputElement;
      if (this.documentDataForDocType.version == null || this.documentDataForDocType.version == "") {
        this.versionCss.style.border = '1px solid red';
        this.versionCssReqdMsg.style.display = 'block';
      } else {
        this.versionCss.style.border = 'none';
        this.versionCssReqdMsg.style.display = 'none';
      }
    }
    if (this.isDocumentNoManuallyForDocType) {
      this.documentNoCss = document.getElementById('documentNoForDocType') as HTMLInputElement;
      this.documentNoCssReqdMsg = document.getElementById('documentNoForDocType-required-msg') as HTMLInputElement;
      if (this.documentDataForDocType.documentNo == null || this.documentDataForDocType.documentNo == "") {
        this.documentNoCss.style.border = '1px solid red';
        this.documentNoCssReqdMsg.style.display = 'block';
      } else {
        this.documentNoCss.style.border = 'none';
        this.documentNoCssReqdMsg.style.display = 'none';
      }
    }

    // if(this.isShowUserBelongsToField && this.documentData.belongsUserId == null) {
    //   this.belongsToUser.style.border = '1px solid red';
    //   this.belongsToUserRequiredMsg.style.display = 'block';
    // } else {
    //   this.belongsToUser.style.border = 'none';
    //   this.belongsToUserRequiredMsg.style.display = 'none';
    // }
  }
  uploadFilePath: any;
  uploadFilePathextension: any;
  addDocForDocTypeFunc() {
    if (this.documentDataForDocType.addDocOrPlaceholder !== "PLACEHOLDER" && !this.document) {
      this.visibleWarningPopup = this.dialog.open(this.warningPopupTemplate, {
        width: '400px',
        disableClose: true,
      });
      return;
    }
    this.isProcessing = true;
    if (this.documentDataForDocType['documentName'] == "" || !this.selectedDocumentTypeForDoc || this.documentDataForDocType['documentDescription'] == null
      || (this.isCrFeildIsMandatory && this.documentDataForDocType.crNo == null) || (this.isVersionManuallyForDocType && (this.documentDataForDocType.version == "" || this.documentDataForDocType.version == null))
      || (this.isDocumentNoManuallyForDocType && (this.documentDataForDocType.documentNo == "" || this.documentDataForDocType.documentNo == null))) {
      this.fieldDocumentValidation();
      this.isProcessing = false;
    } else {

      this.documentDataForDocType.documentTypeCode = this.docTypToAddDocument;
      this.documentDataForDocType.isBlinded = this.documentDataForDocType.isBlinded1 ? "Y" : "N";
      this.documentDataForDocType.folderId = this.selectedFolderForCreateDoc.folderId;
      this.documentDataForDocType.docOrPlaceholder = this.documentDataForDocType.addDocOrPlaceholder;
      if (this.documentDataForDocType.addDocOrPlaceholder != "PLACEHOLDER") {
        if (this.uploadFilePath && this.uploadFilePathextension) {
          this.documentDataForDocType.uploadFolderPath = this.uploadFilePath + "." + this.uploadFilePathextension;
        } else {
          this.documentDataForDocType.uploadFolderPath = null;
        }
      }

      const formData = new FormData();

      if (this.documentDataForDocType.addFrom === 'Add From Template') {
        if (this.templateData && this.templateData.template) {
          this.documentDataForDocType.document = this.templateData.template;
          this.documentDataForDocType.documentExtn = this.templateData.templateExtn;
        }

        formData.append('file', '');
        this.documentDataForDocType.uploadFolderPath = null;
      }
      else if (this.documentDataForDocType.addDocOrPlaceholder !== "PLACEHOLDER") {
        formData.append('file', this.document);
        if (this.uploadFilePath && this.uploadFilePathextension) {
          this.documentDataForDocType.uploadFolderPath = this.uploadFilePath + "." + this.uploadFilePathextension;
        }
      }
      else {
        formData.append('file', '');
      }
      formData.append('file', this.document);
      const json = JSON.stringify(this.documentDataForDocType);
      const blob = new Blob([json], {
        type: 'application/json'
      });
      formData.append('dmsDocumentDto', blob);
      this.isProcessing = true;
      this.appService.createDmsDocument(formData).subscribe((Response: any) => {
        this.isProcessing = false;
        if (Response.resultType == "S") {
          this.isBeforeSaveUploadDiffFile = false;
          this.visibleAddDocForDocumentTypePopup.close();
        } else {
          // this.displayMsg = false;
          // this.resultMsg = data.result;
          // this.dangerMsg = true;
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      }, (error) => {
        this.displayMessage = error;
        this.displaySuccessMessage = false;
        this.displayErrorMessage = true;
        this.isProcessing = false;
        throw error;
      });
    }

  }
  okWarning() {
    if (this.visibleWarningPopup) {
      this.visibleWarningPopup.close();
    }
  }

  multiTemplateArray: any = [];
  searchTemplateParentCheckBox: boolean = false;
  downloadType: any;
  bulkselectedTemplateData: any;
  selectedTemplateData: any;
  downloadTemplates(list: any) {
    this.downloadType = "single";
    this.visibleTemplatePopup.close();
    this.selectedTemplateData = list;
    this.selectedTemplateData.module = "Template";
    this.reason = "";
    this.visibleDownloadTemplatePopup = this.dialog.open(this.downloadTemplatePopup, this.downloadTemplatePopupConfig);

  }

  downloadTemplateForFolder() {
    if (this.reason == "" || this.reason == null) {
      const reason = document.getElementById('deleteReason') as HTMLInputElement;
      const reasonRequiredMsg = document.getElementById('deleteReason-required-msg') as HTMLInputElement;

      reason.style.border = '1px solid red';
      reasonRequiredMsg.style.display = 'block';

    } else {
      let object: any;
      if (this.selectedTemplateData.module == "Template") {
        object = {

          documentId: this.selectedTemplateData.templateId,
          version: 0,
          folderId: this.rightClickData.folderId,
          issuanceType: "Download Template",
          associatedDocuments: "N",
          publisherDetails: null,
          comments: this.reason,
          issuanceId: null,
          templateId: this.selectedTemplateData.templateId,
          otherDetails: this.selectedTemplateData.templateName,
          downloadedFileName: this.selectedTemplateData.templateName
        }
        this.isProcessing = true;
        this.appService.downloadDocumentTemplate(object).subscribe(
          (response: any) => {
            this.visibleDownloadTemplatePopup.close();
            let contentData = "data:application/octet-stream;base64," + this.selectedTemplateData.template;
            let downloadLink = document.createElement("a");
            downloadLink.href = contentData;
            downloadLink.download = this.selectedTemplateData.templateName + "." + this.selectedTemplateData.templateExtn;
            downloadLink.click()
            this.isProcessing = false;
          })
      }// Case 2: History Document Download
      else if (this.selectedTemplateData.module == "History") {

        const docId = this.selectedTemplateData.documentId ? this.selectedTemplateData.documentId : this.rightClickData.documentId;
        object = {

          documentId: docId,
          version: this.selectedTemplateData.version,
          folderId: this.selectedTemplateData.folderId,
          issuanceType: "History Document",
          issuanceReason: "History Download",
          issuanceTo: null,
          noOfCopy: null,
          coverPage: "N",
          revisionHistory: "N",
          additionalDetails: "N",
          amendment: "N",
          approval: "N",
          associatedDocuments: "N",
          publisherDetails: null,
          otherDetails: null,
          comments: this.reason,
          status: "Completed",
          watermark: null,
          issuanceId: null,
          downloadedFileName: this.selectedTemplateData.documentName,
          isPrintOrDownload: "Download"
        };

        this.isProcessing = true;

        // 3. Call Issuance Tracking API First
        this.appService.performIssuanceHistory(object).subscribe((data: any) => {

          if (data.resultType == "S") {
            // 4. On Success, Call the Download API
            this.appService.downloadDocuments(
              docId,
              this.selectedTemplateData.version,
              this.selectedTemplateData.documentNo + "." + this.selectedTemplateData.documentExtn
            );

            this.isProcessing = false;
            this.visibleDownloadTemplatePopup.close();

          } else {
            // Handle Tracking Failure
            this.isProcessing = false;
            let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
              duration: 5000,
              data: {
                message: data.result,
                type: 'Error',
                buttonLabel: "Ok"
              },
              horizontalPosition: 'center',
              verticalPosition: 'top',
              panelClass: 'Error',
            });
            sb.onAction().subscribe(() => sb.dismiss());
          }
        }, (error) => {
          this.isProcessing = false;
          console.error("Issuance Tracking Failed", error);
        });
      } else {
        const object = {

          documentId: this.selectedTemplateData.documentId,
          version: this.selectedTemplateData.version,
          folderId: this.selectedTemplateData.folderId || this.parentFolderId,
          issuanceType: "Original Document",
          associatedDocuments: "N",
          publisherDetails: null,
          comments: this.reason,
          issuanceId: null,
          otherDetails: this.selectedTemplateData.documentName
        }
        this.isProcessing = true;
        this.appService.downloadDocuments(this.rightClickData['documentId'],
          this.rightClickData['version'], this.rightClickData['documentName'] + "." + this.rightClickData['documentExtn']);
        this.isProcessing = false;
        this.isProcessing = true;
        this.appService.downloadOriginalDocument(object, this.selectedTemplateData.documentName).subscribe((data: any) => {
          this.isProcessing = false;
          this.visibleDownloadTemplatePopup.close();
        })

      }
    }




  }
  cancelDownloadTemplateFunc() {
    this.visibleDownloadTemplatePopup.close();
  }

  canceltemplatePopup() {
    this.visibleTemplatePopup.close();
  }

  cancelAddUserGroupPopup() {
    this.visibleAddUserGroupPopup.close();
  }

  selectedUserGroup: any = {};
  previousSelectedData: any = {};
  dataGridGroupChildCheckBoxChecked(e: any, list: any, idx: any) {
    if (e.target.checked) {
      list.grouptChildCheckBoxs = true;
      this.selectedUserGroup = list;
      this.previousSelectedData.grouptChildCheckBoxs = false;
    } else {
      list.grouptChildCheckBoxs = false;
      this.selectedUserGroup = {};
    }
    this.previousSelectedData = list;

  }

  addUserGroupFunc() {
    this.isProcessing = true;
    let data = {
      groupId: this.selectedUserGroup.groupId,
      folderId: this.rightClickData.folderId,
      cascaseToChild: this.cascaseToChild ? 'Y' : 'N',
    }
    this.appService.createDmsGruoupFolders(data).subscribe((Response: any) => {
      this.isProcessing = true;
      if (Response.resultType == 'S') {
        this.visibleAddUserGroupPopup.close();
      }
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: Response.result,
          type: Response.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
      this.isProcessing = false;
    }, (error) => {
      this.isProcessing = false;
      throw error;
    });
  }

  deleteReasonValidation() {
    const reason = document.getElementById('reason') as HTMLInputElement;
    const checkoutCr = document.getElementById('crForCheckout') as HTMLInputElement;
    const reasonRequiredMsg = document.getElementById('reason-required-msg') as HTMLInputElement;
    const checkoutCrRequiredMsg = document.getElementById('crForCheckout-required-msg') as HTMLInputElement;


    if (this.reason == "" || this.reason == null || this.reason == undefined) {
      //reasonValidationIcon.innerHTML = '<i class="fas fa-exclamation-circle"></i>';
      //reasonValidationIcon.style.color = 'red';
      reason.style.border = '1px solid red';
      reasonRequiredMsg.style.display = 'block';
    } else {
      //reasonValidationIcon.innerHTML = '';
      //reasonValidationIcon.style.color = 'none';
      reason.style.border = 'none';
      reasonRequiredMsg.style.display = 'none';
    }
    if (this.isCrFeildIsMandatory) {
      if (this.checkoutcrNo == null) {
        checkoutCr.style.border = '1px solid red';
        checkoutCrRequiredMsg.style.display = 'block';
      } else {
        checkoutCr.style.border = 'none';
        checkoutCrRequiredMsg.style.display = 'none'
      }
    }

  }

  reason: any = "";
  confirmWithReasonFunc() {
    this.isProcessing = true;
    if (this.reason == "" || this.reason == null || (this.checkoutcrNo == null && this.isCrFeildIsMandatory && this.buttonData.text == "CheckOut")) {
      this.deleteReasonValidation();
      this.isProcessing = false;
    } else {
      let data = {

        documentId: this.documentData['documentId'],
        version: this.documentData['version'],
        currentStatus: this.documentData['status'],
        stageName: null,
        buttonValue: this.buttonData.text,
        actionStatus: null,
        crNo: this.checkoutcrNo,
        comments: this.reason,
        rejectReason: null,
        reasonForSignature: null,
        fileExtn: null,
        effectiveDate: null,
        expirationDate: null
      }
      const formData = new FormData();
      const emptyfile: File | any = null;
      formData.append('file', emptyfile);
      const json = JSON.stringify(data);
      const blob = new Blob([json], {
        type: 'application/json'
      });
      formData.append('object', blob);
      this.appService.performButtonOperationForDocument(formData).subscribe((Response: any) => {
        this.isProcessing = false;
        if (Response.resultType == "S") {
          this.visibleConfirmWithReason.close();
          if (this.buttonData.text == "CheckOut") {
            this.getCall();
            this.callAssociatedDocCheckout();
          }
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: Response.result,
            type: Response.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
        this.isProcessing = false;
      })
    }

  }

  checkoutDocList: any = [];
  onChange(i: any, event: any) {
    if (this.checkoutDocList.indexOf(this.checkoutDocList[event.source.value]) == -1) {
      this.checkoutDocList.push(event.source.value);
    }

  }

  callAssociatedDocCheckout() {
    for (let j = 0; j < this.checkoutDocList.length; j++) {
      for (let i = 0; i < this.associatedDocumentListForCheckout.length; i++) {
        if (this.checkoutDocList[j] == this.associatedDocumentListForCheckout[i].documentId) {
          let data = {

            documentId: this.associatedDocumentListForCheckout[i]['documentId'],
            version: this.associatedDocumentListForCheckout[i]['version'],
            currentStatus: this.associatedDocumentListForCheckout[i]['status'],
            stageName: null,
            buttonValue: this.buttonData.text,
            actionStatus: null,
            crNo: this.checkoutcrNo,
            comments: this.reason,
            rejectReason: null,
            reasonForSignature: null,
            fileExtn: null,
            effectiveDate: null,
            expirationDate: null
          }
          const formData = new FormData();
          const emptyfile: File | any = null;
          formData.append('file', emptyfile);
          const json = JSON.stringify(data);
          const blob = new Blob([json], {
            type: 'application/json'
          });
          formData.append('object', blob);
          this.appService.performButtonOperationForDocument(formData).subscribe((Response: any) => {
            this.isProcessing = false;
            if (Response.resultType == "S") {

            } else {
              let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
                duration: 5000,
                data: {
                  message: Response.result,
                  type: Response.resultType == 'S' ? 'Success' : 'Error',
                  buttonLabel: "Ok"
                },
                horizontalPosition: 'center',
                verticalPosition: 'top',
                panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
              });
              sb.onAction().subscribe(() => {
                sb.dismiss();
              });
            }

            this.isProcessing = false;
          })
        }
      }
    }

  }

  cancelFunc() {
    this.visibleConfirmWithReason.close();
  }

  cancelIssuanceHistPopup() {
    this.visibleIssuanceHistPopup.close();
  }

  cancelRedactPopup() {
    this.visibleRedactPopup.close();
  }

  saveReportsToDb() {
    this.isProcessing = true;
    let obj = {

      module: "DOCS",
      refNo: this.documentData['documentId'],
      version: this.documentData['version'],
      statusWhenItsGenerated: this.documentData['status'],
      documentType: "REDACT_" + this.comments,
      documentExtn: 'pdf',
    }
    const formData = new FormData();
    formData.append('file', this.redactedDocument);
    const json = JSON.stringify(obj);
    const blob = new Blob([json], {
      type: 'application/json'
    });
    formData.append('savedReportsDto', blob);
    this.isProcessing = true;
    this.appService.saveReportsToDB(formData).subscribe((Response: any) => {
      this.isProcessing = false;
      if (Response.resultType == "S") {
        this.visibleRedactConfirmationPopup.close();
        //this.visibleRedactPopup.close();
      } else {
        // this.displayMsg = false;
        // this.resultMsg = data.result;
        // this.dangerMsg = true;
      }
      let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
        duration: 5000,
        data: {
          message: Response.result,
          type: Response.resultType == 'S' ? 'Success' : 'Error',
          buttonLabel: "Ok"
        },
        horizontalPosition: 'center',
        verticalPosition: 'top',
        panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
      });
      sb.onAction().subscribe(() => {
        sb.dismiss();
      });
      this.isProcessing = false;
    }, (error) => {
      this.displayMessage = error;
      this.displaySuccessMessage = false;
      this.displayErrorMessage = true;
      this.isProcessing = false;
      throw error;
    });
  }

  cancelViewHistPopup() {
    this.visibleDocumentHistPopup.close();
  }

  cancelDocPropertiesPopup() {
    this.visibleDocumentPropertiesPopup.close();
  }

  onTabChangedForProperties(event: any) {

  }

  onTabChanged2(event: any) {

  }

  cancelMoveDocument() {
    this.visibleMoveDocumentPopup.close();
  }

  movDocReason: any;
  movDocReasonRequiredMsg: any;
  moveDocumentFieldValidation() {
    this.movDocReason = document.getElementById('reasonForMove') as HTMLInputElement;
    this.movDocReasonRequiredMsg = document.getElementById('reasonForMove-required-msg') as HTMLInputElement;

    if (this.reason == "") {
      this.movDocReason.style.border = '1px solid red';
      this.movDocReasonRequiredMsg.style.display = 'block';
    } else {
      this.movDocReason.style.border = 'none';
      this.movDocReasonRequiredMsg.style.display = 'none';
    }
  }

  moveDocFunc() {
    if (this.selectedFolderToMovDocData.folderId == undefined || this.selectedFolderToMovDocData.folderId == null) {
      alert("Please choose folder to move!");
    }
    else if (this.reason == "") {
      this.moveDocumentFieldValidation();
    } else {
      this.isProcessing = true;
      let obj = {

        documentId: this.documentData.documentId,
        folderId: this.selectedFolderToMovDocData.folderId,
        comments: this.reason
      }
      this.appService.moveDocument(obj).subscribe((data: any) => {
        this.isProcessing = false;
        if (data.resultType == "S") {
          this.visibleMoveDocumentPopup.close();
          this.getCall();
        } else {
        }
        let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
          duration: 5000,
          data: {
            message: data.result,
            type: data.resultType == 'S' ? 'Success' : 'Error',
            buttonLabel: "Ok"
          },
          horizontalPosition: 'center',
          verticalPosition: 'top',
          panelClass: data.resultType == 'S' ? 'Success' : 'Error',
        });
        sb.onAction().subscribe(() => {
          sb.dismiss();
        });
      }, (error) => {
        this.displayMessage = error;
        this.displaySuccessMessage = false;
        this.displayErrorMessage = true;
        this.isProcessing = false;
        throw error;
      })
    }
  }

  @ViewChild(StaticAuditTrailComponent) staticAuditTrailComponent!: StaticAuditTrailComponent;

  openAuditTrail(trailFor: string, viewType: any, folderOrDocument: any) {
    if (trailFor == 'folder') {
      if (viewType == 'overAll') {
        this.message.tableOrView_Name = "DMS_FOLDERS_AU_VW";
        this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,STATUS,DOCUMENT_TYPE_CODE,FOLDER_CODE,FOLDER_DESCRIPTION,FOLDER_NAME,FOLDER_PATH,IS_DISTRIBUTED_FOLDER,ALLOW_TO_INPUT_DOCUMENT_NO_MANUALLY,ALLOW_TO_INPUT_VERSION_MANUALLY,ENABLE_PUBLISH_MAIL_FOR_FOLDER_USERS,DOCUMENT_NO_FORMAT,DOCUMENT_NO_REGENERATION,DOCUMENT_NO_NO_OF_DIGITS,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,UPDATE_REASON,DELETED_BY_USER,DELETED_REASON";
        this.message.columnList_UI = "Created Timestamp,End Timestamp,Action Flag,Status,Document Type Code,Folder Code,Folder Description,Folder Name,Folder Path,Is Distributed Folder,Allow To Input Document No Manually,Allow To Input Version Manually,Enable Publish Mail For Folder Users,Document No Format,Document No Regeneration,Document No Of Digits,Created On,Created By,Updated On,Updated By,Update Reason,Deleted By,Deleted Reason";
        this.message.whereClause_AU = " AND PARENT_FOLDER_ID = " + this.parentFolderId;
        this.message.columnList_Report = "Created Timestamp,End Timestamp,Action Flag,Status,Document Type Code,Folder Code,Folder Description,Folder Name,Folder Path,Is Distributed Folder,Created On,Created By,Updated On,Updated By,Update Reason,Deleted By,Deleted Reason";
        this.message.whereClause_Report = " WHERE PARENT_FOLDER_ID = " + this.parentFolderId
        this.message.report_And_Popup_Name = this.rightClickData.folderName + " " + "Audit Trail";
        this.message.reportName_AU = "Sub Folder";
        this.staticAuditTrailComponent.triggerTrail(folderOrDocument);
      } else {
        this.message.tableOrView_Name = "DMS_FOLDERS_AU_VW";
        this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,STATUS,DOCUMENT_TYPE_CODE,FOLDER_CODE,FOLDER_DESCRIPTION,FOLDER_NAME,FOLDER_PATH,IS_DISTRIBUTED_FOLDER,ALLOW_TO_INPUT_DOCUMENT_NO_MANUALLY,ALLOW_TO_INPUT_VERSION_MANUALLY,ENABLE_PUBLISH_MAIL_FOR_FOLDER_USERS,DOCUMENT_NO_FORMAT,DOCUMENT_NO_REGENERATION,DOCUMENT_NO_NO_OF_DIGITS,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,UPDATE_REASON,DELETED_BY_USER,DELETED_REASON";
        this.message.columnList_UI = "Created Timestamp,End Timestamp,Action Flag,Status,Document Type Code,Folder Code,Folder Description,Folder Name,Folder Path,Is Distributed Folder,Allow To Input Document No Manually,Allow To Input Version Manually,Enable Publish Mail For Folder Users,Document No Format,Document No Regeneration,Document No Of Digits,Created On,Created By,Updated On,Updated By,Update Reason,Deleted By,Deleted Reason";
        this.message.whereClause_AU = " AND PARENT_FOLDER_ID = " + this.parentFolderId + " AND FOLDER_ID=" + folderOrDocument;
        this.message.columnList_Report = "Created Timestamp,End Timestamp,Action Flag,Status,Document Type Code,Folder Code,Folder Description,Folder Name,Folder Path,Is Distributed Folder,Created On,Created By,Updated On,Updated By,Update Reason,Deleted By,Deleted Reason";
        this.message.whereClause_Report = " WHERE PARENT_FOLDER_ID = " + this.parentFolderId + " AND FOLDER_ID=" + folderOrDocument;
        this.message.report_And_Popup_Name = this.rightClickData.folderName + " " + "Audit Trail";
        this.message.reportName_AU = "Sub Folder";
        this.staticAuditTrailComponent.triggerTrail(folderOrDocument);
      }
    } else {
      this.message.tableOrView_Name = "DMS_DOCUMENTS_AU_VW";
      this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,DOCUMENT_NO,DOCUMENT_NAME,VERSION,STATUS,EFFECTIVE_DATE,EXPIRATION_DATE,DOCUMENT,DOCUMENT_DESCRIPTION,CR_DETAILS,REVISION_HISTORY,DOCUMENT_TYPE_NAME,DOCUMENT_TYPE_CODE,BELONGS_TO_INDIVIDUAL,BELONGS_TO_USER,ASSOCIATED_DOCUMENT_FROM_VERSION,ASSOCIATED_DOCUMENT_NO,ASSOCIATED_DOCUMENT_TO_VERSION,ASSOCIATED_DOC_TO_FOLLOW_SAME_EXPIRY,DOCUMENT_SIZE_IN_KB,DOCUMENT_EXTN,IS_AMENDEMENT_DOC_TYPE,IS_AMENDMENT_IN_PROGRESS,IS_ASSOCIATED_DOCUMENT_TYPE,IS_EXTENSION_IN_PROGRESS,IS_WITHDRAWAL_IN_PROGRESS,NO_OF_COMPLETED_AMENDMENT,NO_OF_COMPLETED_EXTENSION,ASSIGNABLE_AT_TRAININGS,ENABLED_AT_FORMS_AND_LOGS,CREATED_BY_USER,CREATED_ON,IS_LATEST_PUBLISHED_VERSION,IS_LATEST_VERSION,PUBLISHED_BY_USER,PUBLISHED_ON,CHECKEDIN_BY_USER,CHECKEDIN_ON,CHECKEDOUT_BY_USER,CHECKEDOUT_ON,CHECKINOUT_COMMENTS,REASON_FOR_STATUS_CHANGE,CHECKOUT_FLAG,IS_BLINDED,BLINDED_BY_USER,BLINDED_ON,UNBLINDED_BY_USER,UNBLINDED_ON,UNBLIND_REASON,UPDATED_BY_USER,UPDATED_ON,UPDATE_REASON,FOLDER_NAME,IS_DISTRIBUTED_FOLDER,FOLDER_PATH,FOLDER_STATUS,LAST_ACTION_BY_USER,LAST_ACTION_COMMENTS,LAST_ACTION_ON";
      this.message.columnList_UI = "Created Ts,End Ts,Action Flag,Document No,Document Name,Version,Status,Effective Date,Expiration Date,Document,Document Description,CR Details,Revision History,Document Type Name,Document Type Code,Belongs to Individual,Belongs to User,Associated Document From Version,Associated Document No,Associated Document To Version,Associated Doc to Follow Same Expiry,Document Size in KB,Document Extn,Is Amendment Doc Type,Is Amendment in Progress,Is Associated Document Type,Is Extension in Progress,Is Withdrawal in Progress,No of Completed Amendment,No of Completed Extension,Assignable at Trainings,Enabled at Forms and Logs,Created by User,Created on,Is Latest Published Version,Is Latest Version,Published by User,Published on,Checkedin by User,Checkedin on,Checkedout by User,Checkedout on,Checkinout Comments,Reason for Status Change,Checkout Flag,Is Blinded,Blinded by User,Blinded on,Unblinded by User,Unblinded on,Unblind Reason,Updated by User,Updated on,Update Reason,Folder Name,Is Distributed Folder,Folder Path,Folder Status,Last Action by User,Last Action Comments,Last Action on";
      this.message.whereClause_AU = " AND DOCUMENT_ID = " + this.rightClickData['documentId'] + " AND VERSION=" + folderOrDocument['version'];
      this.message.columnList_Report = "Created Ts,End Ts,Action Flag,Document No,Document Name,Version,Status,Effective Date,Expiration Date,Document,Document Description,CR Details,Revision History,Document Type Name,Document Type Code,Belongs to Individual,Belongs to User,Associated Document From Version,Associated Document No,Associated Document To Version,Associated Doc to Follow Same Expiry,Document Size in KB,Document Extn,Is Amendment Doc Type,Is Amendment in Progress,Is Associated Document Type,Is Extension in Progress,Is Withdrawal in Progress,No of Completed Amendment,No of Completed Extension,Assignable at Trainings,Enabled at Forms and Logs,Created by User,Created on,Is Latest Published Version,Is Latest Version,Published by User,Published on,Checkedin by User,Checkedin on,Checkedout by User,Checkedout on,Checkinout Comments,Reason for Status Change,Checkout Flag,Is Blinded,Blinded by User,Blinded on,Unblinded by User,Unblinded on,Unblind Reason,Updated by User,Updated on,Update Reason,Folder Name,Is Distributed Folder,Folder Path,Folder Status,Last Action by User,Last Action Comments,Last Action on";
      this.message.whereClause_Report = " WHERE DOCUMENT_ID = " + this.rightClickData['documentId'] + " AND VERSION=" + folderOrDocument['version'];
      this.message.report_And_Popup_Name = 'Document Audit Trail';
      this.message.reportName_AU = "Document";
      this.message.manualEntryDataFields =
        "EFFECTIVE_DATE" + "," +
        "EXPIRATION_DATE";
      this.staticAuditTrailComponent.triggerTrail(folderOrDocument);
    }
  }

  pagerForPopup: any = {};
  setPageForPopup(page: number, targetpage: number, list: any) {
    if (page < 1 || page > this.pagerForPopup.totalPages) {
      return;
    }
    if (Number.isNaN(page)) {
      page = 1;
    }

    this.pagerForPopup = this.paginationService.getPager(list.length, page, this.perPage, targetpage);
    this.pagedItemsForPopup = list.slice(this.pagerForPopup.startIndex, this.pagerForPopup.endIndex + 1);
  }

  paginationCall1(value: number, list: any) {
    this.perPage = value;
    this.setPageForPopup(this.pagerForPopup.currentPage, 0, list);
  }

  pagedItemsForPopup: any = [];
  applyFilter3(column: string, event: Event, list: any): void {
    if (column == "Group") { column = "groupName" }
    if (column == "Assigned By") { column = "assignedByName" }
    if (column == "Assigned On") { column = "assignedOn" }
    if (column == "Priviledge Type") { column = "priviledgeType" }
    if (column == "User or Role") { column = "userOrRoleName" }
    if (column == "Template Name") { column = "templateName" }
    if (column == "Template Extn") { column = "templateExtn" }
    if (column == "Group Name") { column = "groupName" }
    const filter = (event.target as HTMLInputElement).value.trim().toLowerCase();

    if (filter === '') {
      this.pagedItemsForPopup = list.slice(this.pager.startIndex, this.pager.endIndex + 1);
    } else {
      this.pagedItemsForPopup = list.filter((item: any) =>
        item[column]?.toLowerCase().includes(filter)

      );
    }
  }

  validateVersion(event: any) {
    if (event.key === 'e' || event.key === 'E' || event.key === '+' || event.key === '-') {
      event.preventDefault();
    }
  }

  downloadDoc(doc: any, event: any) {
    event.preventDefault();
    this.selectedTemplateData = doc;
    this.downloadType = "single";
    this.selectedTemplateData.module = "History";
    if (!this.selectedTemplateData.folderId && this.rightClickData) {
      this.selectedTemplateData.folderId = this.rightClickData.folderId;
    }

    this.reason = "";
    this.visibleDownloadTemplatePopup = this.dialog.open(this.downloadTemplatePopup, this.downloadTemplatePopupConfig);
  }
  selectBoxeForVersion() {
    this.versionValueDropdown = [];
    for (let i = 0; i < this.versionValueDropdown1.length; i++) {
      this.versionValueDropdown = this.versionValueDropdown.concat({
        valueExp: this.versionValueDropdown1[i].version,
        displayExp: this.versionValueDropdown1[i].version
      });
    }
    this.selectedVersionValue = this.rightClickData.version;
  }
  onVersionSelect(event: any, item: any) {
    if (event.isUserInput) {
      this.flexiFieldsList = [];
      this.isProcessing = true;
      this.appService.getDocumentByDocumentId(
        this.rightClickData.documentId, item.valueExp).subscribe((data: any) => {
          this.documentData = data[0];
          this.documentData['saveButtonForDocument'] = false;
          this.documentData['module'] = "DOCS";
          this.callForFlexifields();
          this.documentData.isBlinded = this.documentData.isBlinded == "Y" ? true : false;
          if (this.documentData.effectiveDate != null) {
            this.documentData.effectiveDate = new Date(this.documentData.effectiveDate);
          }
          if (this.documentData.expirationDate != null) {
            this.documentData.expirationDate = new Date(this.documentData.expirationDate);
          }
          this.isProcessing = false;
          //this.visibleDocumentPropertiesPopup = this.dialog.open(this.documentPropertiesPopup, this.documentPropertiesPopupConfig);
          this.callForFlexifields();
          this.appService.getTaskStages(this.documentData['documentId'], item.valueExp)
            .subscribe((data: any) => {
              this.taskStagesList = data;
              this.isProcessing = false;
            })


          this.isProcessing = true;
          this.appService.getAssociatedDocumentsDetail(
            this.documentData['documentId'], item.valueExp).subscribe((data: any) => {
              this.isProcessing = false;
              this.associatedDocumentsList = data;
              this.associatedDocumentListForCheckout = [];
              for (let k = 0; k < this.associatedDocumentsList.length; k++) {
                if (this.documentTypeListOfAssosciatedDocs.indexOf(this.associatedDocumentsList[k].documentTypeName) == -1) {
                  this.documentTypeListOfAssosciatedDocs.push(this.associatedDocumentsList[k].documentTypeName);
                }
                for (let m = 0; m < this.dropDownFordocumentTypeList.length; m++) {
                  if (this.associatedDocumentsList[k].documentTypeName == this.dropDownFordocumentTypeList[m].documentTypeName) {
                    if (this.dropDownFordocumentTypeList[m].isAmendementDocType != "Y") {
                      this.associatedDocumentListForCheckout.push(this.associatedDocumentsList[k]);
                    }
                  }
                }
              }
              for (let l = 0; l < this.documentTypeListOfAssosciatedDocs.length; l++) {
                const list = [];
                const key = this.documentTypeListOfAssosciatedDocs[l];
                for (let j = 0; j < this.associatedDocumentsList.length; j++) {
                  if (this.associatedDocumentsList[j].documentTypeName == this.documentTypeListOfAssosciatedDocs[l]) {
                    list.push(this.associatedDocumentsList[j]);
                  }
                }
                this.documentsByDocTypeList[key] = list;
              }
            })

        })
      // })
    }
  }
  selectAllTemplate(e: any) {
    this.searchTemplateParentCheckBox = e.target.checked;
    this.multiTemplateArray = [];

    if (e.target.checked) {
      // Select All: Check every item and add to array
      this.templateList.forEach((template: any) => {
        template.searchTemplateChildCheckBox = true;

        // Push to array
        this.multiTemplateArray.push({
          templateId: template.templateId,
          templateName: template.templateName,
          template: template.template,
          templateExtn: template.templateExtn,
          folderId: template.folderId
        });
      });
    } else {
      // Unselect All: Uncheck every item and clear array
      this.templateList.forEach((template: any) => {
        template.searchTemplateChildCheckBox = false;
      });
      this.multiTemplateArray = [];
    }
  }


  onChildCheckBoxChanged(e: any, listOfTemplateData: any, idx: any) {
    listOfTemplateData.searchTemplateChildCheckBox = e.target.checked;

    if (e.target.checked) {
      if (!this.multiTemplateArray.some((storedTemplate: any) => storedTemplate.templateId === listOfTemplateData.templateId)) {
        this.multiTemplateArray.push({
          templateId: listOfTemplateData.templateId,
          templateName: listOfTemplateData.templateName,
          template: listOfTemplateData.template,
          templateExtn: listOfTemplateData.templateExtn,
          folderId: listOfTemplateData.folderId
        });
      }
    } else {
      this.multiTemplateArray = this.multiTemplateArray.filter((item: any) => item.templateId !== listOfTemplateData.templateId);
    }
    const allSelected = this.templateList.length > 0 && this.templateList.every((item: any) => item.searchTemplateChildCheckBox === true);
    this.searchTemplateParentCheckBox = allSelected;
  }

  bulkDownloadTemplates() {
    this.downloadType = "bulk";
    this.visibleTemplatePopup.close();
    this.bulkselectedTemplateData = this.templateList[0];
    this.reason = "";
    this.visibleDownloadTemplatePopup = this.dialog.open(this.downloadTemplatePopup, this.downloadTemplatePopupConfig);
  }

  bulkDownloadTemplateForFolder() {
    if (!this.validateDownloadReason()) {
      return;
    }

    if (this.multiTemplateArray.length > 15) {
      alert("You cannot select more than 15 template.");
    } else {
      for (let i = 0; i < this.multiTemplateArray.length; i++) {
        let object = {
          documentId: this.multiTemplateArray[i].templateId,
          version: 0,
          folderId: this.rightClickData.folderId,
          issuanceType: "Download Template",
          associatedDocuments: "N",
          publisherDetails: null,
          comments: this.reason,
          issuanceId: null,
          templateId: this.multiTemplateArray[i].templateId,
          otherDetails: this.multiTemplateArray[i].templateName,
          downloadedFileName: this.multiTemplateArray[i].templateName
        }

        this.appService.downloadDocumentTemplate(object).subscribe(
          (response: any) => {
            let contentData = "data:application/octet-stream;base64," + this.multiTemplateArray[i].template;
            let downloadLink = document.createElement("a");
            downloadLink.href = contentData;
            downloadLink.download = this.multiTemplateArray[i].templateName + "." + this.multiTemplateArray[i].templateExtn;
            downloadLink.click();
          })
      }
      this.visibleDownloadTemplatePopup.close();
    }
  }

  validateDownloadReason() {
    const reasonInput = document.getElementById('deleteReason') as HTMLInputElement;
    const reasonMsg = document.getElementById('deleteReason-required-msg') as HTMLInputElement;

    if (this.reason == "" || this.reason == null || this.reason.trim() == "") {
      if (reasonInput) reasonInput.style.border = '1px solid red';
      if (reasonMsg) reasonMsg.style.display = 'block';
      return false;
    } else {
      if (reasonInput) reasonInput.style.border = '';
      if (reasonMsg) reasonMsg.style.display = 'none';
      return true;
    }
  }

  clearTemplateSelections() {
    this.multiTemplateArray = [];
    this.searchTemplateParentCheckBox = false;
    if (this.templateList && this.templateList.length > 0) {
      this.templateList.forEach((template: any) => {
        template.searchTemplateChildCheckBox = false;
      });
    }
  }

  cancelViewRelatedTrainingsFunction() {
    if (this.visibleViewRelatedTrainingsPopup) {
      this.visibleViewRelatedTrainingsPopup.close();
    }
  }
  async openBulkActionPopup(actionType: string) {
    this.bulkActionType = actionType;
    this.bulkReason = "";
    this.bulkParentCheckbox = false;
    this.bulkDocumentList = [];
    this.bulkValidDocumentListMaster = [];
    this.bulkDocumentTypeDropdown = [];

    this.bulkEffectiveDate = new Date();
    this.bulkExpirationDate = null;
    this.bulkSelectedDocType = null;

    this.isBulkExpApplicable = true;
    this.isBulkEffEditable = true;
    this.isBulkExpEditable = true;

    // Grab all documents currently in the grid
    const allDocs = this.folderDocListForDataGrid.filter((item: any) => item.type === 'Document');

    if (actionType === 'Publish') {
      // --- BULK PUBLISH: Fast Load (Extract Doc Types only) ---
      const uniqueTypes = new Map();

      for (const doc of allDocs) {
        if (doc.documentTypeCode && doc.documentTypeName) {
          if (!uniqueTypes.has(doc.documentTypeCode)) {
            uniqueTypes.set(doc.documentTypeCode, doc.documentTypeName);

            // Push to dropdown list
            this.bulkDocumentTypeDropdown.push({
              valueExp: doc.documentTypeCode,
              displayExp: doc.documentTypeName
            });
          }
        }
      }

      // Save allDocs to the master list to filter later when a type is selected
      this.bulkValidDocumentListMaster = allDocs;

      // Leave the table empty until a type is chosen
      this.bulkDocumentList = [];

      // Open popup instantly without waiting for API calls
      this.visibleBulkActionPopup = this.dialog.open(this.bulkActionPopupTemplate, {
        width: '800px', height: 'auto', panelClass: 'my-dialog', hasBackdrop: true, disableClose: true, position: { top: '30px' }
      });

    } else {
      // --- BULK CHECKIN: Keep old behavior (Check all docs upfront) ---
      this.isProcessing = true;
      try {
        let validDocs: any[] = [];
        for (const doc of allDocs) {
          const btnObj = {

            documentId: doc.documentId,
            version: doc.version,
            folderId: doc.folderId || this.parentFolderId,
            status: doc.status,
            pageName: 'DOCUMENT'
          };

          const btnData: any = await firstValueFrom(this.appService.getDocumentButtonLabels(btnObj));

          if (btnData && btnData.buttonLabels) {
            const availableButtons = btnData.buttonLabels.split(",");
            if (availableButtons.includes(actionType)) {
              doc.selected = false;
              validDocs.push(doc);
            }
          }
        }
        this.bulkValidDocumentListMaster = validDocs;
        this.bulkDocumentList = [...this.bulkValidDocumentListMaster];

      } catch (error) {
        console.error("Error fetching button labels for bulk action:", error);
        this.showSnackBar("Error verifying document actions. Please try again.", "E");
        this.isProcessing = false;
        return;
      }
      this.isProcessing = false;

      this.visibleBulkActionPopup = this.dialog.open(this.bulkActionPopupTemplate, {
        width: '800px', height: 'auto', panelClass: 'my-dialog', hasBackdrop: true, disableClose: true, position: { top: '30px' }
      });
    }
  }
  cancelBulkActionPopup() {
    if (this.visibleBulkActionPopup) {
      this.visibleBulkActionPopup.close();
    }
  }

  toggleBulkParentCheckbox(e: any) {
    this.bulkParentCheckbox = e.target.checked;
    this.bulkDocumentList.forEach((doc: any) => {
      doc.selected = this.bulkParentCheckbox;
    });
  }

  async executeBulkAction() {
    const selectedDocs = this.bulkDocumentList.filter(doc => doc.selected);

    if (selectedDocs.length === 0) {
      this.showSnackBar("Please select at least one document.", "E");
      return;
    }

    const reasonEl = document.getElementById('bulkReason') as HTMLInputElement;
    const reasonRequiredMsg = document.getElementById('bulkReason-required-msg');
    if (this.bulkActionType === 'CheckIn' || this.bulkActionType === 'Self Lock') {

      if (!this.bulkReason || this.bulkReason.trim() === '') {
        if (reasonEl) reasonEl.style.border = '1px solid red';
        if (reasonRequiredMsg) reasonRequiredMsg.style.display = 'block';
        return;
      } else {
        if (reasonEl) reasonEl.style.border = 'none';
        if (reasonRequiredMsg) reasonRequiredMsg.style.display = 'none';
      }
    }
    if (this.bulkActionType === 'Publish') {
      const effDateEl = document.getElementById('bulkEffectiveDate') as HTMLInputElement;
      const effDateReqMsg = document.getElementById('bulkEffectiveDate-required-msg');

      if (this.bulkEffectiveDate) {
        if (effDateEl) effDateEl.style.border = 'none';
        if (effDateReqMsg) effDateReqMsg.style.display = 'none';
      } else {
        if (effDateEl) effDateEl.style.border = '1px solid red';
        if (effDateReqMsg) effDateReqMsg.style.display = 'block';
        return;
      }
    }

    this.isProcessing = true;
    this.bulkActionResults = [];

    for (const doc of selectedDocs) {
      let resultObj = {
        documentName: doc.documentName,
        documentNo: doc.documentNo,
        status: '',
        isSuccess: false
      };

      try {
        let response: any = await this.processSingleBulkActionAsync(doc);
        // UPDATE: Make the success message dynamic
        let actionText = this.bulkActionType === 'CheckIn' ? 'Checked In' :
          this.bulkActionType === 'Self Lock' ? 'Self Locked' : 'Published';
        resultObj.status = response.result || `Successfully ${actionText}`;
        resultObj.isSuccess = true;
      } catch (error: any) {
        console.error(`Failed to process document ${doc.documentNo}:`, error);
        resultObj.status = error.result || 'Failed to process document';
        resultObj.isSuccess = false;
      }

      this.bulkActionResults.push(resultObj);
    }

    this.isProcessing = false;
    this.cancelBulkActionPopup();

    this.visibleBulkResultPopup = this.dialog.open(this.bulkResultPopupTemplate, {
      width: '800px', height: '70%', panelClass: 'my-dialog', hasBackdrop: true, disableClose: true, position: { top: '30px' }
    });

    this.getCall();
  }
  closeBulkResultPopup() {
    if (this.visibleBulkResultPopup) {
      this.visibleBulkResultPopup.close();
    }
  }

  processSingleBulkActionAsync(docData: any): Promise<any> {
    return new Promise((resolve, reject) => {

      let effDateToPass = docData.effectiveDate;
      let expDateToPass = docData.expirationDate;

      if (this.bulkActionType === 'Publish') {
        // Always pass the effective date if selected
        effDateToPass = this.bulkEffectiveDate ? this.appService.dateZoneConvertion(new Date(this.bulkEffectiveDate)) : null;

        // 1. Find the document type configuration for THIS specific document
        let isExpiryApp = false;
        if (this.dropDownFordocumentTypeList && this.dropDownFordocumentTypeList.length > 0) {
          for (let i = 0; i < this.dropDownFordocumentTypeList.length; i++) {
            if (this.dropDownFordocumentTypeList[i].documentTypeCode === docData.documentTypeCode) {
              if (this.dropDownFordocumentTypeList[i].isExpiryApplicable === "Y") {
                isExpiryApp = true;
              }
              break;
            }
          }
        }

        // 2. Only map the expiration date if the config allows it
        if (isExpiryApp) {
          expDateToPass = this.bulkExpirationDate ? this.appService.dateZoneConvertion(new Date(this.bulkExpirationDate)) : null;
        } else {
          // Force null if this document type doesn't support expiration dates
          expDateToPass = null;
        }
      }

      let payload = {
        documentId: docData.documentId,
        version: docData.version,
        currentStatus: docData.status,
        stageName: null,
        buttonValue: this.bulkActionType,
        actionStatus: null,
        crNo: null,
        comments: this.bulkReason,
        rejectReason: null,
        reasonForSignature: null,
        fileExtn: null,
        effectiveDate: effDateToPass,
        expirationDate: expDateToPass
      };

      const formData = new FormData();
      const emptyfile: File | null = null;
      if (emptyfile) {
        formData.append('file', emptyfile);
      }
      formData.append('object', new Blob([JSON.stringify(payload)], { type: 'application/json' }));

      this.appService.performButtonOperationForDocument(formData).subscribe({
        next: (Response: any) => {
          if (Response.resultType == "S") {
            resolve(Response);
          } else {
            reject(Response);
          }
        },
        error: (err) => {
          reject(err);
        }
      });
    });
  }

  toggleBulkChildCheckbox(e: any, doc: any) {
    doc.selected = e.target.checked;
    this.bulkParentCheckbox = this.bulkDocumentList.every((item: any) => item.selected);
  }
  async onBulkDocTypeChange(docTypeCode: any) {
    this.bulkSelectedDocType = docTypeCode;

    if (!docTypeCode) {
      this.bulkDocumentList = [];
      return;
    }

    this.isProcessing = true; // Show loading spinner inside the popup

    try {
      // 1. Filter the master list to ONLY get documents matching the selected Type
      const docsOfSelectedType = this.bulkValidDocumentListMaster.filter(
        (doc: any) => doc.documentTypeCode === docTypeCode
      );

      let validDocs: any[] = [];

      // 2. Iterate and check 'Publish' button availability ONLY for these specific documents
      for (const doc of docsOfSelectedType) {
        const btnObj = {

          documentId: doc.documentId,
          version: doc.version,
          folderId: doc.folderId || this.parentFolderId,
          status: doc.status,
          pageName: 'DOCUMENT'
        };

        const btnData: any = await firstValueFrom(this.appService.getDocumentButtonLabels(btnObj));

        if (btnData && btnData.buttonLabels) {
          const availableButtons = btnData.buttonLabels.split(",");
          if (availableButtons.includes('Publish')) {
            doc.selected = false; // Initialize checkbox state
            validDocs.push(doc);
          }
        }
      }

      // Assign the verified documents to the grid
      this.bulkDocumentList = validDocs;
      this.bulkParentCheckbox = false;

      // 3. Apply Expiry and Effective Date Rules
      const docTypeData = this.dropDownFordocumentTypeList.find(
        (x: any) => x.documentTypeCode === docTypeCode
      );

      if (docTypeData) {
        this.isBulkExpApplicable = docTypeData.isExpiryApplicable === 'Y';

        // Disable/Override rules
        this.isBulkEffEditable = docTypeData.overrideEffectiveDate === 'Y';
        this.isBulkExpEditable = docTypeData.overrideExpiryDate === 'Y';

        // Auto-fetch values
        this.bulkEffectiveDate = new Date();

        if (this.isBulkExpApplicable) {
          this.calculateBulkExpValue(this.bulkEffectiveDate, docTypeData);
        } else {
          this.bulkExpirationDate = null;
        }
      }

    } catch (error) {
      console.error("Error verifying Publish status:", error);
      this.showSnackBar("Error verifying document actions.", "E");
    }

    this.isProcessing = false; // Hide loading spinner
  } calculateBulkExpValue(date: Date, typeData: any) {
    if (typeData && typeData.expiryInUnit != null && date != null) {
      let expDate = new Date(date);
      if (typeData.expiryInUnit === "Days") {
        expDate.setDate(date.getDate() + typeData.expiryIn);
      } else if (typeData.expiryInUnit === "Month") {
        expDate.setMonth(date.getMonth() + typeData.expiryIn);
      } else {
        expDate.setFullYear(date.getFullYear() + typeData.expiryIn);
      }
      this.bulkExpirationDate = expDate;
    }
  }

  onBulkEffectiveDateChange(newDate: Date) {
    if (this.bulkSelectedDocType && this.isBulkExpApplicable && !this.isBulkExpEditable) {
      let docTypeData = this.dropDownFordocumentTypeList.find((x: any) => x.documentTypeCode === this.bulkSelectedDocType);
      this.calculateBulkExpValue(newDate, docTypeData);
    }
  }

  reportObj: any = {};
  manuallyPicked: boolean;
  pdfSearchText: string = '';
  maxCountReached: boolean = false;
  selectedColumnsAsString: string = "";
  pdfPageSizes: any = [];
  selectedColumns: any;
  dropDownForPdfColumn: any;
  excelPdf: any = {};
  isForExcel: boolean = false;
  @ViewChild('excelPdfPopup1', { static: true }) excelPdfPopup1: TemplateRef<any>;

  excelPdfPopupConfig = {
    width: '600px',
    height: 'auto',
    panelClass: 'my-dialog',
    disableClose: true,
    hasBackdrop: true,
    position: { top: '10px' },
  }
  visibleExcelPdfPopup: MatDialogRef<TemplateRef<any>>;
  isSaveReport: boolean = false;
  reportName: any;
  tabName = "Folder Group Privilege";
  openReportProperties(reportType: string) {
    this.pdfPageSizes = JSON.parse(sessionStorage.getItem('pdfPageSizes') ?? '{}');
    this.excelPdf.pdfPageSize = 'A4';
    this.popupDataTitle.title = 'Excel Report';
    [this.manuallyPicked, this.maxCountReached, this.selectedColumns] = [false, false, []];
    const firstst = this.message.breadcrumbData.firstLevel;
    const secondnd = this.message.breadcrumbData.secondLevel;
    const thirdL = this.message.breadcrumbData.thirdLevel;
    const fourthL = this.message.breadcrumbData.fourthLevel;
    let fileName = "";
    if (firstst != null) {
      fileName = firstst + "_";
    }
    if (secondnd != null) {
      fileName = fileName + secondnd + "_";
    }
    if (thirdL != null) {
      fileName = fileName + thirdL + "_";
    }
    if (fourthL != null) {
      fileName = fileName + fourthL + "_";
    }
    this.reportName = fileName + Date.now();
    this.visibleExcelPdfPopup = this.dialog.open(this.excelPdfPopup1, this.excelPdfPopupConfig);
    this.isSaveReport = false;



  }

  cancelReportPopup() {
    this.visibleExcelPdfPopup.close();
    this.manuallyPicked = false;
    this.selectedColumns = "";

  }


  whereValsForExcel: any;
  generateReport(value: any) {
    let invisibleList = "";

    this.appService.isProcessingRep = true;
    let tname = "";
    let colList = "";
    let fieldList = "";
    this.whereValsForExcel = "";
    if (this.tabName != "Folder User Privilege") {
      tname = "DMS_GROUP_ALL_FOLDERS_PRIV_VW";
      colList = "GROUP_NAME,PRIVILEDGE_TYPE,ASSIGNED_ON,ASSIGNED_BYNAME";
      fieldList = "Group Name,Priviledge Type,Assigned On,Assigned By";
      this.whereValsForExcel = " Where ORG_ID=" + this.message.getOrgId() + " AND FOLDER_ID=" + this.rightClickData.folderId;
    } else {
      tname = "DMS_GROUP_USERS_ALL_FOLDER_PRIV_VW";
      colList = "USER_OR_ROLE_NAME, FOLDER_ADMINISTRATOR, AUTHOR, REVIEWER, APPROVER, QA, TRAINING_COORDINATOR, PUBLISHER, BLINDED, BLINDBREAK, REDACTOR, DOWNLOADER, VIEWER, AUTHORIZER, EXTENSION_REVIEWER, EXTENSION_APPROVER, WITHDRAWAL_REVIEWER, WITHDRAWAL_APPROVER, DESTRUCTION_REVIEWER, DESTRUCTION_APPROVER, PRINTER, CURRENT_VERSION_VIEWER";
      fieldList = "User or Role, Folder Administrator, Author, Reviewer, Approver, QA, Training Coordinator, Publisher, Blinded, Blindbreak, Redactor, Downloader, Viewer, Authorizer, Extension Reviewer, Extension Approver, Withdrawal Reviewer, Withdrawal Approver, Destruction Reviewer, Destruction Approver, Printer, Current Version Viewer";
      this.whereValsForExcel = " Where ORG_ID=" + this.message.getOrgId() + " AND FOLDER_ID=" + this.rightClickData.folderId;
    }
    const data = {

    }

    const data1: any = {

      tableOrViewName: tname,
      columnsList: colList,
      fieldLabelsList: fieldList,
      invisibleColumn: invisibleList,
      orderByClause: tname == "DMS_GROUP_USERS_ALL_FOLDER_PRIV_VW" ? "USER_OR_ROLE_NAME" : "",
      fieldSizeList: "",
      columnsListarray: [],
      fieldColumnarray: [],
      invisibleColumnarray: [],
      fieldSizeListArray: [],
      status: null,
      codelistGroup: null,
      manualEntryDataFields: null,
      groupId: null,
      chartStatus: "null",
      reModule: "qms1",
      logoId: 0,
      isSaveRep: this.isSaveReport ? 'Y' : 'N',
      footer: null,
      reportName: this.reportName,
      currentStatus: "NA",
      groupName: null,
      wherVal: this.whereValsForExcel
    }


    this.reportObj = { ...data1, ...data };




    const fileName = "Report";

    const pdfData = {
      ...this.reportObj, title: "Report", columns: [],
      "informationTab": {
        "Report Name": "Report",
        "Exported By": sessionStorage.getItem("reportsUserName") ? sessionStorage.getItem("reportsUserName") : localStorage.getItem("loggedUserName")
      }
    }
    this.appService.downloadexcelForChart(pdfData, fileName + ".xlsx");
  }

  docDownload(documents: any) {
    this.isPrintDownloadMode = false;
    this.isOnlyPreviewMode = true;
    this.title = "Download";
    this.documentData = documents;
    this.selectedOptionforDownload = null;
    this.selectedOptionforDownload = null;
    this.resetDownloadData();
    this.visibleSDownloadPopup = this.dialog.open(this.downloadPopup, this.propertiesdownloadPopupConfig);
  }
  docPrint(documents: any) {
    this.isOnlyPreviewMode = false;
    this.isPrintDownloadMode = true;
    this.title = "Print";
    this.documentData = documents;
    this.selectedOptionforDownload = "Issue Document";
    this.resetDownloadData();
    this.visibleSDownloadPopup = this.dialog.open(this.downloadPopup, this.propertiesdownloadPopupConfig);
  }

  @ViewChild('viewPopup', { static: true }) viewPopup: TemplateRef<any>;
  visibleViewPopup: MatDialogRef<TemplateRef<any>>;

  viewPopupConfig = {
    width: '100%',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: false,
    disableClose: true,
    position: { top: '10px' },
  };
  viewerData: any = {};
  docView(event: any, documents: any) {
    event.preventDefault();
    this.visibleViewPopup = this.dialog.open(this.viewPopup, this.viewPopupConfig);
    this.isProcessing = true;
    this.documentData = documents;
    console.log(this.documentData, "==============");
    this.appService.getDocumentsToViewForDmsOnlyByNo(this.documentData.documentNo)
      .subscribe((response: any) => {
        console.log("header==");
        this.isProcessing = false;
        const header = response.headers.get('content-type');
        console.log("header==", header);
        let extension = "pdf";
        if (header == "application/plain") {
          extension = "log"
        } else if (header == "application/pdf") {
          extension = "pdf"
        } else if (header == "application/vnd.openxmlformats-officedocument.wordprocessingml.document") {
          extension = "docx"
        } else if (header == "application/msword") {
          extension = "doc"
        } else if (header == "application/vnd.ms-excel") {
          extension = "xls"
        } else if (header == "application/vnd.ms-excel.sheet.macroEnabled.12") {
          extension = "xlsm"
        } else if (header == "application/vnd.ms-powerpoint") {
          extension = "ppt"
        } else if (header == "application/zip") {
          extension = "zip"
        } else if (header == "text/xml") {
          extension = "xml"
        } else if (header == "video/mp4") {
          extension = "mp4"
        } else if (header == "image/x-png") {
          extension = "png"
        } else if (header == "image/jpeg") {
          extension = "jpeg"
        }

        this.viewerData = {
          body: response.body,
          contentType: header,
          extn: extension
        }
      });
  }

  cancelViewPopup() {
    this.visibleViewPopup.close();
  }

  config1: EditorConfig = {
    placeholder: '',
    buttons: [],
  };
  @ViewChild('angularEditorTextarea', { static: true }) angularEditorTextarea: TemplateRef<any>;
  visibleAngularEditor: MatDialogRef<TemplateRef<any>>;

  angularEditorTextareaConfig = {
    width: '100%',
    height: 'auto',
    hasBackdrop: true,
    disableClose: true,
    position: { top: '30px' },
  };

  editorValue: any;
  openEditor(value: string) {
    this.editorValue = value;
    this.visibleAngularEditor = this.dialog.open(this.angularEditorTextarea, this.angularEditorTextareaConfig);
  }

  cancelAngularEditorData() {
    this.visibleAngularEditor.close();
  }



  formatColumnName(column: string): string {
    return column
      .toLowerCase()
      .split('_')
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
